// ============================================================
//  CCS SHIRT BUILDER — GENERATED, DO NOT EDIT BY HAND
// ============================================================
//  Produced from sib-custom-design/frontend/public/shirt-builder/
//  shirt-builder-admin.js by rederive-ccs.js at the root of this theme.
//  Run that to pull a fix across; editing this file directly means the next
//  re-derive silently discards the edit.
//
//  The admin copy already removes the sizes step, the cart, saved designs and
//  sign-in. This transform changes only:
//    * the host bridge -> window.CCSBuilderHost (assets/ccs-builder-host.js)
//    * the primary action -> publishing a marketplace listing
//    * the labels that name it
//
//  Everything else is the SIB builder unchanged, including the selection
//  handles, the history, the panels and the export path.
//
//  Multi-color is NOT in here. A color owning its own design is a CCS-only
//  idea, so it lives in the host beside the builder rather than being
//  transformed into it -- which keeps this file re-derivable.
// ============================================================

// ============================================================
//  ADMIN SHIRT BUILDER — GENERATED, DO NOT EDIT BY HAND
// ============================================================
//  Produced from sib-shopify/assets/shirt-builder.js by rederive.js in
//  this folder. Run that to pull a storefront fix across; editing this
//  file directly means the next re-derive silently discards the edit.
//
//  What the transform changes, and why:
//    * No rollout flag. The storefront copy hides behind a localStorage
//      opt-in for its live rollout; this one is behind an admin login.
//    * Logging is switched off at its four entry points rather than cut
//      out, so this file still diffs cleanly against its source.
//    * No cart, no sizes step, no saved designs, no sign-in. The primary
//      action generates a PROOF: it duplicates the website proof and
//      replaces its images with composited renders.
//    * The host bridge is window.SBAdminHost, supplied by the proofs page.
// ============================================================

(function(){
  'use strict';

  // ============================================================
  // CONFIG
  // ============================================================

  // fabric.js is vendored in this theme but weighs ~900KB, so it is
  // fetched on the first open rather than on every product page.
  var builderRoot = document.getElementById('sb-ov');
  var FABRIC_URL = builderRoot ? builderRoot.getAttribute('data-fabric-url') : '';

  // Every object lives in a fixed 1000-unit-wide design space, and the
  // canvas is zoomed to whatever the screen can give it. That keeps a
  // saved scene resolution-independent: reopening on a phone, a laptop
  // or after a window resize replays identical geometry, and the export
  // does not have to reason about display size at all.
  var DESIGN_W = 1000;

  // How wide a newly added element starts, as a percentage of the garment
  // photo's width. This is all that survives of the legacy per-product
  // bounds metafield, which the builder no longer reads at all.
  //
  // The offsets were why "centre" was not the middle of the shirt: the
  // default carried x:3, so every centre — the guide, the Center button and
  // the drag snap — sat 3% of the garment width to the RIGHT of the collar.
  // The garment photos are centred, so the middle of the image is the
  // middle of the shirt, and that is what centring now means.
  var DROP_W_PCT = 35;
  // Standard print area proportion (about 12" x 15.3"). Only used to fit
  // tall artwork sensibly inside the default drop area.
  var PRINT_RATIO = 1.2727;

  // Long edge of the exported artwork PNG, in pixels. 2400px covers a
  // full-front print at ~200dpi, which is what the proof team works from.
  var EXPORT_LONG_EDGE = 2400;

  var ALLOWED_TYPES = ['image/png','image/jpeg','image/svg+xml'];
  var MAX_BYTES = 25 * 1024 * 1024;

  // ── Font library ───────────────────────────────────────────────────
  // Google Fonts, fetched at runtime. `starter: true` marks the short list
  // shown inline in the text panel; the rest live behind "More fonts".
  // `google` is the css2 family parameter, null for faces already on the
  // page or present on every system.
  //
  // Grouped by the job the type does on a shirt, because that is how
  // someone picks one — nobody browses apparel type alphabetically.
  var FONTS = [
    // Starter set: the dozen that cover most shirt jobs.
    { label:'Inter Tight',      css:'"Inter Tight", system-ui, sans-serif',  google:null,               starter:true },
    { label:'Anton',            css:'Anton, Impact, sans-serif',             google:'Anton',            starter:true },
    { label:'Bebas Neue',       css:'"Bebas Neue", Impact, sans-serif',      google:'Bebas+Neue',       starter:true },
    { label:'Oswald',           css:'Oswald, "Arial Narrow", sans-serif',    google:'Oswald',           starter:true },
    { label:'Montserrat',       css:'Montserrat, Arial, sans-serif',         google:'Montserrat',       starter:true },
    { label:'Playfair Display', css:'"Playfair Display", Georgia, serif',    google:'Playfair+Display', starter:true },
    { label:'Lobster',          css:'Lobster, cursive',                      google:'Lobster',          starter:true },
    { label:'Pacifico',         css:'Pacifico, cursive',                     google:'Pacifico',         starter:true },
    { label:'Permanent Marker', css:'"Permanent Marker", cursive',           google:'Permanent+Marker', starter:true },
    { label:'Bangers',          css:'Bangers, Impact, cursive',              google:'Bangers',          starter:true },
    { label:'Righteous',        css:'Righteous, Verdana, sans-serif',        google:'Righteous',        starter:true },
    { label:'Courier',          css:'"Courier New", Courier, monospace',     google:null,               starter:true },

    // Display / poster
    { label:'Archivo Black',    css:'"Archivo Black", Impact, sans-serif',   google:'Archivo+Black' },
    { label:'Alfa Slab One',    css:'"Alfa Slab One", serif',                google:'Alfa+Slab+One' },
    { label:'Titan One',        css:'"Titan One", cursive',                  google:'Titan+One' },
    { label:'Bungee',           css:'Bungee, sans-serif',                    google:'Bungee' },
    { label:'Bungee Shade',     css:'"Bungee Shade", sans-serif',            google:'Bungee+Shade' },
    { label:'Staatliches',      css:'Staatliches, Impact, sans-serif',       google:'Staatliches' },
    { label:'Russo One',        css:'"Russo One", sans-serif',               google:'Russo+One' },
    { label:'Teko',             css:'Teko, "Arial Narrow", sans-serif',      google:'Teko' },
    { label:'Ultra',            css:'Ultra, serif',                          google:'Ultra' },
    { label:'Passion One',      css:'"Passion One", sans-serif',             google:'Passion+One' },
    { label:'Squada One',       css:'"Squada One", sans-serif',              google:'Squada+One' },
    { label:'Fjalla One',       css:'"Fjalla One", sans-serif',              google:'Fjalla+One' },
    { label:'Rowdies',          css:'Rowdies, cursive',                      google:'Rowdies' },
    { label:'Luckiest Guy',     css:'"Luckiest Guy", cursive',               google:'Luckiest+Guy' },
    { label:'Chewy',            css:'Chewy, cursive',                        google:'Chewy' },
    { label:'Fredoka',          css:'Fredoka, sans-serif',                   google:'Fredoka' },
    { label:'Black Ops One',    css:'"Black Ops One", cursive',              google:'Black+Ops+One' },
    { label:'Bowlby One SC',    css:'"Bowlby One SC", cursive',              google:'Bowlby+One+SC' },
    { label:'Shrikhand',        css:'Shrikhand, cursive',                    google:'Shrikhand' },
    { label:'Rampart One',      css:'"Rampart One", cursive',                google:'Rampart+One' },

    // Retro / novelty
    { label:'Monoton',          css:'Monoton, cursive',                      google:'Monoton' },
    { label:'Audiowide',        css:'Audiowide, cursive',                    google:'Audiowide' },
    { label:'Orbitron',         css:'Orbitron, sans-serif',                  google:'Orbitron' },
    { label:'Press Start 2P',   css:'"Press Start 2P", cursive',             google:'Press+Start+2P' },
    { label:'Faster One',       css:'"Faster One", cursive',                 google:'Faster+One' },
    { label:'Wallpoet',         css:'Wallpoet, cursive',                     google:'Wallpoet' },
    { label:'Creepster',        css:'Creepster, cursive',                    google:'Creepster' },
    { label:'Nosifer',          css:'Nosifer, cursive',                      google:'Nosifer' },
    { label:'Eater',            css:'Eater, cursive',                        google:'Eater' },
    { label:'Special Elite',    css:'"Special Elite", cursive',              google:'Special+Elite' },
    { label:'Silkscreen',       css:'Silkscreen, cursive',                   google:'Silkscreen' },

    // Blackletter / collegiate
    { label:'UnifrakturMaguntia', css:'UnifrakturMaguntia, cursive',         google:'UnifrakturMaguntia' },
    { label:'Pirata One',       css:'"Pirata One", cursive',                 google:'Pirata+One' },
    { label:'Metal Mania',      css:'"Metal Mania", cursive',                google:'Metal+Mania' },
    { label:'New Rocker',       css:'"New Rocker", cursive',                 google:'New+Rocker' },
    { label:'Cinzel',           css:'Cinzel, serif',                         google:'Cinzel' },

    // Script / handwriting
    { label:'Dancing Script',   css:'"Dancing Script", cursive',             google:'Dancing+Script' },
    { label:'Great Vibes',      css:'"Great Vibes", cursive',                google:'Great+Vibes' },
    { label:'Satisfy',          css:'Satisfy, cursive',                      google:'Satisfy' },
    { label:'Kaushan Script',   css:'"Kaushan Script", cursive',             google:'Kaushan+Script' },
    { label:'Sacramento',       css:'Sacramento, cursive',                   google:'Sacramento' },
    { label:'Allura',           css:'Allura, cursive',                       google:'Allura' },
    { label:'Parisienne',       css:'Parisienne, cursive',                   google:'Parisienne' },
    { label:'Yellowtail',       css:'Yellowtail, cursive',                   google:'Yellowtail' },
    { label:'Courgette',        css:'Courgette, cursive',                    google:'Courgette' },
    { label:'Cookie',           css:'Cookie, cursive',                       google:'Cookie' },
    { label:'Marck Script',     css:'"Marck Script", cursive',               google:'Marck+Script' },
    { label:'Caveat',           css:'Caveat, cursive',                       google:'Caveat' },
    { label:'Shadows Into Light', css:'"Shadows Into Light", cursive',       google:'Shadows+Into+Light' },
    { label:'Indie Flower',     css:'"Indie Flower", cursive',               google:'Indie+Flower' },
    { label:'Amatic SC',        css:'"Amatic SC", cursive',                  google:'Amatic+SC' },
    { label:'Rock Salt',        css:'"Rock Salt", cursive',                  google:'Rock+Salt' },
    { label:'Gloria Hallelujah', css:'"Gloria Hallelujah", cursive',         google:'Gloria+Hallelujah' },
    { label:'Architects Daughter', css:'"Architects Daughter", cursive',     google:'Architects+Daughter' },
    { label:'Patrick Hand',     css:'"Patrick Hand", cursive',               google:'Patrick+Hand' },
    { label:'Nanum Pen Script', css:'"Nanum Pen Script", cursive',           google:'Nanum+Pen+Script' },
    { label:'Homemade Apple',   css:'"Homemade Apple", cursive',             google:'Homemade+Apple' },

    // Serif
    { label:'Abril Fatface',    css:'"Abril Fatface", serif',                google:'Abril+Fatface' },
    { label:'Merriweather',     css:'Merriweather, Georgia, serif',          google:'Merriweather' },
    { label:'Lora',             css:'Lora, Georgia, serif',                  google:'Lora' },
    { label:'Bitter',           css:'Bitter, Georgia, serif',                google:'Bitter' },
    { label:'Libre Baskerville', css:'"Libre Baskerville", serif',           google:'Libre+Baskerville' },
    { label:'PT Serif',         css:'"PT Serif", Georgia, serif',            google:'PT+Serif' },
    { label:'Crimson Text',     css:'"Crimson Text", Georgia, serif',        google:'Crimson+Text' },
    { label:'Vollkorn',         css:'Vollkorn, Georgia, serif',              google:'Vollkorn' },
    { label:'Rokkitt',          css:'Rokkitt, serif',                        google:'Rokkitt' },
    { label:'Zilla Slab',       css:'"Zilla Slab", serif',                   google:'Zilla+Slab' },
    { label:'Cormorant Garamond', css:'"Cormorant Garamond", serif',         google:'Cormorant+Garamond' },

    // Sans
    { label:'Poppins',          css:'Poppins, Arial, sans-serif',            google:'Poppins' },
    { label:'Raleway',          css:'Raleway, Arial, sans-serif',            google:'Raleway' },
    { label:'Nunito',           css:'Nunito, Arial, sans-serif',             google:'Nunito' },
    { label:'Rubik',            css:'Rubik, Arial, sans-serif',              google:'Rubik' },
    { label:'Work Sans',        css:'"Work Sans", Arial, sans-serif',        google:'Work+Sans' },
    { label:'Josefin Sans',     css:'"Josefin Sans", Arial, sans-serif',     google:'Josefin+Sans' },
    { label:'Quicksand',        css:'Quicksand, Arial, sans-serif',          google:'Quicksand' },
    { label:'Barlow',           css:'Barlow, Arial, sans-serif',             google:'Barlow' },
    { label:'Karla',            css:'Karla, Arial, sans-serif',              google:'Karla' },
    { label:'Cabin',            css:'Cabin, Arial, sans-serif',              google:'Cabin' },
    { label:'Lato',             css:'Lato, Arial, sans-serif',               google:'Lato' },
    { label:'Archivo',          css:'Archivo, Arial, sans-serif',            google:'Archivo' }
  ];

  // Ink colors a shop can actually print, plus the two that matter most
  // on dark garments. `null` on the outline list means "no outline".
  var COLORS = [
    ['Black','#000000'], ['White','#ffffff'], ['Light Gray','#c8ccd0'], ['Gray','#6b7280'],
    ['Red','#d21c1c'], ['Maroon','#7f1d2d'], ['Orange','#ea6a10'], ['Gold','#d9a520'],
    ['Yellow','#f5d312'], ['Kelly Green','#1c9245'], ['Forest','#14532d'], ['Teal','#0f8a8a'],
    ['Light Blue','#7cc0e8'], ['Royal Blue','#1d4ed8'], ['Navy','#12224a'], ['Purple','#6d28d9'],
    ['Pink','#ec6ba5'], ['Brown','#6b4423']
  ];

  // Inks the shopper mixed themselves, in the order they first appeared,
  // shown after the stock list in both grids.
  //
  // Filled from two directions. One is the mixer: anything applied from it
  // lands here. The other is the design itself — a saved design, a cart
  // edit or an admin proof can arrive carrying colours that were mixed in
  // some earlier session, and those have to come back as swatches or the
  // shopper cannot reuse a colour already on their own shirt. Harvesting
  // covers both, so the mixer does not have to be the only way in.
  var customColors = [];

  // #abc, #aabbcc, or rgb()/rgba() as fabric sometimes reports it. Anything
  // else is not a colour this can offer as a swatch.
  function normHex(v){
    if(!v) return null;
    var t = String(v).trim().toLowerCase();
    var m = /^#([0-9a-f]{3})$/.exec(t);
    if(m) return '#' + m[1][0] + m[1][0] + m[1][1] + m[1][1] + m[1][2] + m[1][2];
    if(/^#[0-9a-f]{6}$/.test(t)) return t;
    m = /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/.exec(t);
    if(m) return rgbToHex(+m[1], +m[2], +m[3]);
    return null;
  }

  function rgbToHex(r, g, b){
    return '#' + [r, g, b].map(function(n){
      var v = clamp(Math.round(n) || 0, 0, 255).toString(16);
      return v.length < 2 ? '0' + v : v;
    }).join('');
  }

  function hexToRgb(hex){
    var h = normHex(hex) || '#000000';
    return [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)];
  }

  function isStockColor(hex){
    var h = normHex(hex);
    if(!h) return false;
    return COLORS.some(function(c){ return c[1].toLowerCase() === h; });
  }

  // Returns the normalised hex, whether or not it was already known — so
  // callers can use it as "clean this up and remember it if it is new".
  function addCustomColor(v){
    var h = normHex(v);
    if(!h || isStockColor(h)) return h;
    if(customColors.indexOf(h) < 0) customColors.push(h);
    return h;
  }

  // Every text colour already in the design, across BOTH sides — the back
  // of the shirt is as much the shopper's design as the front, and a
  // colour mixed for it has to be reachable while editing the front.
  function harvestCustomColors(){
    var before = customColors.length;
    views.forEach(function(v){
      if(!v.canvas) return;
      v.canvas.getObjects().forEach(function(o){
        if(!o || o.type !== 'sb-text') return;
        addCustomColor(o.fill);
        // Only a stroke that is actually drawn: fabric keeps the last
        // colour on an object whose width has gone to zero, and an
        // outline nobody can see is not a colour they chose.
        if(o.strokeWidth) addCustomColor(o.stroke);
      });
    });
    if(customColors.length !== before) renderAllSwatches();
  }

  // ============================================================
  // TINY HELPERS
  // ============================================================
  function $(id){ return document.getElementById(id); }
  function on(el, ev, fn){ if(el) el.addEventListener(ev, fn); }
  function esc(s){
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
    });
  }
  function clamp(v, lo, hi){ return Math.max(lo, Math.min(hi, v)); }
  function warn(){ try { console.warn.apply(console, arguments); } catch(e){} }

  // The modal owns the shared plumbing (presign upload, AI endpoint,
  // Recent Designs, assignments). If it is somehow absent the builder
  // must not throw on every interaction — it just refuses to open.
  // The storefront's bridge is window.CustomDesigns and the admin page's is
  // window.SBAdminHost; the CCS seller page supplies its own with the same
  // shape again. See assets/ccs-builder-host.js.
  function api(){ return window.CCSBuilderHost || null; }

  // ============================================================
  // USAGE LOGGING
  // ============================================================
  // Everything here goes through the shared activity module, which owns
  // the tracking cookie, the batching and the endpoint. If this visitor is
  // not being tracked its log() is a no-op, so nothing below has to check.
  //
  // Two rules for anything added here:
  //   * it must never be able to break the builder — hence the try/catch
  //     around every call, and no return value anyone depends on;
  //   * it must never ship pixels. An object's `src` can be a blob: or
  //     data: URL holding the whole image; sbSrc is the canonical https
  //     address and is the only one that ever goes in a payload.
  var LOG_TEXT_MAX = 280;      // a shirt is not a novel; enough to identify
  var LOG_URL_MAX = 500;

  function logStr(v, max){
    if(v == null) return null;
    return String(v).slice(0, max || LOG_TEXT_MAX);
  }

  // Only ever an https address. A blob:/data: value means the caller
  // reached for the wrong field, and logging megabytes of base64 would
  // blow the batch size limit for every event behind it.
  function logUrl(v){
    var u = v == null ? '' : String(v);
    if(!/^https?:/i.test(u)) return null;
    return u.slice(0, LOG_URL_MAX);
  }

  // No-op in admin: this is an internal tool and its use is not customer
  // telemetry.
  function track(){}

  function trackFail(){}

  // What is on the shirt, in one line per side. Cheap enough to attach to
  // the events worth reconstructing a session from — open, continue, add
  // to cart — without shipping the scene itself.
  function logScene(){
    var out = { sides: [], objects: 0 };
    try {
      views.forEach(function(v){
        if(!v.canvas) return;
        var objs = v.canvas.getObjects();
        out.objects += objs.length;
        out.sides.push({
          side: v.id,
          count: objs.length,
          text: objs.filter(function(o){ return o.type === 'sb-text'; }).length,
          images: objs.filter(function(o){ return o.type !== 'sb-text'; }).length,
          notes: !!v.notes
        });
      });
      out.shirt = shirt ? shirt.key : null;
      out.color = shirt ? shirt.color : null;
    } catch(e){}
    return out;
  }

  // The properties worth knowing about one element. Geometry is rounded:
  // sub-pixel precision says nothing about how the tool is being used and
  // makes two identical layouts look different.
  function logElement(o){
    if(!o) return null;
    var d = {
      kind: o.type === 'sb-text' ? 'text' : 'image',
      left: Math.round(o.left || 0),
      top: Math.round(o.top || 0),
      scale: Math.round((o.scaleX || 1) * 1000) / 1000,
      angle: Math.round(o.angle || 0),
      flipped: !!(o.flipX || o.flipY)
    };
    try {
      if(o.type === 'sb-text'){
        d.text = logStr(o.text);
        d.chars = (o.text || '').length;
        d.font = logStr(o.fontFamily, 80);
        d.fontSize = Math.round(o.fontSize || 0);
        d.fill = logStr(o.fill, 24);
        d.align = logStr(o.textAlign, 16);
        d.arc = Math.round(o.arc || 0);
        d.spacing = Math.round(o.charSpacing || 0);
        d.outline = o.stroke ? { color: logStr(o.stroke, 24),
                                 width: Math.round((o.strokeWidth || 0) * 100) / 100 } : null;
      } else {
        d.url = logUrl(o.sbSrc);
        d.label = logStr(o.sbLabel, 80);
        d.bgRemoved = !!o.sbBgOn;
        d.cutoutUrl = o.sbBgOn ? logUrl(o.sbBgSrc) : null;
      }
    } catch(e){}
    return d;
  }

  // Editing text fires on every keystroke and every slider tick, and
  // dragging fires per frame. Those are not events worth one row each —
  // what matters is where the shopper LANDED. So the fine-grained changes
  // are collapsed into a single settled snapshot once they stop.
  var LOG_SETTLE_MS = 1200;
  var settleTimer = null, settleAction = null;

  function trackSettled(){}

  // Anything about to navigate away has to send what is pending first.
  function flushSettled(){}

  // ============================================================
  // LAZY DEPENDENCIES
  // ============================================================
  var fabricPromise = null;
  function loadFabric(){
    if(window.fabric) return Promise.resolve(window.fabric);
    if(fabricPromise) return fabricPromise;
    fabricPromise = new Promise(function(resolve, reject){
      var s = document.createElement('script');
      s.src = FABRIC_URL;
      s.async = true;
      s.onload = function(){
        if(window.fabric) resolve(window.fabric);
        else reject(new Error('fabric.js loaded but did not register'));
      };
      s.onerror = function(){
        fabricPromise = null;   // let a later open retry
        reject(new Error('Could not load the design engine'));
      };
      document.head.appendChild(s);
    });
    return fabricPromise;
  }

  // Families are requested as they are needed, never all at once. Asking
  // for the whole library up front would pull down a font file for every
  // face in it — megabytes for a list most shoppers never open.
  var fontsLoaded = {};

  // Any face finishing, at any time, re-measures every text object.
  //
  // The per-request triggers below are not enough on their own, and the
  // gap is exactly what reopening a design from the cart falls into: the
  // builder asks for its shortlist on open, so by the time the scene
  // restores those families are already marked as requested and
  // loadFontFamilies returns early, registering no triggers at all. The
  // restore measures against the fallback, the real face lands a moment
  // later, and nothing ever re-measures -- a box wider than its own
  // glyphs, with the whole difference sitting to the right of them.
  var fontWatchBound = false;
  function watchFontArrivals(){
    if(fontWatchBound || !document.fonts || !document.fonts.addEventListener) return;
    fontWatchBound = true;
    document.fonts.addEventListener('loadingdone', remeasureAllText);
  }

  function loadFontFamilies(params){
    watchFontArrivals();
    var pending = [];
    params.forEach(function(param){
      if(!param || fontsLoaded[param]) return;
      fontsLoaded[param] = true;
      pending.push(param);
    });
    if(!pending.length) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?' +
      pending.map(function(p){ return 'family=' + p; }).join('&') + '&display=swap';
    document.head.appendChild(link);

    // Injecting the stylesheet is not the end of the job. A text object is
    // measured against whatever font exists at layout time, so anything
    // laid out before its face arrives keeps a fallback-derived width for
    // good. And for a SINGLE line width === lineWidth, which makes
    // fabric's centring offset zero — so the glyphs start at the box's
    // left edge and the whole difference shows up as dead space on the
    // right. That is the over-wide bounding box, and why snap-to-centre
    // lines up the box rather than the visible text.
    //
    // So once the faces are actually here, re-measure every text object.
    // Two triggers, because neither alone is reliable: the stylesheet's
    // load event fires before the faces are necessarily usable, and
    // document.fonts.load is unavailable on older browsers.
    // On load the stylesheet has arrived but its font FILES may not have,
    // so this waits for the faces to be usable rather than re-measuring
    // against whatever is there the instant the CSS parses.
    function remeasureWhenUsable(){ whenFontsSettled(pending).then(remeasureAllText); }
    link.addEventListener('load', remeasureWhenUsable);
    remeasureWhenUsable();
  }

  // Resolves once every requested family is usable. document.fonts.load
  // wants a real family name, and these are URL-encoded (Permanent+Marker),
  // so they are turned back into CSS names first.
  function whenFontsSettled(params){
    if(!document.fonts || !document.fonts.load) return Promise.resolve();
    return Promise.all(params.map(function(p){
      var family = String(p).replace(/\+/g, ' ').split(':')[0];
      try { return document.fonts.load('72px "' + family + '"').catch(function(){}); }
      catch(e){ return Promise.resolve(); }
    })).catch(function(){});
  }

  // The CSS family name behind one of our font stacks, in the form
  // document.fonts wants. FONTS carries the Google parameter
  // (Permanent+Marker), not the family.
  function familyNameOf(cssStack){
    var i = fontIndexByCss(cssStack);
    if(i < 0 || !FONTS[i].google) return null;
    return String(FONTS[i].google).split('+').join(' ').split(':')[0];
  }

  // Resolves once the family is genuinely usable, not merely asked for.
  //
  // Two traps here, both of which report success while the real face is
  // still absent. document.fonts.load resolves IMMEDIATELY when the
  // family has no @font-face rule yet -- the normal state for the moment
  // after the stylesheet is injected. And document.fonts.check answers
  // true for a family that is not there at all, because the text would
  // still render, through the fallback.
  //
  // The face list load() hands back is the honest signal: empty means the
  // rule has not been parsed yet. Poll that, and a restore measures the
  // real font the first time instead of measuring the fallback and
  // depending on a later correction to put it right.
  function whenFamilyUsable(cssStack){
    var family = familyNameOf(cssStack);
    if(!family || !document.fonts || !document.fonts.load) return whenFontReady(cssStack);
    var probe = '72px "' + family + '"';
    var deadline = Date.now() + 4000;
    return new Promise(function(resolve){
      function done(){ dropFontCache(cssStack); resolve(); }
      (function attempt(){
        var p;
        try { p = document.fonts.load(probe); } catch(e){ p = null; }
        if(!p || !p.then){ done(); return; }
        p.then(function(faces){
          if((faces && faces.length) || Date.now() > deadline) done();
          else setTimeout(attempt, 100);
        }, done);
      })();
    });
  }

  // Re-measure text on every side, not just the visible one: a thumbnail
  // and an export both read the same stale width.
  function remeasureAllText(){
    var touched = false;
    views.forEach(function(v){
      if(!v.canvas) return;
      v.canvas.getObjects().forEach(function(o){
        if(o.type !== 'sb-text') return;
        dropFontCache(o.fontFamily);
        var before = o.width;
        o.initDimensions();
        o.setCoords();
        if(Math.abs(o.width - before) > 0.5){
          touched = true;
          if(SB_DIAG){
            console.log('[sb-diag] fontArrived:corrected | ' + round2(before) +
                        ' -> ' + round2(o.width) + ' | ' + o.fontFamily);
          }
        }
      });
      v.canvas.renderAll();
    });
    if(touched){
      // The box moved, so anything derived from it is stale too.
      syncPanel();
      scheduleElements();
    }
  }

  // The inline grid is a most-recently-used shortlist, not a fixed set. It
  // starts as the starter fonts and keeps their count: promoting a face
  // pushes the last one off, so the grid never changes size.
  //
  // Held as FONTS indices, and persisted for the tab so the list survives
  // reopening the builder and the login round trip. Labels rather than
  // indices go to storage, since an index means nothing if the library is
  // ever reordered.
  var SHORTLIST_KEY = 'sibShirtBuilderFonts';
  var shortlist = [];

  function starterIndices(){
    var out = [];
    FONTS.forEach(function(f, i){ if(f.starter) out.push(i); });
    return out;
  }

  function fontIndexByLabel(label){
    for(var i = 0; i < FONTS.length; i++) if(FONTS[i].label === label) return i;
    return -1;
  }

  function fontIndexByCss(css){
    if(!css) return -1;
    for(var i = 0; i < FONTS.length; i++) if(FONTS[i].css === css) return i;
    return -1;
  }

  function initShortlist(){
    var base = starterIndices();
    shortlist = base.slice();
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(SHORTLIST_KEY) || 'null'); } catch(e){}
    if(!Array.isArray(saved)) return;
    // Rebuild from the stored order, then top up from the starters so a
    // short or partly stale list still fills the grid.
    var rebuilt = [];
    saved.forEach(function(label){
      var i = fontIndexByLabel(label);
      if(i > -1 && rebuilt.indexOf(i) === -1) rebuilt.push(i);
    });
    base.forEach(function(i){ if(rebuilt.indexOf(i) === -1) rebuilt.push(i); });
    shortlist = rebuilt.slice(0, base.length);
  }

  function saveShortlist(){
    try {
      sessionStorage.setItem(SHORTLIST_KEY,
        JSON.stringify(shortlist.map(function(i){ return FONTS[i].label; })));
    } catch(e){}
  }

  // Returns whether the grid changed, so callers only re-render when it
  // did. A face already on the shortlist stays where it is: reshuffling
  // the grid under the pointer that just clicked it is worse than stale
  // ordering.
  function promoteFont(idx){
    if(!(idx > -1) || !FONTS[idx]) return false;
    if(shortlist.indexOf(idx) > -1) return false;
    shortlist.unshift(idx);
    shortlist = shortlist.slice(0, starterIndices().length);
    saveShortlist();
    return true;
  }

  function shortlistFonts(){
    return shortlist.map(function(i){ return FONTS[i]; });
  }

  // Reopening a design should show what it is set in. Promotes in reverse
  // so the design's first font ends up first, and loads the faces — a
  // restored object carries a fontFamily but nothing has fetched it, so
  // without this it measures and paints as the fallback.
  function adoptFontsInUse(){
    var seen = [];
    views.forEach(function(v){
      if(!v.canvas) return;
      v.canvas.getObjects().forEach(function(o){
        if(o.type !== 'sb-text' || !o.fontFamily) return;
        var i = fontIndexByCss(o.fontFamily);
        if(i > -1 && seen.indexOf(i) === -1) seen.push(i);
      });
    });
    if(!seen.length) return;
    loadFontFamilies(seen.map(function(i){ return FONTS[i].google; }));
    var changed = false;
    for(var k = seen.length - 1; k >= 0; k--) if(promoteFont(seen[k])) changed = true;
    if(changed) renderFonts();
  }

  // What new text is set in. A condensed grotesque reads well on a shirt at
  // almost any size, which the theme's UI face does not. Looked up by label
  // so reordering the library cannot silently change it.
  var DEFAULT_FONT = 'Oswald';
  function defaultFont(){
    for(var i = 0; i < FONTS.length; i++){
      if(FONTS[i].label === DEFAULT_FONT) return FONTS[i];
    }
    return FONTS[0];
  }

  // On open, only the inline shortlist.
  function requestFonts(){
    if(!shortlist.length) initShortlist();
    loadFontFamilies(shortlistFonts().map(function(f){ return f.google; }));
  }

  // A webfont that has not finished loading measures as the fallback, so
  // text added immediately after a font change would be laid out at the
  // wrong width and stay that way. Wait for the real face, then re-render.
  function whenFontReady(cssStack){
    if(!document.fonts || !document.fonts.load) return Promise.resolve();
    try {
      return document.fonts.load('72px ' + cssStack)
        .catch(function(){})
        .then(function(){ dropFontCache(cssStack); });
    } catch(e){
      return Promise.resolve();
    }
  }

  // fabric memoises per-character widths in fabric.charWidthsCache, keyed
  // by font family alone. Measure a string before its webfont arrives and
  // every later initDimensions() reads the FALLBACK's widths back out of
  // that cache — so the box keeps the fallback's size no matter how many
  // times it is re-measured. Bebas Neue falls back to Impact, which is far
  // wider, which is why the box ran off to the right of the glyphs.
  //
  // So the cache has to be dropped the moment a real face lands, before
  // anything re-measures against it. Clear the whole cache deliberately:
  // Fabric keys it by the exact fontFamily declaration (including fallback
  // stacks and per-character styles), while a restored scene may not use
  // the byte-for-byte declaration that requested the webfont. A partial
  // clear can therefore leave the bad fallback measurements in place.
  function dropFontCache(){
    try {
      if(fabric && fabric.util && fabric.util.clearFabricFontCache){
        fabric.util.clearFabricFontCache();
      }
    } catch(e){}
  }

  // Load every face used by a serialized scene before Fabric constructs its
  // text objects. Fabric's Text constructor measures immediately and trusts
  // its global character-width cache; fixing the dimensions afterwards is
  // both racy and vulnerable to a cache-key mismatch. Preflighting makes the
  // first (constructor) measurement the authoritative one.
  function prepareSceneFonts(scene){
    var stacks = [];
    var params = [];
    ((scene && scene.objects) || []).forEach(function(o){
      if(o.type !== 'sb-text' || !o.fontFamily || stacks.indexOf(o.fontFamily) > -1) return;
      stacks.push(o.fontFamily);
      var i = fontIndexByCss(o.fontFamily);
      if(i > -1 && FONTS[i].google) params.push(FONTS[i].google);
    });
    if(!stacks.length) return Promise.resolve();
    loadFontFamilies(params);
    return Promise.all(stacks.map(whenFamilyUsable)).then(function(){
      dropFontCache();
    });
  }

  // ============================================================
  // ARC TEXT
  // ============================================================
  // fabric has no curved text. This subclass renders each glyph rotated
  // along a circular arc whose length equals the straight line width, so
  // dialling `arc` from 0 bends the same text without resizing it.
  // Positive arc arches upward, negative sags into a valley.
  var sbTextDefined = false;
  function defineSbText(fabric){
    if(sbTextDefined) return;
    sbTextDefined = true;

    var SbText = fabric.util.createClass(fabric.Text, {
      type: 'sb-text',
      arc: 0,
      // Arc geometry is recomputed per frame from live properties, so the
      // usual object cache would serve a stale bitmap after every slider
      // nudge. A handful of text objects is nowhere near enough to make
      // uncached rendering cost anything.
      objectCaching: false,

      initialize: function(text, options){
        options = options || {};
        this.callSuper('initialize', text, options);
        this.arc = options.arc || 0;
      },

      // fabric.Text normally shares one process-wide character-width cache.
      // That is unsafe for webfonts: a different object (or an earlier
      // builder session) can measure this same family through its fallback,
      // and a restored object then inherits those numbers even though the
      // real face is what the browser paints. The result is visible glyphs
      // at the left of an obsolete, much wider selection box.
      //
      // Keep measurement reuse within this object and this dimensions pass
      // only. Text._measureChar still gets its normal single-character and
      // kerning-pair cache, but no fallback measurement can cross an
      // initDimensions boundary or leak in from another text object.
      getFontCache: function(decl){
        var key = String(decl.fontFamily || '').toLowerCase() + '|' +
                  String(decl.fontStyle || '').toLowerCase() + '|' +
                  String(decl.fontWeight || '').toLowerCase();
        this.__sbCharWidths = this.__sbCharWidths || {};
        return this.__sbCharWidths[key] || (this.__sbCharWidths[key] = {});
      },

      toObject: function(props){
        return this.callSuper('toObject', ['arc'].concat(props || []));
      },

      // Lay the whole block out on concentric rings around ONE centre.
      //
      // The obvious implementation — arc each line on its own circle and
      // stack the results vertically — falls apart exactly where it
      // matters: as the arc opens up, every line's bulge grows and pushes
      // the next one further away, so at full sweep two lines read as two
      // unrelated arcs drifting apart rather than as one ring of text.
      // Sharing a centre and giving each line its own radius is what
      // makes "family reunion" close into a circle.
      //
      // Runs off __charBounds, which fabric fills during initDimensions,
      // so the metrics pass and the render pass agree by construction —
      // no second measurement that could disagree with the first.
      _arcLayout: function(){
        var deg = Math.abs(this.arc || 0);
        if(deg < 1 || !this.__lineWidths || !this.__charBounds) return null;
        var lines = this.textLines || [];
        if(!lines.length) return null;

        var a = Math.min(deg, 360) * Math.PI / 180;
        var sign = this.arc >= 0 ? 1 : -1;
        var lh = this.getHeightOfLine(0) || this.fontSize;
        var i, j;

        var widest = 0;
        for(i = 0; i < lines.length; i++) widest = Math.max(widest, this.__lineWidths[i] || 0);
        if(!widest) return null;

        // Every line spans the SAME sweep — the slider angle — rather than
        // each deriving its own from its width and radius.
        //
        // Deriving per line is what made two lines drift apart: the inner
        // ring is shorter, so it reaches a full circle first and clamps
        // there while the outer one keeps opening. Sharing the sweep locks
        // them together by construction — both lines start and end on the
        // same two radii at every setting, and both close at 360 at the
        // same moment.
        //
        // The cost is that lines no longer keep their natural tracking:
        // a line shorter than the ring it sits on gets spread out to fill
        // the sweep. That is inherent to concentric text — it is why the
        // outer ring of a badge is always tracked wider than the inner —
        // and it is the trade that buys the even effect.
        // Rings stay exactly a line-height apart at every sweep. Closing
        // the gap as the circle tightens does hold the shorter line's
        // tracking down, but it buys that by letting the rings collide —
        // and overlapping lines are far worse to read than widely tracked
        // ones. A fixed line-height is the one value that can never
        // collide, whatever the arc.
        var gap = lh;
        // Size the rings so no line is squeezed into an arc shorter than
        // the text itself: every ring is at least as long as the line it
        // carries, so letters spread but never collide.
        // Which ring each line sits on, counted from the outermost.
        //
        // For an arch the centre of the circle is below the text, so a
        // bigger radius sits higher and line 0 belongs on the outside.
        // A valley puts the centre ABOVE, which inverts that: a bigger
        // radius now hangs lower, so leaving line 0 outermost printed the
        // lines bottom-to-top — "Family / Reunion" read as "Reunion /
        // Family" the moment the arc went negative.
        var last = lines.length - 1;
        function ring(idx){ return sign > 0 ? idx : last - idx; }

        // Size the rings from the WIDEST line, not from whichever line
        // happens to land on the inside.
        //
        // Deriving each ring from its own line's width made the shape
        // depend on the sign: a valley puts line 0 on the inner ring, so
        // a short first line produced a much tighter circle than the same
        // arc in the other direction — +120 and -120 bent by visibly
        // different amounts. Sizing the innermost ring so the widest line
        // would exactly fill it makes the radii identical either way, so
        // flipping the sign now mirrors the shape instead of reshaping
        // it. It also guarantees no line is ever compressed: every ring
        // is at least as long as the longest line.
        var rIn = Math.max(widest / a, lh * 0.35);

        var glyphs = [];
        var minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
        var pad = this.fontSize * 0.72;

        for(i = 0; i < lines.length; i++){
          var R = rIn + (last - ring(i)) * gap;
          var w = this.__lineWidths[i] || 0;
          var bounds = this.__charBounds[i] || [];
          var cum = 0;
          for(j = 0; j < lines[i].length; j++){
            var cw = bounds[j] ? (bounds[j].kernedWidth || bounds[j].width || 0) : 0;
            // Position by each glyph's share of its own line, then spread
            // that across the shared sweep — so relative letter widths are
            // preserved while the line as a whole fills the arc.
            var t = w ? (cum + cw / 2) / w : 0.5;
            var theta = (t - 0.5) * a;
            var x = R * Math.sin(theta);
            var y = -sign * R * Math.cos(theta);
            glyphs.push({ ch: lines[i][j], theta: theta, r: R });
            if(x - pad < minX) minX = x - pad;
            if(x + pad > maxX) maxX = x + pad;
            if(y - pad < minY) minY = y - pad;
            if(y + pad > maxY) maxY = y + pad;
            cum += cw;
          }
        }
        if(!glyphs.length) return null;

        return {
          glyphs: glyphs,
          sign: sign,
          width: maxX - minX,
          height: maxY - minY,
          // Where the circle centre sits relative to the object's centre.
          ox: (minX + maxX) / 2,
          oy: (minY + maxY) / 2
        };
      },

      // fabric sizes the box for a straight run; an arced run occupies a
      // different box entirely. Recompute it so the selection frame and
      // the hit area actually wrap the glyphs the shopper can see.
      initDimensions: function(){
        this.__sbCharWidths = {};
        this.callSuper('initDimensions');
        if(!this.arc) return;
        var m = this._arcLayout();
        if(!m) return;
        this.width = m.width;
        this.height = m.height;
      },

      _render: function(ctx){
        if(!this.arc || Math.abs(this.arc) < 1){
          this.callSuper('_render', ctx);
          return;
        }
        var m = this._arcLayout();
        if(!m){ this.callSuper('_render', ctx); return; }

        ctx.save();
        ctx.font = this._getFontDeclaration();
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        ctx.fillStyle = this.fill || '#000';
        ctx.lineJoin = 'round';
        // Shift so the laid-out block is centred on the object.
        ctx.translate(-m.ox, -m.oy);
        for(var k = 0; k < m.glyphs.length; k++){
          var g = m.glyphs[k];
          ctx.save();
          ctx.rotate(m.sign * g.theta);
          ctx.translate(0, -m.sign * g.r);
          this._strokeAndFill(ctx, g.ch, 0, 0);
          ctx.restore();
        }
        ctx.restore();
      },

      _strokeAndFill: function(ctx, str, x, y){
        // Stroke UNDER the fill. A canvas stroke straddles the glyph
        // outline — half outside, half in — so painting the fill over it
        // hides the inner half and leaves a solid band that only grows
        // outwards. strokeWidth is stored pre-doubled for exactly this,
        // so the visible band matches the thickness the shopper set.
        // (The unarced path gets the same result from paintFirst:'stroke'.)
        if(this.stroke && this.strokeWidth){
          ctx.save();
          ctx.strokeStyle = this.stroke;
          ctx.lineWidth = this.strokeWidth;
          ctx.strokeText(str, x, y);
          ctx.restore();
        }
        ctx.fillText(str, x, y);
      }
    });

    SbText.fromObject = function(object, callback){
      return fabric.Object._fromObject('SbText', object, callback, 'text');
    };
    fabric.SbText = SbText;
  }

  // ============================================================
  // SELECTION CONTROLS
  // ============================================================
  // Corner buttons drawn as flat vector icons rather than loaded images:
  // no async, no CORS, and they stay crisp at any device pixel ratio.
  function ctlRender(draw, color, size){
    var r = (size || 26) / 2;
    // Every glyph below is drawn for the 26px handle. Scaling the whole
    // path keeps it proportional on the larger touch handle instead of
    // leaving a small icon marooned in a big circle.
    var k = r / 13;
    return function(ctx, left, top){
      ctx.save();
      ctx.translate(left, top);
      ctx.beginPath();
      ctx.arc(0, 0, r, 0, Math.PI * 2);
      ctx.fillStyle = '#fff';
      ctx.fill();
      ctx.lineWidth = 1;
      ctx.strokeStyle = '#c9cdd3';
      ctx.stroke();
      ctx.scale(k, k);
      ctx.beginPath();
      ctx.strokeStyle = color || '#1f2937';
      ctx.lineWidth = 1.6;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      draw(ctx);
      ctx.stroke();
      ctx.restore();
    };
  }

  var ICON = {
    // Delete reads as a red X rather than a bin: at 26px a bin is a grey
    // smudge, and an X is the one glyph nobody has to decode.
    close:  function(c){ c.moveTo(-4.3,-4.3); c.lineTo(4.3,4.3); c.moveTo(4.3,-4.3); c.lineTo(-4.3,4.3); },
    // The rail's Duplicate glyph at handle scale: a square with a second
    // one behind it, open on the near corner.
    dupe:   function(c){
              c.moveTo(-1.4,-2.75); c.lineTo(4.1,-2.75);
              c.quadraticCurveTo(5.5,-2.75, 5.5,-1.4);
              c.lineTo(5.5,4.1);
              c.quadraticCurveTo(5.5,5.5, 4.1,5.5);
              c.lineTo(-1.4,5.5);
              c.quadraticCurveTo(-2.75,5.5, -2.75,4.1);
              c.lineTo(-2.75,-1.4);
              c.quadraticCurveTo(-2.75,-2.75, -1.4,-2.75);
              c.moveTo(2.1,-4.8); c.lineTo(-4.1,-4.8);
              c.quadraticCurveTo(-5.5,-4.8, -5.5,-3.4);
              c.lineTo(-5.5,2.1);
            },
    rotate: function(c){ c.arc(0,0,5,-0.5,4.4); c.moveTo(5.6,-3.4); c.lineTo(4.4,0.2); c.lineTo(1.2,-1.6); },
    layers: function(c){ c.moveTo(0,-6); c.lineTo(6,-2.6); c.lineTo(0,0.8); c.lineTo(-6,-2.6); c.closePath();
                         c.moveTo(-6,1.4); c.lineTo(0,4.8); c.lineTo(6,1.4); },
    scale:  function(c){ c.moveTo(-4.6,4.6); c.lineTo(4.6,-4.6); c.moveTo(4.6,-4.6); c.lineTo(1,-4.6);
                         c.moveTo(4.6,-4.6); c.lineTo(4.6,-1); c.moveTo(-4.6,4.6); c.lineTo(-1,4.6); c.moveTo(-4.6,4.6); c.lineTo(-4.6,1); }
  };

  // Arrow-key nudging, the way every design tool does it: one step is a
  // hair, Shift is a stride.
  //
  // Sized in SCREEN pixels and converted to design units, not fixed in
  // design units. The design space is 1000 wide however big the garment is
  // drawn, so a fixed step is a different distance on every screen — and
  // one design unit on a phone is a third of a pixel, which looks like the
  // key did nothing at all.
  var NUDGE_PX = 1;
  var NUDGE_PX_SHIFT = 10;

  // A run of taps is ONE undo step. Capturing per key would fill the
  // 40-deep history with a single adjustment and evict real edits behind
  // it; a drag is one step for the same reason.
  var nudgeTimer = null;

  function nudge(dx, dy, big){
    var o = active(), c = canvas();
    if(!o || !c) return false;
    var step = (big ? NUDGE_PX_SHIFT : NUDGE_PX) / (c.getZoom() || 1);
    o.set({ left: o.left + dx * step, top: o.top + dy * step });
    o.setCoords();
    c.renderAll();
    syncPanel();
    if(nudgeTimer) clearTimeout(nudgeTimer);
    nudgeTimer = setTimeout(function(){ nudgeTimer = null; capture(); }, 400);
    return true;
  }

  var ARROWS = {
    ArrowLeft:  [-1, 0], ArrowRight: [1, 0],
    ArrowUp:    [0, -1], ArrowDown:  [0, 1]
  };

  // Rotation, with the 45-degree magnet suspended while Shift is held.
  // fabric's own handler reads target.snapAngle, so the switch is to zero
  // it for the duration of the call and put it back — cheaper and less
  // brittle than reimplementing the rotation maths to skip one branch.
  function rotateMaybeSnapping(eventData, transform, x, y){
    var cu = fabric.controlsUtils;
    var o = transform && transform.target;
    if(!o || !snapOverridden(eventData)) return cu.rotationWithSnapping(eventData, transform, x, y);
    var angle = o.snapAngle, threshold = o.snapThreshold;
    o.snapAngle = 0;
    o.snapThreshold = 0;
    try {
      return cu.rotationWithSnapping(eventData, transform, x, y);
    } finally {
      // Restored even if the handler throws, or one bad frame would leave
      // the object permanently unsnappable.
      o.snapAngle = angle;
      o.snapThreshold = threshold;
    }
  }

  // Applied to every object we add: delete top-left, rotate top-right,
  // layer bottom-left, free resize bottom-right, duplicate top-centre.
  //
  // The single-axis stretch handles are deliberately absent. They are the
  // only handles here that can distort artwork, they were the easiest to
  // hit by accident on a phone, and nothing about a shopper's design needs
  // a squashed logo. Corner resize keeps the aspect ratio.
  function applyControls(fabric, obj, handlers){
    var cu = fabric.controlsUtils;
    var phone = isMobile();
    // A finger needs a bigger handle than a mouse pointer, and more room
    // between the handle and the artwork — at desktop spacing the handles
    // sit on the thing they are meant to be adjusting, so a thumb covers
    // the result of its own drag. Read at creation, like borderColor.
    var size = phone ? 34 : 26;
    var gap  = phone ? 10 : 4;
    obj.set({
      // Orange on a phone, matching every other "this is selected" cue
      // in the builder; the desktop frame keeps the blue it has always
      // had. Read at creation, which is when an object joins a canvas.
      borderColor: isMobile() ? '#f97316' : '#2f6df6',
      borderScaleFactor: isMobile() ? 2 : 1.6,
      cornerSize: size,
      // The drawn handle stays 26px; this is the invisible area a finger
      // has to land in, which wants to be a comfortable target.
      touchCornerSize: 44,
      transparentCorners: false,
      // The gap between the artwork and the selection frame, which the
      // corner handles hang off — so widening it pushes them out too.
      padding: phone ? 10 : 6,
      lockScalingFlip: true,
      // Rotation clicks into 45-degree steps. snapThreshold is the width of
      // the magnet in degrees: inside it the angle holds while the pointer
      // keeps moving, which is the "few pixels of nothing" that makes a
      // snap feel deliberate rather than twitchy.
      snapAngle: 45,
      snapThreshold: 8,
      // Grow from the middle, not from the opposite corner. Fabric's
      // default pins the far corner, so every resize slides the artwork
      // off-centre and has to be dragged back. This matches the Size
      // slider, which already scales about the centre because these
      // objects are positioned by their centre. Holding Alt still gives
      // the corner-anchored behaviour for anyone who wants it.
      centeredScaling: true
    });
    obj.controls = {
      tl: new fabric.Control({ x:-0.5, y:-0.5, offsetX:-gap, offsetY:-gap, cursorStyle:'pointer',
            mouseUpHandler: handlers.remove, render: ctlRender(ICON.close, '#dc2626', size),
            sizeX:size, sizeY:size }),
      tr: new fabric.Control({ x:0.5, y:-0.5, offsetX:gap, offsetY:-gap, cursorStyle:'crosshair',
            actionHandler: rotateMaybeSnapping, actionName:'rotate',
            render: ctlRender(ICON.rotate, null, size), sizeX:size, sizeY:size }),
      bl: new fabric.Control({ x:-0.5, y:0.5, offsetX:-gap, offsetY:gap, cursorStyle:'pointer',
            mouseUpHandler: handlers.layer, render: ctlRender(ICON.layers, null, size),
            sizeX:size, sizeY:size,
            // A lone element has no stack to move through, so the handle
            // stays away rather than opening a menu of two dead options.
            // fabric consults this for hit testing as well as drawing, so
            // the corner is genuinely inert, not merely invisible.
            getVisibility: function(obj){
              return !!(obj && obj.canvas && obj.canvas.getObjects().length > 1);
            } }),
      br: new fabric.Control({ x:0.5, y:0.5, offsetX:gap, offsetY:gap,
            cursorStyleHandler: cu.scaleCursorStyleHandler,
            actionHandler: cu.scalingEqually, actionName:'scale',
            render: ctlRender(ICON.scale, null, size), sizeX:size, sizeY:size }),
      mt: new fabric.Control({ x:0, y:-0.5, offsetY:-gap, cursorStyle:'pointer',
            mouseUpHandler: handlers.dupe, render: ctlRender(ICON.dupe, null, size),
            sizeX:size, sizeY:size })
    };
  }

  // ============================================================
  // STATE
  // ============================================================
  var fabric = null;          // resolved on first open
  var shirt = null;           // the shirt entry handed over by the modal
  var views = [];             // [{ id, label, garment, canvas, el, design, history, redo, notes }]
  var activeIdx = 0;
  var isOpen = false;
  var restoring = false;      // suppresses history capture during a replay
  // Same, for a clear that spans both sides. Every removal fires
  // object:removed, and capture() records whichever side is ON SCREEN —
  // so left alone, clearing the back would write the front's history over
  // and over while the back's went unrecorded.
  var clearing = false;
  var swatchTarget = null;    // 'fill' | 'stroke' while a swatch grid is open

  function view(){ return views[activeIdx] || null; }
  function canvas(){ var v = view(); return v && v.canvas; }
  function active(){ var c = canvas(); return c && c.getActiveObject(); }

  // Default drop area in design units. Not drawn — it only decides where
  // a newly added element lands and how big it starts, which is the whole
  // job the metafield was calibrated for.
  function dropBox(v){
    var w = v.design.w * DROP_W_PCT / 100;
    return {
      w: w,
      h: w * PRINT_RATIO,
      // The middle of the garment photo, full stop. Every centring in the
      // builder reads these, so they are the definition of centred.
      cx: v.design.w / 2,
      cy: v.design.h / 2
    };
  }

  // ============================================================
  // CANVAS LIFECYCLE
  // ============================================================
  // A note on painting: everything in here calls renderAll(), never
  // requestRenderAll().
  //
  // requestRenderAll() defers to requestAnimationFrame, and fabric guards
  // it with an isRendering flag — so a request that never gets a frame
  // swallows every later request too, and the canvas sits on stale pixels
  // until something renders synchronously. Deselecting an object happened
  // to be one such thing, which is why the symptom always looked like
  // "it updates when I click away". rAF also never fires at all in a
  // backgrounded or occluded tab.
  //
  // Every render in this file is triggered by a discrete action — a slider
  // tick, a swatch, a layer change, loading a scene — not by a per-frame
  // drag loop, since fabric paints transforms itself. So there is nothing
  // here that benefits from frame batching, and painting now is both
  // simpler to reason about and impossible to wedge.
  // Strip the stage back to just the garment image.
  //
  // Disposal driven by `views` alone is not enough: openBuilder reassigns
  // views before anything tears the old ones down, so a re-entry or a
  // half-failed open orphans canvases that nothing owns any more. They
  // keep their last painted frame, which is how the builder can open
  // showing artwork that is on no canvas and in no element list. Sweeping
  // the DOM cannot miss one.
  function resetStage(){
    var wrap = $('sb-wrap');
    if(!wrap) return;
    Array.prototype.slice.call(wrap.children).forEach(function(node){
      if(node.id !== 'sb-garment') wrap.removeChild(node);
    });
  }

  // ============================================================
  // THE iOS KEYBOARD AND THE FIXED LAYERS
  // ============================================================
  // Symptom: open the builder from a product page on an iPhone, tap Add
  // Text, and the product page shows through below the dialog.
  //
  // Cause: position:fixed on iOS is anchored to the LAYOUT viewport, which
  // does not shrink when the keyboard opens. A dialog centred in it
  // therefore centres behind the keyboard — so Safari scrolls the document
  // to bring the focused field into view, and on iOS that scroll drags the
  // fixed layers with it. The builder's bottom edge lifts off the bottom
  // of the screen and the page behind it fills the gap.
  //
  // Fix: size the open dialog to the VISUAL viewport, which is the part
  // not covered by the keyboard. The field then lands above the keyboard
  // on its own and Safari has nothing to scroll for. The scroll reset
  // undoes anything it managed before this ran.
  //
  // Restored to the position the page held when the builder opened, not to
  // zero: the shopper was somewhere down a product page and closing the
  // builder has to put them back there.
  var lockedScrollY = 0;

  function pageScrollY(){
    return window.scrollY || window.pageYOffset || 0;
  }

  function restorePageScroll(){
    if(Math.abs(pageScrollY() - lockedScrollY) > 1) window.scrollTo(0, lockedScrollY);
  }

  // How much of the viewport has to disappear before this counts as a
  // keyboard. A phone's own toolbars make visualViewport.height differ from
  // innerHeight by a few dozen pixels during ordinary use, so a near-equal
  // test was true almost always — and the scroll correction below then ran
  // on every viewport scroll event, including the ones a drag on the
  // garment generates. Repeatedly scrolling the page under a fixed overlay
  // is how iOS ends up hit-testing controls somewhere other than where it
  // painted them.
  var KEYBOARD_MIN_PX = 120;

  function syncSubViewport(){
    var vv = window.visualViewport;
    var subs = document.querySelectorAll('.sb-sub');
    var openSub = false;
    Array.prototype.forEach.call(subs, function(el){
      if(el.classList.contains('open')) openSub = true;
    });
    var top = vv ? Math.max(0, Math.round(vv.offsetTop)) : 0;
    var h = vv ? Math.round(vv.height) : 0;
    // A keyboard-sized reduction, or a pinch that has moved the visible
    // area down the page. Anything smaller is the browser's own furniture.
    var shifted = !!vv && openSub &&
                  (top > 0 || (window.innerHeight - h) > KEYBOARD_MIN_PX);
    Array.prototype.forEach.call(subs, function(el){
      if(shifted && el.classList.contains('open')){
        el.style.top = top + 'px';
        el.style.height = h + 'px';
        el.style.bottom = 'auto';
      } else if(el.style.top || el.style.height){
        // Cleared for anything not currently open, so a dialog closed
        // while the keyboard was up cannot keep a stale height. Every call
        // corrects every layer, which makes this self-healing rather than
        // dependent on catching each open and close.
        el.style.top = '';
        el.style.height = '';
        el.style.bottom = '';
      }
    });
    // Only ever while a dialog is open. With nothing open there is no
    // focused field, nothing for the browser to have scrolled toward, and
    // no business touching the page's scroll position at all — doing it
    // anyway put a scrollTo in the middle of every drag.
    if(shifted && isOpen) restorePageScroll();
  }

  if(window.visualViewport){
    window.visualViewport.addEventListener('resize', syncSubViewport);
    window.visualViewport.addEventListener('scroll', syncSubViewport);
  }
  // focusin covers the case the viewport events miss: a field focused while
  // the keyboard is ALREADY up, where nothing resizes.
  document.addEventListener('focusin', syncSubViewport);
  document.addEventListener('focusout', function(){ setTimeout(syncSubViewport, 0); });

  // ============================================================
  // DRAGGING SHOWS THE ELEMENT, NOTHING ELSE
  // ============================================================
  // While something is being dragged its bounding box, its handles and the
  // Remove Background toggle all go away, so the only thing on the garment
  // is the artwork being positioned. Fabric's own answer is to grey the
  // handles out, which still leaves a box and eight nodes sitting over the
  // thing you are trying to look at.
  //
  // What comes back at the end depends on whether the element was already
  // selected when the drag started:
  //
  //   * already selected — the UI returns. The shopper is working on this
  //     element and nudging it is part of that.
  //   * not selected — it stays hidden and the element is left deselected.
  //     Dragging is then purely moving, and selecting is an explicit tap;
  //     a drag never leaves a bounding box behind on something that was
  //     only shoved out of the way.
  //
  // Selection is therefore decided on the way UP, not the way down. Fabric
  // makes the target active during mouse:down, which painted the box the
  // instant a finger landed and left it there until the drag actually
  // started — a flash of handles on something the shopper was only
  // reaching for. An unselected target has its box suppressed before
  // fabric ever gets to select it, and whether it stays suppressed is
  // settled at mouse:up by whether the gesture moved:
  //
  //   moved -> it was a drag. Leave it unselected.
  //   still -> it was a tap. Reveal the box now.
  //
  // Fabric makes the target active on mouse:down either way — that is what
  // makes the drag work at all — and with `selection:false` that also
  // clears whatever was selected before, so no other element is left
  // showing a box mid-drag. The deselect at the end is what stops the
  // dragged one from silently inheriting that selection.
  var dragWasSelected = false;   // read at mouse:down, before fabric acts
  var dragHidden = null;

  // Fabric has already made the target active by the time `mouse:down`
  // fires, so this has to run on `mouse:down:before` — afterwards there is
  // no way left to tell a drag of a selected element from a drag of an
  // unselected one.
  function noteDragCandidate(c, e){
    var t = e && e.target;
    dragWasSelected = !!(t && c.getActiveObject() === t);
    // Suppressed HERE, before fabric selects it, so no frame is ever
    // painted with the box on. Doing it any later — even in `mouse:down` —
    // means fabric has already selected and rendered, and the flash is
    // exactly what this is here to remove.
    if(t && !dragWasSelected) beginDragHide(t);
  }

  // Called from mouse:down:before for an unselected element, and from
  // object:moving for one that was already selected — a tap on something
  // already showing its box must not flicker it away and back.
  function beginDragHide(o){
    if(!o || dragHidden) return;
    dragHidden = {
      target: o,
      controls: o.hasControls,
      borders: o.hasBorders,
      wasSelected: dragWasSelected,
      moved: false
    };
    o.hasControls = false;
    o.hasBorders = false;
    hideBgrChip();
    // renderAll, not requestRenderAll: the deferred form is banned here.
    // It waits on requestAnimationFrame behind fabric's isRendering guard,
    // so a request that never gets a frame swallows every later one — the
    // box would come back only once something else painted.
    var c = canvas();
    if(c) c.renderAll();
  }

  // Records that this gesture was a drag rather than a tap, which is the
  // only thing that separates the two.
  function noteDragMoved(){
    if(dragHidden) dragHidden.moved = true;
  }

  function endDragHide(){
    if(!dragHidden) return;
    var st = dragHidden;
    dragHidden = null;
    st.target.hasControls = st.controls;
    st.target.hasBorders = st.borders;
    var c = canvas();
    // Only a gesture that actually MOVED leaves an unselected element
    // unselected. One that did not is a tap, and fabric has already made
    // it active — so restoring the box here is what makes the selection
    // appear on release instead of on touch.
    if(c && !st.wasSelected && st.moved) c.discardActiveObject();
    // After the discard, so an element that ends up deselected closes its
    // chip rather than leaving it floating over nothing — object:modified
    // fires before this and re-opens it while the object is still active.
    syncBgControls();
    if(c) c.renderAll();
  }

  function ensureCanvas(v){
    if(v.canvas) return v.canvas;
    var el = document.createElement('canvas');
    el.width = 10; el.height = 10;
    $('sb-wrap').appendChild(el);
    var c = new fabric.Canvas(el, {
      preserveObjectStacking: true,   // selecting must not jump z-order
      selection: false,               // no rubber-band; one object at a time
      backgroundColor: null,          // transparent: the garment is a DOM img behind
      allowTouchScrolling: false,
      stopContextMenu: true,
      fireRightClick: false,
      enableRetinaScaling: true
    });
    v.canvas = c;
    v.el = c.wrapperEl;
    c.on('selection:created', onSelect);
    c.on('selection:updated', onSelect);
    c.on('selection:cleared', onDeselect);
    c.on('object:modified', function(){
      wasCenterSnapped = false;
      capture(); syncPanel(); scheduleElements();
    });
    c.on('object:added',    function(){ capture(); refreshChrome(); });
    c.on('object:removed',  function(){ capture(); refreshChrome(); });
    // Live feedback while dragging a handle, without a history entry per
    // frame — object:modified fires once at the end and captures then.
    c.on('object:scaling', syncPanel);
    c.on('object:rotating', syncPanel);
    c.on('mouse:down:before', function(e){ noteDragCandidate(c, e); });
    c.on('mouse:down', function(){
      pointerDown = true;
      // Grabbing the artwork again mid-fade should bring the guide back to
      // solid rather than letting it finish dying under the pointer.
      var wrap = $('sb-center');
      if(wrap && wrap.classList.contains('show')){
        wrap.classList.remove('fading');
        clearCenterTimers();
      }
    });
    c.on('mouse:up', function(){
      pointerDown = false;
      endDragHide();
      armCenterFade();
    });
    c.on('object:moving', function(e){
      closeCanvasMenu();
      beginDragHide(e && e.target);
      noteDragMoved();
      snapWhileMoving(e);
    });
    bindTouchGestures(v);
    c.on('after:render', function(){
      var chip = $('sb-bgr-chip');
      if(chip && chip.classList.contains('open')) placeBgrChip();
      var guide = $('sb-center');
      if(guide && guide.classList.contains('show')) placeCenterGuide();
    });
    return c;
  }

  // ============================================================
  // TOUCH GESTURES
  // ============================================================
  // Fabric gives us one-finger drag for free, and its corner handles work
  // under a finger once the touch target is big enough. What it has no
  // notion of is two fingers: pinching to resize and twisting to rotate,
  // which on a phone is how people expect to handle an object at all.
  //
  // So two-finger gestures are handled here, on the upper canvas — the
  // element fabric puts its own listeners on — and only ever while
  // something is selected. One finger is left entirely to fabric, so
  // dragging, the handles and hit testing are unchanged.
  var MIN_GESTURE_SCALE = 0.02;
  var MAX_GESTURE_SCALE = 12;

  function touchSpan(touches){
    var dx = touches[0].clientX - touches[1].clientX;
    var dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }
  function touchAngle(touches){
    var dx = touches[0].clientX - touches[1].clientX;
    var dy = touches[0].clientY - touches[1].clientY;
    return Math.atan2(dy, dx) * 180 / Math.PI;
  }

  function bindTouchGestures(v){
    var wrap = v.canvas && v.canvas.wrapperEl;
    if(!wrap || wrap.sbGesturesBound) return;
    wrap.sbGesturesBound = true;
    var g = null;

    // Bound to the WRAPPER, in the capture phase, and not to the canvas
    // itself. Fabric registers its own touch listeners on the upper
    // canvas when the canvas is constructed -- before these -- and at the
    // target node listeners run in registration order whatever their
    // capture flag says. So a listener on the canvas can never get in
    // first, and fabric had already read the gesture as a plain tap:
    // whichever empty patch of shirt the first finger landed on cleared
    // the selection, leaving nothing to pinch by the time this code ran.
    // Capturing one node up is what actually arrives first.
    //
    // Once a gesture is recognised the event is stopped dead, so fabric
    // never sees it and cannot deselect or drag underneath it.
    function arm(e){
      if(e.touches.length !== 2) return;
      var o = v.canvas.getActiveObject();
      if(!o) return;
      e.preventDefault();
      e.stopPropagation();
      // A one-finger drag may already be in flight from the first finger.
      v.canvas._currentTransform = null;
      o.lockMovementX = true;
      o.lockMovementY = true;
      g = {
        obj: o,
        span: touchSpan(e.touches) || 1,
        angle: touchAngle(e.touches),
        scaleX: o.scaleX, scaleY: o.scaleY, rotation: o.angle || 0
      };
    }

    function move(e){
      if(!g) return;
      // A finger lifted mid-gesture: stop transforming, but keep the
      // event from fabric until every finger is up, or it resumes
      // dragging from whichever one is left.
      if(e.touches.length !== 2){ e.stopPropagation(); return; }
      e.preventDefault();
      e.stopPropagation();
      var k = touchSpan(e.touches) / g.span;
      // Scaled about the object own centre, which is where these objects
      // are positioned from -- so a pinch grows the artwork in place
      // instead of walking it across the shirt.
      g.obj.set({
        scaleX: clamp(g.scaleX * k, MIN_GESTURE_SCALE, MAX_GESTURE_SCALE),
        scaleY: clamp(g.scaleY * k, MIN_GESTURE_SCALE, MAX_GESTURE_SCALE),
        angle: ((g.rotation + (touchAngle(e.touches) - g.angle)) % 360 + 360) % 360
      });
      g.obj.setCoords();
      v.canvas.renderAll();
      syncPanel();
    }

    function end(e){
      if(!g) return;
      if(e.touches && e.touches.length){ e.stopPropagation(); return; }
      e.stopPropagation();
      g.obj.lockMovementX = false;
      g.obj.lockMovementY = false;
      g = null;
      // One history entry for the whole gesture, the way object:modified
      // gives one for a whole drag.
      capture();
      syncPanel();
      scheduleElements();
    }

    wrap.addEventListener('touchstart', arm, { capture: true, passive: false });
    wrap.addEventListener('touchmove', move, { capture: true, passive: false });
    wrap.addEventListener('touchend', end, { capture: true, passive: false });
    wrap.addEventListener('touchcancel', end, { capture: true, passive: false });
  }

  // Size the garment box to the stage, and zoom the canvas so design
  // units map onto it. Object coordinates never change, so this is safe
  // to run on every resize and on every view switch.
  // Size one side's canvas to the stage. Split out of fitStage() because
  // it is needed for sides that are NOT on screen: a canvas that has never
  // been fitted keeps fabric's default 300x150, and objects positioned in
  // design units fall outside it — so its thumbnail renders blank. That is
  // what made the first "Swap designs" appear to do nothing: the artwork
  // moved to a side whose canvas had never been shown, and the tile drew
  // an empty PNG.
  function fitCanvas(v){
    if(!v || !v.natural) return null;
    var main = $('sb-stage-main');
    var pad = isMobile() ? 16 : 32;
    var padX = pad, padY = pad;
    var availW = Math.max(120, main.clientWidth  - padX);
    var availH = Math.max(120, main.clientHeight - padY);
    var ratio = v.natural.w / v.natural.h;
    var w = availW, h = w / ratio;
    if(h > availH){ h = availH; w = h * ratio; }
    w = Math.floor(w); h = Math.floor(h);

    var c = ensureCanvas(v);
    if(c.getWidth() !== w || c.getHeight() !== h){
      c.setDimensions({ width: w, height: h });
      c.setZoom(w / v.design.w);
    }
    return { canvas: c, w: w, h: h };
  }

  function fitStage(){
    var v = view();
    if(!v || !v.natural) return;
    var fit = fitCanvas(v);
    if(!fit) return;

    var wrap = $('sb-wrap');
    wrap.style.width  = fit.w + 'px';
    wrap.style.height = fit.h + 'px';
    fit.canvas.renderAll();
    // Both empty-state overlays are positioned in stage pixels, so they
    // have to be recomputed whenever the stage is re-fitted.
    syncEmptyState();
  }

  function showView(idx){
    if(idx < 0 || idx >= views.length) return;
    var prev = views[activeIdx];
    if(prev && prev.el) prev.el.style.display = 'none';
    activeIdx = idx;
    var v = views[idx];
    $('sb-garment').src = v.garment;
    ensureCanvas(v);
    if(v.el) v.el.style.display = '';
    fitStage();
    v.canvas.discardActiveObject();
    v.canvas.renderAll();
    showPanel('add');
    renderViews();
    syncNotes();
    refreshChrome();
  }

  // ============================================================
  // HISTORY
  // ============================================================
  // Snapshots are per view. Cross-view undo would be surprising: the
  // shopper sees one side at a time and expects Undo to act on it.
  function captureView(v){
    if(!v || !v.canvas || restoring || clearing) return;
    var snap = JSON.stringify(v.canvas.toJSON(SCENE_PROPS));
    if(v.history.length && v.history[v.history.length - 1] === snap) return;
    v.history.push(snap);
    if(v.history.length > 40) v.history.shift();
    v.redo.length = 0;
    dirtySinceSave = true;
    refreshChrome();
  }

  function capture(){ captureView(view()); }

  // Replace the newest history entry with the canvas as it stands. For
  // corrections that do not change what the shopper sees as a separate
  // action — re-measuring text once its font lands, say.
  function recapture(){
    var v = view();
    if(!v || !v.canvas || !v.history.length) return;
    v.history[v.history.length - 1] = JSON.stringify(v.canvas.toJSON(SCENE_PROPS));
  }

  function restore(snap, done){
    var v = view();
    if(!v) return;
    restoring = true;
    v.canvas.loadFromJSON(snap, function(){
      v.canvas.getObjects().forEach(adoptObject);
      v.canvas.renderAll();
      restoring = false;
      v.canvas.getObjects().forEach(function(o){ sbDiagLog('undo/redo:restored', o); });
      // loadFromJSON takes each object's width straight from the snapshot.
      // A snapshot captured before a webfont arrived carries the width
      // fabric measured against the fallback, so every undo back to it
      // restored an over-wide box. Re-measure like the other restores do.
      remeasureText(v);
      refreshChrome();
      syncPanel();
      if(done) done();
    });
  }

  function undo(){
    var v = view();
    if(!v || v.history.length < 2) return;
    v.redo.push(v.history.pop());
    restore(v.history[v.history.length - 1]);
  }

  function redo(){
    var v = view();
    if(!v || !v.redo.length) return;
    var snap = v.redo.pop();
    v.history.push(snap);
    restore(snap);
  }

  function askStartOver(){
    // Anything on the shirt at all, not just on the side being viewed:
    // this clears both.
    if(!hasArtwork()) return;
    var copy = $('sb-reset-copy');
    if(copy){
      var sides = views.filter(function(v){
        return v.canvas && v.canvas.getObjects().length;
      });
      copy.textContent = (sides.length > 1
          ? 'This removes everything on the shirt, front and back.'
          : 'This removes everything on the shirt.') +
        (savedGuid ? ' It will also start a new design rather than changing your saved one.' : '');
    }
    $('sb-reset-ov').classList.add('open');
  }
  function closeStartOver(){ $('sb-reset-ov').classList.remove('open'); }

  // Every side, not just the one on screen. It used to clear only the
  // visible side while still dropping the design's saved identity — so
  // starting over on a design loaded from Saved Designs left an unnamed
  // new design that still held the whole back of the old one, and the
  // element list (which spans both sides) went on listing it.
  function startOver(){
    if(!views.length) return;
    track('builder-start-over', { was_saved: !!savedGuid, scene: logScene() });
    clearing = true;
    views.forEach(function(v){
      if(!v.canvas) return;
      v.canvas.discardActiveObject();
      v.canvas.remove.apply(v.canvas, v.canvas.getObjects().slice());
      v.canvas.renderAll();
    });
    clearing = false;
    // One undo entry per side, recorded here rather than by the removals:
    // see `clearing`. Undo still steps each side back on its own, which is
    // how every other edit in the builder behaves.
    views.forEach(captureView);
    // Whatever this becomes, it is no longer the design that was opened,
    // so it gives up its identity: the name row goes, and the next Save
    // asks for a name and writes a new row instead of overwriting the
    // original. Set after the captures — each one marks the stage dirty,
    // which would otherwise leave this fresh stage looking unsaved.
    savedGuid = null;
    savedName = '';
    dirtySinceSave = false;
    showPanel('add');
    refreshChrome();
  }

  // loadFromJSON rebuilds plain fabric objects, so anything we attached
  // by hand — the custom controls, the lock state — has to be re-applied.
  function adoptObject(obj){
    applyControls(fabric, obj, controlHandlers);
    if(obj.type === 'sb-text'){
      // Older scenes were saved before the outline was made outward-only.
      obj.set({ paintFirst: 'stroke', shadow: null });
    }
  }

  // ============================================================
  // ARTWORK FETCHING
  // ============================================================
  // Canvas-bound artwork is fetched as a blob and handed to fabric as an
  // object URL, rather than loaded straight from its https address.
  //
  // Sharing one URL between a plain <img> thumbnail and a CORS canvas
  // load is a trap: both go through the same image cache entry, so
  // whichever request lands first decides whether the other one works. A
  // thumbnail cached without CORS makes fabric's later CORS load fail;
  // tagging the thumbnail with crossorigin to match just moves the
  // breakage onto the thumbnail. There is no attribute combination that
  // fixes both, because the problem is that they share the entry at all.
  //
  // fetch gives the canvas its own request, and the resulting blob: URL
  // is same-origin — so thumbnails stay plain <img> that always render,
  // and the export canvas can never be tainted.
  var blobUrls = {};   // original https URL -> object URL
  // Extra object properties carried through every serialization.
  var SCENE_PROPS = ['sbSrc','sbLabel','sbStrokePct','sbBaseW','sbBgSrc','sbBgOn'];

  function loadArtwork(url){
    if(blobUrls[url]) return Promise.resolve(blobUrls[url]);
    if(!window.fetch || /^(data|blob):/.test(url)) return Promise.resolve(url);
    // cache:'reload' is load-bearing, not belt-and-braces. fetch shares
    // the HTTP cache with <img>, so a thumbnail already cached from a
    // no-cors request hands this fetch a response with no ACAO header and
    // the CORS check fails — the very problem the blob detour exists to
    // avoid. Forcing one revalidated round trip puts a properly
    // CORS-approved entry in the cache; blobUrls memoizes the result, so
    // this costs a single request per distinct artwork per session.
    return builderRetry(function(){ return builderFetch(url, { mode: 'cors', credentials: 'omit', cache: 'reload' }, true)
      .then(function(r){
        if(!r.ok){ var err = new Error('artwork ' + r.status); err.status = r.status; throw err; }
        return r.blob();
      }); })
      .then(function(b){
        blobUrls[url] = URL.createObjectURL(b);
        return blobUrls[url];
      })
      .catch(function(err){
        // The host does not allow cross-origin reads. Load it directly so
        // the shopper can still see and place it; exportSide's guard is
        // what reports the tainted canvas if it comes to that.
        warn('[ShirtBuilder] blob fetch failed, loading directly', url, err);
        return url;
      });
  }

  // fabric sets crossOrigin on anything that is not a data: URL, and
  // setting it on a blob: URL is both pointless and, in some browsers,
  // harmful. Only ask for it when we actually fell back to the remote
  // address.
  function imgOpts(src, original){
    return { crossOrigin: src === original ? 'anonymous' : null };
  }

  function releaseArtwork(){
    Object.keys(blobUrls).forEach(function(k){
      try { URL.revokeObjectURL(blobUrls[k]); } catch(e){}
    });
    blobUrls = {};
  }

  // ============================================================
  // ADDING OBJECTS
  // ============================================================
  // fabric hands a control's mouseUpHandler (eventData, target, control) —
  // the OBJECT, not a transform. Reading `transform.target` here made both
  // corner buttons throw on undefined and do nothing at all.
  var controlHandlers = {
    remove: function(eventData, target){
      if(!target || !target.canvas) return true;
      // Hold the canvas: remove() clears target.canvas, so reading it again
      // afterwards throws.
      var c = target.canvas;
      closeCanvasMenu();
      c.remove(target);
      c.renderAll();
      showPanel('add');
      return true;
    },
    dupe: function(eventData, target){
      if(!target || !target.canvas) return true;
      closeCanvasMenu();
      dupeObject(target);
      return true;
    },
    layer: function(eventData, target){
      if(!target || !target.canvas) return true;
      // Same two explicit choices the rail offers, so the corner button and
      // the panel button behave identically rather than one of them
      // guessing a direction.
      openCanvasMenu(target);
      return true;
    }
  };

  // ============================================================
  // BACKGROUND REMOVAL
  // ============================================================
  // The cutout is a SEPARATE address, kept beside the original rather than
  // replacing it, so the toggle is reversible and costs one model run per
  // distinct artwork. sbSrc is always the original; sbBgSrc is the cutout;
  // sbBgOn says which one is on the shirt. All three ride in the scene, so
  // a reopened design comes back showing what it was saved showing.
  var BGR_URL = 'https://dix7ak1o8b.execute-api.us-east-1.amazonaws.com/dev/public/backgroundRemoval';
  // Session-wide, keyed by source address: the same artwork placed twice,
  // or on both sides, must not pay for the model twice.
  var bgCache = {};

  function effectiveSrc(o){
    if(!o) return '';
    return (o.sbBgOn && o.sbBgSrc) ? o.sbBgSrc : (o.sbSrc || '');
  }

  function canRemoveBg(o){
    return !!(o && o.type === 'image' && o.sbSrc && /^https:/i.test(o.sbSrc));
  }

  // Swap the element's pixels for the other address, keeping the artwork
  // where and how big it was. The cutout is trimmed and re-encoded, so its
  // intrinsic size differs from the original's: preserving the DISPLAYED
  // width (and the centre, which these objects are positioned by) is what
  // makes the toggle feel like a toggle instead of a reposition. Reading
  // the width back from the object each time keeps repeated toggling
  // stable rather than drifting.
  function swapArtwork(o, url){
    var shownW = o.getScaledWidth();
    return loadArtwork(url).then(function(src){
      return new Promise(function(resolve){
        o.setSrc(src, function(){
          var intrinsic = o.width || 1;
          var scale = shownW / intrinsic;
          o.set({ scaleX: scale, scaleY: scale });
          o.setCoords();
          // Belt and braces. objectCaching is on by default and neither
          // setElement() nor a scaleX/scaleY change marks the object dirty,
          // so in principle a render could re-blit the stale bitmap. In
          // practice the cutout is trimmed and re-encoded, so its intrinsic
          // size differs and fabric's own isCacheDirty() catches the change
          // in cache-canvas dimensions — removing this line does NOT
          // reproduce the bug. It stays because a cutout that happened to
          // match the original's dimensions exactly would slip through, and
          // one assignment is cheaper than relying on that never happening.
          o.dirty = true;
          var c = o.canvas;
          // Synchronous by convention here — see the note on renderAll
          // above ensureCanvas().
          if(c) c.renderAll();
          resolve();
        }, { crossOrigin: 'anonymous' });
      });
    });
  }

  function setBgBusy(o, busy){
    if(o) o.sbBgBusy = !!busy;
    syncBgControls();
  }

  // Both switches show one object's state, so they are painted together.
  function syncBgControls(){
    var o = active();
    var eligible = canRemoveBg(o);
    var busy = !!(o && o.sbBgBusy);
    var on = !!(o && o.sbBgOn);

    var row = $('sb-i-bgr-row');
    if(row) row.style.display = eligible ? '' : 'none';

    [['sb-i-bgr', 'sb-i-bgr-wait'], ['sb-bgr-chip-sw', 'sb-bgr-chip-wait']].forEach(function(ids){
      var sw = $(ids[0]), wait = $(ids[1]);
      if(!sw || !wait) return;
      // The spinner takes the switch's place rather than sitting beside it,
      // so the row keeps its width and there is nothing to click twice.
      sw.hidden = busy;
      wait.hidden = !busy;
      sw.classList.toggle('on', on);
      sw.setAttribute('aria-checked', on ? 'true' : 'false');
      sw.disabled = !eligible;
    });

    var note = $('sb-i-bgr-note');
    if(note){
      note.textContent = on
        ? 'Background removed from preview.'
        : 'Cuts the subject out of its background.';
    }

    var chip = $('sb-bgr-chip');
    if(chip){
      // Never while a drag is hiding the element's UI. The chip is one of
      // the things that goes away so the artwork can be seen, and hiding
      // it once at the start of the drag is not enough: fabric selecting
      // the target fires onSelect, which repaints the whole panel through
      // here and put the chip straight back. One guard at the only place
      // that opens it beats chasing every caller.
      var show = eligible && !dragHidden;
      chip.classList.toggle('open', show);
      if(show) placeBgrChip();
    }
  }

  // Anchored under the element's on-screen bounding box, which already
  // accounts for rotation, so the chip tracks the artwork through every
  // transform rather than only sitting under an axis-aligned box.
  function placeBgrChip(){
    var chip = $('sb-bgr-chip'), o = active(), c = canvas(), host = $('sb-stage-main');
    if(!chip || !o || !c || !host) return;
    var hRect = host.getBoundingClientRect();
    // Freshly calculated, for the reason placeCenterGuide() spells out.
    var box = o.getBoundingRect(false, true);
    var cRect = c.lowerCanvasEl.getBoundingClientRect();
    // The gap has to clear the corner handles that hang off the box, not
    // just the box: the resize node sits directly above this chip on the
    // right, and a thumb reaching for it was catching the toggle instead.
    // Twice the spacing it used to have, and more again on a phone, where
    // the handles are finger-sized and reach further past the edge.
    var gap = isMobile() ? 48 : 28;
    chip.style.left = Math.round(cRect.left - hRect.left + box.left + box.width / 2) + 'px';
    chip.style.top  = Math.round(cRect.top  - hRect.top  + box.top + box.height + gap) + 'px';
  }

  function hideBgrChip(){
    var chip = $('sb-bgr-chip');
    if(chip) chip.classList.remove('open');
  }

  // One request per distinct source address, ever. A cutout already on the
  // object (a reopened design) or in the session cache (the same artwork
  // used twice) is reused without touching the endpoint.
  function fetchCutout(o){
    var src = o.sbSrc;
    if(o.sbBgSrc) return Promise.resolve(o.sbBgSrc);
    if(bgCache[src]) return Promise.resolve(bgCache[src]);
    if(!window.fetch) return Promise.reject(new Error('fetch unavailable'));
    return fetch(BGR_URL + '?url=' + encodeURIComponent(src), { credentials: 'omit' })
      .then(function(r){ return r.json().catch(function(){ return null; }); })
      .then(function(d){
        if(!d || !d.success || !d.url) throw new Error((d && d.error) || 'no cutout returned');
        bgCache[src] = d.url;
        return d.url;
      });
  }

  function toggleBackgroundRemoval(){
    var o = active();
    if(!canRemoveBg(o) || o.sbBgBusy) return;

    track('builder-bg-toggle', {
      turning: o.sbBgOn ? 'off' : 'on',
      url: logUrl(o.sbSrc),
      // A cutout already fetched this session costs no request; knowing
      // the split is what says whether the endpoint is being hammered.
      cached: !o.sbBgOn && !!(o.sbBgSrc || bgCache[o.sbSrc])
    });
    // Turning it off never needs the network — the original is still there.
    if(o.sbBgOn){
      o.sbBgOn = false;
      swapArtwork(o, o.sbSrc).then(function(){
        syncBgControls();
        syncPanel();
        capture();
      });
      return;
    }

    setBgBusy(o, true);
    fetchCutout(o).then(function(url){
      o.sbBgSrc = url;
      o.sbBgOn = true;
      return swapArtwork(o, url);
    }).then(function(){
      setBgBusy(o, false);
      syncPanel();
      capture();
    }).catch(function(err){
      // Leave the artwork exactly as it was and say so, rather than
      // flipping a switch that did nothing.
      o.sbBgOn = false;
      setBgBusy(o, false);
      warn('[ShirtBuilder] background removal failed', err);
      showMessageSafe('Remove Background',
        'The background could not be removed from this image. Please try again.');
    });
  }

  function place(obj, box){
    obj.set({ originX:'center', originY:'center', left: box.cx, top: box.cy });
  }

  /*
   * Replace the selected image, keeping where and how big it is.
   *
   * sbBaseW is recomputed from the NEW image rather than carried over: it is
   * the width this image would have arrived at, and the Size slider reads as
   * a percentage of it. Carrying the old one over would leave the slider
   * saying 124% of a number belonging to a picture that is no longer there.
   */
  function replaceImage(url, label){
    var v = view();
    var old = active();
    if(!v || !old || old.type === 'sb-text') return;

    setBusy(true, 'Replacing artwork…');
    loadArtwork(url).then(function(src){
      fabric.Image.fromURL(src, function(img){
        setBusy(false);
        if(!img || !img.width){
          showError('sb-up-err', 'That image could not be loaded. Please try another file.');
          return;
        }

        var box = dropBox(v);
        // What it would have been at if it were being added now, which is what
        // the Size slider is a percentage of.
        var fresh = Math.min(box.w / img.width, box.h / img.height);
        img.sbBaseW = img.width * fresh;

        // And what it is: the width the picture it replaces occupied.
        // width * scaleX rather than getScaledWidth(), which adds stroke and
        // padding and would land a couple of pixels out.
        var scale = (old.width * old.scaleX) / img.width;
        img.set({
          scaleX: scale,
          scaleY: scale,
          left: old.left,
          top: old.top,
          originX: old.originX,
          originY: old.originY,
          angle: old.angle,
          flipX: old.flipX,
          flipY: old.flipY
        });
        img.sbSrc = url;
        img.sbLabel = label || '';
        applyControls(fabric, img, controlHandlers);

        // Back into the same place in the stack, so anything layered over or
        // under it stays where it was.
        var at = v.canvas.getObjects().indexOf(old);
        v.canvas.remove(old);
        if(at > -1) v.canvas.insertAt(img, at, false); else v.canvas.add(img);
        v.canvas.setActiveObject(img);
        v.canvas.renderAll();
        syncPanel();
        // One undo step, so Replace can be taken back like any other edit.
        capture();
      }, imgOpts(src, url));
    });
  }

  // Borrows Add Images the same way the feature photo does.
  function pickReplacement(){
    var o = active();
    if(!o || o.type === 'sb-text') return;
    ccsPick = function(url, label){ replaceImage(url, label); };
    openTool('images');
  }

  // Set while Add Images is being borrowed to choose an image for something
  // else. Cleared the moment it is used, so a stray later upload cannot be
  // routed somewhere the seller has stopped looking.
  var ccsPick = null;

  function addImage(url, label){
    if(ccsPick){
      var claim = ccsPick;
      ccsPick = null;
      closeTool();
      $('sb-all-ov').classList.remove('open');
      claim(url, label);
      return;
    }
    var v = view();
    if(!v) return;
    setBusy(true, 'Adding artwork…');
    track('builder-add-image', {
      url: logUrl(url),
      label: logStr(label, 80),
      side: v.id,
      objects_before: v.canvas ? v.canvas.getObjects().length : 0
    });
    loadArtwork(url).then(function(src){
      fabric.Image.fromURL(src, function(img){
        setBusy(false);
        if(!img || !img.width){
          showError('sb-up-err', 'That image could not be loaded. Please try another file.');
          trackFail('shirt-builder-image-load-failed', null, { url: logUrl(url) });
          return;
        }
        var box = dropBox(v);
        var scale = Math.min(box.w / img.width, box.h / img.height);
        img.set({ scaleX: scale, scaleY: scale });
        // sbSrc keeps the canonical https address. `src` may be a blob:
        // URL that dies with this page, so it is never what we persist.
        img.sbSrc = url;
        img.sbLabel = label || '';
        // Remember the size it arrived at: the Size slider is relative to it.
        img.sbBaseW = img.getScaledWidth();
        place(img, box);
        applyControls(fabric, img, controlHandlers);
        v.canvas.add(img);
        v.canvas.setActiveObject(img);
        v.canvas.renderAll();
        showPanel('image');
      }, imgOpts(src, url));
    });
  }

  function addText(str){
    var v = view();
    if(!v || !str) return;
    var box = dropBox(v);
    var font = defaultFont();
    var t = new fabric.SbText(str, {
      fontFamily: font.css,
      fontSize: 100,
      // fabric's 1.16 default, multiplied by its own 1.13 font-size
      // factor, leaves each line occupying ~1.31x the font size — fine
      // for a paragraph, far too airy for the two or three display words
      // that actually go on a shirt. This lands just under 1x, which is
      // the tight setting shirt art is normally drawn at.
      lineHeight: 0.86,
      fill: '#000000',
      stroke: null,
      strokeWidth: 0,
      // Stroke under the fill, so an outline grows outwards instead of
      // eating into the letterforms. fabric defaults to 'fill', which
      // strokes on top and thins the glyph as the outline thickens.
      paintFirst: 'stroke',
      // A shirt outline is a flat band. Nothing here may soften it into
      // a glow, so the shadow is pinned off rather than left to default.
      shadow: null,
      textAlign: 'center',
      charSpacing: 0,
      arc: 0
    });
    // Start at the print width so the first thing the shopper sees is a
    // sensible size, then let the Size slider take over from there.
    var natural = t.width || box.w;
    t.set({ fontSize: clamp(Math.round(100 * box.w / natural), 12, 400) });
    place(t, box);
    applyControls(fabric, t, controlHandlers);
    v.canvas.add(t);
    track('builder-add-text', Object.assign({ side: v.id }, logElement(t) || {}));
    v.canvas.setActiveObject(t);
    // Shut, so the shirt is the first thing seen: fresh text wants
    // dragging and sizing before it wants a font, and the panel covers
    // the garment it is being dragged on. Set rather than left alone
    // because the sheet may still be open from the last piece of text.
    // The collapsed Edit Text header is what advertises the controls.
    if(isMobile()) setSheet('closed');
    // The default face may still be in flight on a cold open; re-measure
    // as soon as it lands so the box matches the glyphs.
    sbDiagLog('addText:created', t);
    whenFontReady(font.css).then(function(){
      t.initDimensions();
      t.setCoords();
      sbDiagLog('addText:afterFontReady', t);
      v.canvas.renderAll();
      // object:added already captured a snapshot, measured against
      // whatever font existed then. Overwrite it rather than pushing a
      // new entry: this is the same state, correctly measured, and an
      // extra undo step here would be noise.
      recapture();
      syncPanel();
      scheduleElements();
    });
    v.canvas.renderAll();
    showPanel('text');
  }

  // ============================================================
  // OBJECT ACTIONS (shared by the text and image panels)
  // ============================================================
  function objCenter(){
    var o = active(), v = view();
    if(!o || !v) return;
    var box = dropBox(v);
    o.set({ left: box.cx, top: box.cy });
    o.setCoords();
    v.canvas.renderAll();
    // Same confirmation a drag-snap gives, so the button and the snap read
    // as the same thing having happened.
    showCenterGuide();
    capture();
  }

  // One step in an explicit direction. The rail offers both directions as
  // separate choices, so this never has to guess or wrap around.
  function objLayer(dir){
    var o = active(), c = canvas();
    if(!o || !c) return;
    if(dir === 'backward') c.sendBackwards(o);
    else                   c.bringForward(o);
    c.renderAll();
    syncSubmenus();
    capture();
  }

  function objFlip(axis){
    var o = active();
    if(!o) return;
    o.set(axis === 'v' ? 'flipY' : 'flipX', !(axis === 'v' ? o.flipY : o.flipX));
    canvas().renderAll();
    capture();
  }

  // Takes the object explicitly: the corner handle is handed its own
  // target by fabric, and reading the active object instead would copy
  // the wrong thing the moment those two disagree.
  function dupeObject(o){
    var c = o && o.canvas;
    if(!o || !c) return;
    o.clone(function(copy){
      copy.set({ left: o.left + 24, top: o.top + 24 });
      copy.sbSrc = o.sbSrc;
      copy.sbBgSrc = o.sbBgSrc;
      copy.sbBgOn = o.sbBgOn;
      copy.sbLabel = o.sbLabel;
      applyControls(fabric, copy, controlHandlers);
      c.add(copy);
      c.setActiveObject(copy);
      c.renderAll();
      capture();
      scheduleElements();
    }, ['sbSrc','sbLabel','sbStrokePct','sbBaseW','sbBgSrc','sbBgOn']);
  }

  function objDupe(){ dupeObject(active()); }

  function objDelete(){
    var o = active(), c = canvas();
    if(!o || !c) return;
    c.remove(o);
    c.renderAll();
    showPanel('add');
  }

  // ============================================================
  // RAIL PANELS
  // ============================================================
  // Open one sub-menu at a time, within the panel that owns it. Passing a
  // falsy name closes whatever is open.
  function openSubmenu(panel, name){
    if(!panel) return;
    Array.prototype.forEach.call(panel.querySelectorAll('.sb-submenu'), function(m){
      m.classList.toggle('open', m.getAttribute('data-menu') === name);
    });
    Array.prototype.forEach.call(panel.querySelectorAll('[data-sb="obj-menu"]'), function(b){
      b.classList.toggle('open', b.getAttribute('data-menu') === name);
    });
    if(name) syncSubmenus();
  }

  // How close the centre has to get before it clicks into place, in screen
  // pixels. Converted to design units per call because the canvas zoom
  // changes with the window — a magnet measured in design units would feel
  // twice as strong on a small screen.
  var SNAP_PX = 9;
  // Breaking OUT of the horizontal centre takes more than getting into it.
  // With one symmetric band, dragging vertically along the centre line
  // knocked the artwork off centre on the slightest sideways wobble — the
  // pointer only has to stray 9px to lose a line the shopper is trying to
  // hold. A wider release band makes the centre feel magnetic instead of
  // twitchy, which is the whole point of snapping to it.
  var CENTER_RELEASE_PX = 26;
  // A quarter strength on a phone. A finger is a far coarser pointer than
  // a cursor, and at full strength the magnet took the artwork away from
  // where the thumb was putting it — the snap stopped reading as help and
  // started reading as the canvas disagreeing. Half was still too much.
  // In screen pixels that leaves a 2px band to enter the centre line and
  // 6px to leave it: enough to land on exactly centred if that is what is
  // being aimed for, not enough to pull artwork there that is not.
  function snapScale(){ return isMobile() ? 0.25 : 1; }

  // Holding Shift turns every magnet off for as long as it is down, which
  // is the escape hatch for placing something deliberately just off centre
  // or at an angle the snap keeps eating.
  //
  // Read off the event rather than tracked as state: a keyup that lands
  // while the window is unfocused never arrives, and a stuck flag would
  // leave snapping silently dead until the page reloaded.
  function snapOverridden(e){
    var src = e && (e.e || e);
    return !!(src && src.shiftKey);
  }

  // Pin a dragged object to the design's centre lines. While it is held
  // there the pointer can keep moving without the object following, which
  // is what makes the snap noticeable without being sticky enough to fight.
  //
  // The targets are the same point the Center button uses, so a dragged
  // element and a clicked one come to rest in exactly the same place.
  // How far the dashed arms reach past the artwork, in screen pixels. The
  // outer two thirds fade out (see .sb-center-up / -down), so the reach is
  // long without the line itself being heavy.
  var CENTER_ARM = 192;
  // Where the label sits above the artwork. Fixed, not a fraction of the
  // arm: it wants to stay near the artwork it is labelling.
  var CENTER_WORD_UP = 52;
  // Whether the drag was already sitting on the centre line last frame, so
  // the guide fires on the transition INTO the snap rather than on every
  // mouse move that happens to stay inside it.
  var wasCenterSnapped = false;
  var centerHideTimer = null;
  var centerFadeTimer = null;
  // True between mouse/touch down and up on the canvas. While the shopper is
  // still holding the artwork the guide is live information, so it stays
  // solid; the fade is a dismissal AFTER they let go.
  var pointerDown = false;
  var CENTER_HOLD_MS = 1500;   // solid time once the drag ends
  var CENTER_FADE_MS = 800;    // must match the CSS animation duration

  // ── Snap to centre: OFF for now ────────────────────────────────────
  // Flip this to true to bring it back. Nothing has been removed — the
  // pull, the guide, the release band and the Center button's confirmation
  // are all still here and all still wired.
  //
  // Why it is off: both the pull and the line are computed from the
  // element's BOUNDING BOX, and a lot of uploaded artwork is not centred
  // inside its own transparent margins. The box lands dead centre while
  // the picture in it sits visibly to one side, so the snap pulls toward a
  // centre that is not the one the shopper can see and the line claims a
  // centre that is not one either. Until artwork is trimmed on upload (or
  // the centre is measured from opaque pixels) it costs more than it gives.
  //
  // The Center BUTTON still centres — it just does it without raising the
  // guide, because the guide would make the same false claim.
  var CENTER_SNAP_ON = false;

  function snapWhileMoving(e){
    var o = e && e.target, v = view(), c = canvas();
    if(!o || !v || !c) return;
    // Disabled, deliberately and reversibly. Handled here rather than by
    // unhooking the caller so the whole feature stays on one switch.
    if(!CENTER_SNAP_ON){
      if(centerGuideShowing()) hideCenterGuide();
      wasCenterSnapped = false;
      return;
    }
    // Shift held: no pull, and no guide either — a line drawn where the
    // artwork is not going to land is worse than no line.
    if(snapOverridden(e)){
      if(centerGuideShowing()) hideCenterGuide();
      wasCenterSnapped = false;
      return;
    }
    var box = dropBox(v);
    var zoom = c.getZoom() || 1;
    var k = snapScale();
    var tol = SNAP_PX * k / zoom;
    // Already on the line? Then it takes the wider band to leave it.
    var xBand = (wasCenterSnapped ? CENTER_RELEASE_PX : SNAP_PX) * k / zoom;
    var onCenter = Math.abs(o.left - box.cx) < xBand;
    if(onCenter) o.left = box.cx;
    if(Math.abs(o.top - box.cy) < tol) o.top = box.cy;
    // Only the horizontal centre gets a guide — that is the one shoppers
    // line up by eye, and the one the Center button shares.
    if(onCenter && !wasCenterSnapped) showCenterGuide();
    else if(onCenter) placeCenterGuide();
    else if(centerGuideShowing()) hideCenterGuide();
    wasCenterSnapped = onCenter;
  }

  // Where the onboarding card sits, in stage pixels.
  //
  // Anchored to the garment PHOTO, not to the print area. dropBox() comes
  // the middle of the garment photo plus a default width — a polo or a
  // hoodie prints nothing like a tee, so that box is not something to
  // position a card by, let alone draw on screen. The canvas frame is
  // always exactly the garment image, whatever the garment is.
  // Both leave-the-builder affordances mean something different once this
  // is an existing cart design: there is no new design to cancel and no
  // quick flow to switch to — there is a cart to go back to.
  function syncCartEditChrome(){
    // There is no cart to return to and no quick flow to switch to, so
    // both links stay away rather than pointing at nothing. Hidden here as
    // well as removed from the markup: this runs on every chrome sync and
    // would otherwise un-hide whatever it found.
    var quick = $('sb-quick-link');
    if(quick) quick.hidden = true;
    var headQuick = $('sb-head-quick');
    if(headQuick) headQuick.hidden = true;
    var cancel = document.querySelector('.sb-cancel');
    if(cancel) cancel.textContent = 'Close';
  }

  function syncEmptyState(){
    var start = $('sb-start');
    if(!start) return;
    var v = view(), host = $('sb-stage-main');
    // Across BOTH sides, not just the one on screen. "Start Your Design" is
    // an invitation to begin, so it has no business appearing on the back
    // of a shirt whose front is already designed — at that point they have
    // started, and the card reads as having lost their work.
    var empty = !!(v && v.canvas) && !hasArtwork();
    start.classList.toggle('open', empty);
    syncSheetAvailability();
    if(!empty || !host || !v.canvas) return;
    var cRect = v.canvas.lowerCanvasEl.getBoundingClientRect();
    var hRect = host.getBoundingClientRect();
    // A third of the way down the garment is the chest on every full-length
    // product shot we use.
    start.style.left = Math.round(cRect.left - hRect.left + cRect.width / 2) + 'px';
    start.style.top = Math.round(cRect.top - hRect.top + cRect.height * 0.33) + 'px';
  }

  // Anchored to the element's on-screen bounding box, so the arms stay
  // attached through rotation and scaling like the rest of the overlay.
  function placeCenterGuide(){
    var wrap = $('sb-center'), up = $('sb-center-up'), down = $('sb-center-down');
    var word = $('sb-center-word');
    var o = active(), c = canvas(), host = $('sb-stage-main');
    if(!wrap || !up || !down || !word || !o || !c || !host) return;
    // getBoundingRect(false, true): the second argument is `calculate`, and
    // without it fabric hands back cached lineCoords. Those are refreshed in
    // setCoords(), which fabric calls when a transform ENDS — never during
    // one. So an overlay anchored to the plain call freezes at the position
    // the element had when it first appeared and only catches up on mouse
    // up. Costs one matrix multiply per frame.
    var box = o.getBoundingRect(false, true);
    var cRect = c.lowerCanvasEl.getBoundingClientRect();
    var hRect = host.getBoundingClientRect();
    var cx = Math.round(cRect.left - hRect.left + box.left + box.width / 2);
    var top = Math.round(cRect.top - hRect.top + box.top);
    var bottom = top + Math.round(box.height);
    up.style.left = cx + 'px';
    up.style.top = (top - CENTER_ARM) + 'px';
    up.style.height = CENTER_ARM + 'px';
    down.style.left = cx + 'px';
    down.style.top = bottom + 'px';
    down.style.height = CENTER_ARM + 'px';
    word.style.left = cx + 'px';
    word.style.top = (top - CENTER_WORD_UP) + 'px';
  }

  function showCenterGuide(){
    var wrap = $('sb-center');
    if(!wrap || !active() || !CENTER_SNAP_ON) return;
    placeCenterGuide();
    // Re-adding a class the element already has is a no-op, so a re-snap
    // would not replay the fade. Drop both classes, force the style change
    // to land by reading a layout property, then re-add — which restarts
    // any animation from 0%. Synchronous on purpose: requestAnimationFrame
    // does not fire in a backgrounded or occluded tab, which would strand
    // it hidden.
    clearCenterTimers();
    wrap.classList.remove('show');
    wrap.classList.remove('fading');
    void wrap.offsetWidth;
    wrap.classList.add('show');
    armCenterFade();
  }

  function clearCenterTimers(){
    if(centerHideTimer){ clearTimeout(centerHideTimer); centerHideTimer = null; }
    if(centerFadeTimer){ clearTimeout(centerFadeTimer); centerFadeTimer = null; }
  }

  // No fade while the pointer is down — the guide is telling the shopper
  // something about the drag they are still doing. Releasing arms it.
  function armCenterFade(){
    clearCenterTimers();
    if(pointerDown || !centerGuideShowing()) return;
    centerFadeTimer = setTimeout(function(){
      var wrap = $('sb-center');
      if(!wrap || !wrap.classList.contains('show')) return;
      wrap.classList.add('fading');
      // The animation settles at opacity 0 but the element is still laid
      // out, so drop it once the fade has finished.
      centerHideTimer = setTimeout(hideCenterGuide, CENTER_FADE_MS);
    }, CENTER_HOLD_MS);
  }

  // Keyed on what is actually on screen rather than on wasCenterSnapped,
  // so dragging away also dismisses a guide raised by the Center button —
  // that path never sets the flag.
  function centerGuideShowing(){
    var wrap = $('sb-center');
    return !!(wrap && wrap.classList.contains('show'));
  }

  // Dropping the class hits display:none at once, with no fade. Leaving the
  // centre is the shopper undoing the thing the guide is confirming, so it
  // goes immediately rather than lingering.
  function hideCenterGuide(){
    var wrap = $('sb-center');
    if(wrap){ wrap.classList.remove('show'); wrap.classList.remove('fading'); }
    clearCenterTimers();
    wasCenterSnapped = false;
  }

  // Anchor the menu under the object's bottom-left control. oCoords are in
  // canvas pixels, so they are offset by where the canvas sits inside the
  // stage — the menu lives in the stage, not the canvas wrapper, because
  // resetStage() clears that wrapper on every open.
  // fabric fires a control's mouseUpHandler on mouseup; the browser then
  // delivers a click on the canvas, which the dismiss-on-outside-click
  // handler read as "close". Swallow exactly that one click.
  var canvasMenuJustOpened = false;

  function openCanvasMenu(target){
    var menu = $('sb-cmenu'), c = canvas(), host = $('sb-stage-main');
    if(!menu || !c || !host || !target) return;
    target.setCoords();
    var bl = target.oCoords && target.oCoords.bl;
    if(!bl) return;
    var cRect = c.lowerCanvasEl.getBoundingClientRect();
    var hRect = host.getBoundingClientRect();
    menu.style.left = Math.round(cRect.left - hRect.left + bl.x) + 'px';
    menu.style.top  = Math.round(cRect.top  - hRect.top  + bl.y + 20) + 'px';
    menu.classList.add('open');
    canvasMenuJustOpened = true;
    syncSubmenus();
  }
  function closeCanvasMenu(){
    var menu = $('sb-cmenu');
    if(menu) menu.classList.remove('open');
    canvasMenuJustOpened = false;
  }

  function closeSubmenus(){
    closeCanvasMenu();
    Array.prototype.forEach.call(document.querySelectorAll('#sb-rail .sb-submenu'), function(m){
      m.classList.remove('open');
    });
    Array.prototype.forEach.call(document.querySelectorAll('#sb-rail [data-sb="obj-menu"]'), function(b){
      b.classList.remove('open');
    });
  }

  // Grey out a direction the object is already at the end of, so the
  // sub-menu says what will actually happen.
  function syncSubmenus(){
    var o = active(), c = canvas();
    if(!o || !c) return;
    var objs = c.getObjects();
    var i = objs.indexOf(o);
    var noForward  = i === objs.length - 1;
    var noBackward = i <= 0;
    Array.prototype.forEach.call(document.querySelectorAll('[data-sb="obj-forward"]'), function(b){
      b.disabled = noForward;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-sb="obj-backward"]'), function(b){
      b.disabled = noBackward;
    });
    // With nothing to move past — a lone element — the menu holds two dead
    // options, so the button that opens it is dead too. Say so on the
    // button rather than making them open it to find out.
    var dead = noForward && noBackward;
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-sb="obj-menu"][data-menu="layer"]'), function(b){
        b.disabled = dead;
        b.title = dead ? 'Nothing to layer — this is the only element'
                       : 'Change stacking order';
        // It can go dead while open, if the other element was just removed.
        if(dead) b.classList.remove('open');
      });
    if(dead){
      Array.prototype.forEach.call(
        document.querySelectorAll('.sb-submenu[data-menu="layer"]'), function(m){
          m.classList.remove('open');
        });
      closeCanvasMenu();
    }
  }

  // ============================================================
  // MOBILE SHEET
  // ============================================================
  // On a phone the rail is a sheet over the shirt with three positions:
  // closed (the handle alone, still on screen), peek (roughly a third,
  // enough for the controls that matter without burying the garment) and
  // full. Everything here no-ops above the breakpoint, so the desktop
  // layout has one code path and it is the one it always had.
  var SHEET_STATES = ['closed', 'peek', 'full'];
  var sheetState = 'closed';
  var mobileQuery = window.matchMedia ? window.matchMedia('(max-width:900px)') : null;
  function isMobile(){ return !!(mobileQuery && mobileQuery.matches); }

  // What the handle says it is showing, so the sheet names its contents
  // rather than being an anonymous drawer.
  var PANEL_TITLES = { add: 'Design', text: 'Edit Text', image: 'Edit Image' };

  function activePanelName(){
    var found = 'add';
    ['add', 'text', 'image'].forEach(function(p){
      var el = $('sb-p-' + p);
      if(el && el.classList.contains('active')) found = p;
    });
    return found;
  }

  // On a phone the drawer exists for exactly one thing: the font, colour,
  // outline and arc controls of a selected piece of text, which have
  // nowhere else to live. Every other state has nothing to put in it —
  // an image carries delete, duplicate, rotate, resize and layer on its
  // own bounding box, and with nothing selected there is nothing to edit
  // at all — so the sheet goes rather than sitting over the garment as a
  // bare grab handle.
  function sheetSuppressed(){
    if(!isMobile()) return false;
    var o = active();
    return !(o && o.type === 'sb-text');
  }

  // Published on the overlay so rules outside the sheet can respond to
  // it — the garment furniture has to move out from under the header the
  // sheet leaves on screen while text is selected. Written here as well
  // as in setSheet because adding text deliberately skips setSheet, and
  // the class still has to describe the sheet that is on screen.
  function markSheetState(){
    var ov = $('sb-ov');
    if(ov) ov.classList.toggle('sb-sheet-shut', sheetState === 'closed');
  }

  function syncSheetAvailability(){
    var off = sheetSuppressed(), ov = $('sb-ov'), o = active();
    if(ov){
      ov.classList.toggle('sb-nosheet', off);
      // With text selected the sheet header stays on screen whatever the
      // sheet is doing. It is the only place the panel is named on a
      // phone, and the way back into the controls, so closing the sheet
      // must not be able to reduce it to an anonymous handle.
      ov.classList.toggle('sb-textsel', isMobile() && !!(o && o.type === 'sb-text'));
    }
    markSheetState();
    // A sheet left open from a moment ago would otherwise be stranded.
    if(off && sheetState !== 'closed') setSheet('closed');
  }

  function setSheet(state){
    if(SHEET_STATES.indexOf(state) < 0) return;
    sheetState = state;
    var rail = $('sb-rail'), grip = $('sb-grip');
    if(!rail) return;
    rail.classList.remove('peek', 'full');
    if(state !== 'closed') rail.classList.add(state);
    // Hand control back to the classes, including the reserve a free
    // drag sized for its own position.
    rail.style.transform = '';
    rail.style.paddingBottom = '';
    markSheetState();
    if(grip) grip.setAttribute('aria-expanded', state === 'closed' ? 'false' : 'true');
    syncSheetChrome();
  }

  function syncSheetChrome(){
    var panel = activePanelName();
    var label = $('sb-grip-label');
    if(label) label.textContent = PANEL_TITLES[panel] || 'Design';
    // Whichever dock entry opened the sheet stays marked while it is up.
    var notes = $('sb-dock-notes');
    if(notes) notes.classList.toggle('is-active', !!(view() && view().notes));
  }

  // The header strip is the least the sheet can usefully show, and so the
  // floor a drag can push it to. Read off the element so it cannot drift
  // away from the stylesheet that sizes it.
  function gripHeight(){
    var g = $('sb-grip');
    return (g && g.offsetHeight) || 44;
  }

  // Dragged down to less than this much showing, the sheet just shuts:
  // what is left at that point is the header and a sliver of the first
  // control, which is no use to anyone, and half a control on screen
  // looks like a mistake rather than a position.
  var SHEET_SHUT_SNAP = 80;

  // Where a drag left it. The fixed stops are for the header tap, which
  // has no position to honour; a finger that chose a height gets to keep
  // it. The sheet still counts as open, so tapping the header closes it.
  function setSheetAt(off){
    var rail = $('sb-rail'), grip = $('sb-grip');
    if(!rail) return;
    var h = rail.offsetHeight || 1;
    // Close to shut is shut. The closed state owns a class and chrome of
    // its own, so it takes over rather than being imitated by an inline
    // transform parked near the bottom.
    if(h - off < SHEET_SHUT_SNAP){ setSheet('closed'); return; }
    sheetState = 'peek';
    rail.classList.remove('full');
    rail.classList.add('peek');
    off = Math.round(clamp(off, 0, h - gripHeight()));
    rail.style.transform = 'translateY(' + off + 'px)';
    // The reserve has to follow the position. It is the part of the sheet
    // below the fold — exactly this offset — and without it a sheet
    // dragged only a little way open cannot be scrolled to the rows it is
    // still hiding. The stylesheet does the same sum for the peek stop.
    rail.style.paddingBottom = (74 + off) + 'px';
    if(grip) grip.setAttribute('aria-expanded', 'true');
    markSheetState();
    syncSheetChrome();
  }

  // Open or shut, nothing in between: a tap on a header labelled Edit
  // Text is a request to see the controls or to get them out of the way,
  // and a three-way cycle meant the same tap did different things
  // depending on a position the shopper had to keep track of. Full is
  // still reachable — by dragging the handle, where the finger is
  // choosing the position directly.
  function toggleSheet(){
    setSheet(sheetState === 'closed' ? 'peek' : 'closed');
  }

  function openSheet(panel, state){
    if(panel) showPanel(panel);
    setSheet(state || 'peek');
  }

  // Dragging the handle. Written per frame during the drag and snapped to
  // the nearest position on release — a sheet that does not follow the
  // finger reads as broken on a phone, and a sheet that stops wherever it
  // is let go reads as unfinished.
  var gripSwallowClick = false;

  function bindSheetDrag(){
    var grip = $('sb-grip'), rail = $('sb-rail');
    if(!grip || !rail) return;
    var startY = 0, startOffset = 0, dragging = false, moved = false;

    // Where the sheet actually sits, read off its rendered transform.
    // Modelling it from the state instead is what went wrong before: the
    // drag believed peek was 0.52 of the sheet while the stylesheet put
    // it at 0.58, so every drag jumped on the first move. There is no
    // model that can be right now anyway — after a free drag the sheet is
    // wherever it was left.
    function currentOffset(){
      var t = getComputedStyle(rail).transform;
      if(!t || t === 'none') return 0;
      var n = t.match(/-?[\d.]+/g);
      return (n && n.length >= 6) ? parseFloat(n[5]) : 0;
    }

    grip.addEventListener('pointerdown', function(e){
      if(!isMobile()) return;
      gripSwallowClick = false;
      dragging = true; moved = false;
      startY = e.clientY;
      startOffset = currentOffset();
      rail.classList.add('sb-dragging');
      try { grip.setPointerCapture(e.pointerId); } catch(err){}
    });

    grip.addEventListener('pointermove', function(e){
      if(!dragging) return;
      var dy = e.clientY - startY;
      if(Math.abs(dy) > 3) moved = true;
      var h = rail.offsetHeight || 1;
      // Anywhere between fully open — the sheet's own height, which is
      // the ceiling — and down to just its header.
      var next = clamp(startOffset + dy, 0, h - gripHeight());
      rail.style.transform = 'translateY(' + next + 'px)';
    });

    function end(e){
      if(!dragging) return;
      dragging = false;
      rail.classList.remove('sb-dragging');
      try { grip.releasePointerCapture(e.pointerId); } catch(err){}
      // A tap is left to the click that follows, so it is handled once
      // and Enter/Space on the focused handle behave the same way.
      if(!moved) return;
      // A drag is followed by a compatibility click; swallow that one and
      // only that one. The guard expires on its own, because the click is
      // not guaranteed to arrive at all.
      gripSwallowClick = true;
      setTimeout(function(){ gripSwallowClick = false; }, 350);
      // Left where it was put. It used to jump to whichever of the three
      // stops was nearest, which threw away the height the shopper had
      // just chosen.
      setSheetAt(currentOffset());
    }
    grip.addEventListener('pointerup', end);
    grip.addEventListener('pointercancel', end);
  }

  function showPanel(which){
    ['add','text','image'].forEach(function(p){
      var el = $('sb-p-' + p);
      if(el) el.classList.toggle('active', p === which);
    });
    closeSubmenus();
    if(which !== 'text') closeSwatches();
    if(which === 'add' && canvas()) canvas().discardActiveObject().renderAll();
    syncPanel();
    $('sb-rail').scrollTop = 0;
    syncSheetChrome();
  }

  function onSelect(){
    var o = active();
    if(!o) return;
    showPanel(o.type === 'sb-text' ? 'text' : 'image');
    // Deliberately does not open the sheet. Selecting text shows the
    // collapsed Edit Text header, which says the controls are there
    // without taking the shirt off screen to prove it — and without
    // re-opening a panel the shopper has just closed.
    syncSheetAvailability();
    scheduleElements();
  }
  function onDeselect(){
    hideCenterGuide();
    showPanel('add');
    // Nothing selected means nothing to edit: give the garment the screen
    // back rather than leaving an open sheet over it.
    if(isMobile()) setSheet('closed');
    syncSheetAvailability();
    scheduleElements();
  }

  var TOOL_TITLES = { images: 'Add Images', text: 'Add Text' };

  // The three buttons open a dialog rather than swapping content inside
  // the rail. Inline bodies made them read as a tab strip — one always
  // looked selected even when the shopper was doing something else — and
  // pushed Design Elements far enough down the panel to get lost.
  function openTool(tool){
    ['images','text'].forEach(function(t){
      var body = $('sb-tb-' + t);
      if(body) body.classList.toggle('active', t === tool);
    });
    $('sb-add-title').textContent = TOOL_TITLES[tool] || 'Add to Your Design';
    $('sb-add-box').classList.toggle('images', tool === 'images');
    $('sb-add-ov').classList.add('open');
    if(tool === 'images'){
      $('sb-ai-grid').innerHTML = '';
      clearError('sb-ai-err');
      clearError('sb-up-err');
      renderRecent();
    }
    requestFonts();  // warm the cache while they are in here
    var focusEl = tool === 'text' ? $('sb-new-text') : null;
    if(focusEl) focusEl.focus();
  }

  // The shopper's previous uploads and AI picks, shown inside Add Images
  // the way the quick flow shows them — so reusing artwork never requires
  // hunting for it in a second dialog.
  function renderRecent(){
    var host = $('sb-recent');
    if(!host) return;
    var list = recent().slice(0, 6);
    var tile = '<button type="button" class="sb-see-tile" data-sb="see-all">' +
                 '<svg viewBox="0 0 20 20"><rect x="2" y="2" width="7" height="7" rx="1.5"/>' +
                 '<rect x="11" y="2" width="7" height="7" rx="1.5"/><rect x="2" y="11" width="7" height="7" rx="1.5"/>' +
                 '<rect x="11" y="11" width="7" height="7" rx="1.5"/></svg>See All</button>';
    host.innerHTML = (list.length ? list.map(cardHtml).join('') : '') + tile;
  }

  function closeTool(){ $('sb-add-ov').classList.remove('open'); }

  // Reflect the selected object into whichever panel is showing. Called
  // on selection, after every transform, and after undo — so the sliders
  // never disagree with the canvas.
  function syncPanel(){
    var o = active();
    // The background-removal controls belong to the selection, so they are
    // painted BEFORE the early return — otherwise deselecting leaves the
    // on-shirt chip floating over nothing.
    syncBgControls();
    if(!o) return;
    if(o.type === 'sb-text'){
      var ta = $('sb-t-text');
      if(document.activeElement !== ta) ta.value = o.text || '';
      setRange('sb-t-size', 'sb-t-size-n', Math.round(o.fontSize));
      setRange('sb-t-arc',  'sb-t-arc-n',  Math.round(o.arc || 0));
      setRange('sb-t-rot',  'sb-t-rot-n',  Math.round(o.angle || 0));
      setRange('sb-t-spc',  'sb-t-spc-n',  Math.round(o.charSpacing || 0));
      $('sb-t-font-name').textContent = fontLabel(o.fontFamily);
      paintChip('fill', o.fill);
      paintChip('stroke', (o.strokeWidth ? o.stroke : null));
      var hasOutline = !!(o.stroke && o.strokeWidth);
      $('sb-t-ow-row').style.display = hasOutline ? '' : 'none';
      if(hasOutline) setRange('sb-t-ow', 'sb-t-ow-n', strokePct(o));
      Array.prototype.forEach.call($('sb-t-align').children, function(b){
        b.classList.toggle('on', b.getAttribute('data-v') === o.textAlign);
      });
    } else {
      var factor = o.getScaledWidth() / baseWidth(o);
      var sizeRange = $('sb-i-size'), sizeNum = $('sb-i-size-n');
      if(document.activeElement !== sizeRange) sizeRange.value = Math.round(sizeFactorToPos(factor));
      if(document.activeElement !== sizeNum) sizeNum.value = Math.round(factor * 100);
      paintRange(sizeRange);
      setRange('sb-i-rot', 'sb-i-rot-n', Math.round(signedAngle(o.angle)));
      if(o.sbSrc) $('sb-i-thumb').src = effectiveSrc(o);
      // Scaling a bitmap past 1:1 is the single most common cause of a
      // disappointing print, and it is invisible on a backlit screen.
      var over = o.type === 'image' && (o.scaleX > 1.02 || o.scaleY > 1.02);
      $('sb-i-quality-row').style.display = over ? '' : 'none';
    }
    syncSubmenus();
    syncFontSelection();
  }

  function setRange(rangeId, numId, value){
    var r = $(rangeId), n = $(numId);
    if(r && document.activeElement !== r) r.value = value;
    if(n && document.activeElement !== n) n.value = value;
    paintRange(r);
  }

  // WebKit has no ::-moz-range-progress equivalent, so the filled portion
  // of the track is painted by a gradient stop that this keeps in step
  // with the value. Firefox ignores it and uses the native progress.
  function paintRange(r){
    if(!r) return;
    var min = parseFloat(r.min) || 0;
    var max = parseFloat(r.max);
    if(!isFinite(max) || max === min) return;
    var val = parseFloat(r.value);
    if(!isFinite(val)) val = min;
    var pct = clamp((val - min) / (max - min) * 100, 0, 100);
    r.style.setProperty('--sb-pct', pct + '%');
    if(r.classList.contains('centered')){
      // Paint the band between the midpoint and the thumb, whichever side
      // it is on.
      r.style.setProperty('--sb-lo', Math.min(50, pct) + '%');
      r.style.setProperty('--sb-hi', Math.max(50, pct) + '%');
    }
  }

  // Outline thickness is kept as a share of the font size rather than an
  // absolute width, so resizing the text keeps the outline in proportion
  // instead of leaving it hairline on big type and clogged on small.
  var DEFAULT_STROKE_PCT = 4.5;

  function strokePct(o){
    return typeof o.sbStrokePct === 'number' ? o.sbStrokePct : DEFAULT_STROKE_PCT;
  }
  // Doubled on purpose: a stroke is centred on the glyph outline, so only
  // half of it shows once the fill is painted over the top. Asking for
  // twice the width makes the visible, outward-only band equal the
  // thickness that was set.
  function strokeWidthFor(o){
    return o.stroke ? o.fontSize * strokePct(o) / 100 * 2 : 0;
  }

  // The Size slider is a multiple of the size the artwork was placed at,
  // not an absolute width: the centre is "as added", left shrinks, right
  // enlarges. Logarithmic so the two halves feel symmetrical — a linear
  // scale would make the shrink half cover 1x..0x and the grow half
  // 1x..3x, and the thumb would crawl on one side and race on the other.
  // The two halves have their own end stops: artwork often needs to go
  // very small (a sleeve hit, a pocket mark) but rarely needs to triple.
  // Each half is still logarithmic, so equal travel is an equal ratio —
  // the shrink side simply moves through more of them.
  var SIZE_MIN = 0.05;   // 5% of the size it was added at
  var SIZE_MAX = 3;      // 300%
  function sizePosToFactor(pos){
    var p = clamp(pos, -100, 100) / 100;
    return p >= 0 ? Math.pow(SIZE_MAX, p) : Math.pow(SIZE_MIN, -p);
  }
  function sizeFactorToPos(factor){
    if(!(factor > 0)) return 0;
    if(factor >= 1) return clamp(100 * Math.log(factor) / Math.log(SIZE_MAX), 0, 100);
    return clamp(-100 * Math.log(factor) / Math.log(SIZE_MIN), -100, 0);
  }

  // The reference width, captured when the artwork lands on the canvas and
  // carried through saves so "as added" survives a reopen.
  function baseWidth(o){
    if(!(o.sbBaseW > 0)) o.sbBaseW = o.getScaledWidth() || 1;
    return o.sbBaseW;
  }

  function applySizeFactor(factor){
    var o = active();
    if(!o || o.type === 'sb-text') return;
    // Set the scale directly rather than via scaleToWidth(): that helper
    // measures through getBoundingRect(), which is in canvas coordinates
    // and therefore multiplied by the current zoom — asking for 3x at a
    // half-scale canvas produced roughly 6x.
    var target = baseWidth(o) * clamp(factor, SIZE_MIN, SIZE_MAX);
    var k = target / (o.width || 1);
    o.set({ scaleX: k, scaleY: k });
    o.setCoords();
    canvas().renderAll();
    syncPanel();
    capture();
  }

  // fabric keeps angle in 0..360; the slider runs -180..180 so that zero
  // sits in the middle.
  function signedAngle(a){
    var v = ((a || 0) % 360 + 360) % 360;
    return v > 180 ? v - 360 : v;
  }

  // The font of the text object being edited, or null when the selection
  // is not text.
  function currentFontCss(){
    var o = active();
    return (o && o.type === 'sb-text') ? (o.fontFamily || null) : null;
  }

  // Toggling classes rather than re-rendering: renderFonts() rebuilds the
  // grid, and doing that on every syncPanel would fight the shopper mid
  // scroll and throw away the lazy-load observers on the picker's tiles.
  function syncFontSelection(){
    var cur = currentFontCss();
    Array.prototype.forEach.call(
      document.querySelectorAll('#sb-t-fonts .sb-font, #sb-font-grid .sb-font-tile'),
      function(b){
        var f = FONTS[parseInt(b.getAttribute('data-i'), 10)];
        b.classList.toggle('is-active', !!(f && cur && f.css === cur));
      });
  }

  function fontLabel(css){
    for(var i = 0; i < FONTS.length; i++) if(FONTS[i].css === css) return FONTS[i].label;
    return defaultFont().label;
  }

  function colorName(hex){
    if(!hex) return 'None';
    for(var i = 0; i < COLORS.length; i++){
      if(COLORS[i][1].toLowerCase() === String(hex).toLowerCase()) return COLORS[i][0];
    }
    // A mixed colour has no name, and its hex is not one — a shopper has
    // no reason to know that notation, and it read as a fault code next to
    // the swatch. The swatch itself says which colour it is.
    return 'Custom';
  }

  function paintChip(kind, hex){
    $('sb-t-' + kind + '-name').textContent = colorName(hex);
    var chip = $('sb-t-' + kind + '-chip');
    chip.style.background = hex || 'transparent';
    chip.style.borderStyle = hex ? 'solid' : 'dashed';
  }

  function renderFonts(){
    var wrap = $('sb-t-fonts');
    if(!shortlist.length) initShortlist();
    var cur = currentFontCss();
    wrap.innerHTML = shortlistFonts().map(function(f){
      return '<button type="button" class="sb-font' + (f.css === cur ? ' is-active' : '') + '" ' +
             'data-sb="t-font" data-i="' + FONTS.indexOf(f) + '" ' +
             'style="font-family:' + esc(f.css) + '">' + esc(f.label) + '</button>';
    }).join('') +
    '<button type="button" class="sb-font sb-font-more" data-sb="open-fonts">' +
      'More fonts (' + FONTS.length + ')&hellip;</button>';
  }

  // ── All fonts, searchable ─────────────────────────────────────────
  var fontObserver = null;

  function openFontPicker(){
    $('sb-font-search').value = '';
    renderFontGrid('');
    $('sb-font-ov').classList.add('open');
    $('sb-font-search').focus();
  }
  function closeFontPicker(){ $('sb-font-ov').classList.remove('open'); }

  function renderFontGrid(query){
    var host = $('sb-font-grid');
    if(!host) return;
    var term = String(query || '').toLowerCase().trim();
    // Alphabetical, always. The FONTS table is grouped by style for
    // readability, but that grouping is invisible here — 92 tiles with no
    // headings just read as unsorted — and this list is where someone
    // comes to find a face by name. filter() already returns a copy, so
    // sorting it cannot disturb FONTS itself; data-i still resolves
    // against the original order.
    // Options are ignored rather than fatal on engines without full Intl,
    // so this degrades to a plain compare.
    var list = FONTS.filter(function(f){
      return !term || f.label.toLowerCase().indexOf(term) > -1;
    }).sort(function(a, b){
      return a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: 'base' });
    });
    if(!list.length){
      host.innerHTML = '<div class="sb-empty">No fonts match &ldquo;' + esc(query) + '&rdquo;.</div>';
      return;
    }
    var curCss = currentFontCss();
    host.innerHTML = list.map(function(f){
      var i = FONTS.indexOf(f);
      return '<button type="button" class="sb-font-tile' + (f.css === curCss ? ' is-active' : '') + '" ' +
               'data-sb="t-font" data-i="' + i + '" ' +
               'data-google="' + esc(f.google || '') + '" title="' + esc(f.label) + '">' +
               '<span class="sb-font-sample" style="font-family:' + esc(f.css) + '">' + esc(f.label) + '</span>' +
             '</button>';
    }).join('');
    watchFontTiles();
  }

  // Each tile previews itself in its own face, so a tile that is never
  // scrolled to never costs a download. Without this, opening the picker
  // would fetch every family in the library at once.
  function watchFontTiles(){
    var tiles = document.querySelectorAll('#sb-font-grid .sb-font-tile');
    if(!window.IntersectionObserver){
      // No observer: fall back to loading everything the filter produced.
      var all = [];
      Array.prototype.forEach.call(tiles, function(t){ all.push(t.getAttribute('data-google')); });
      loadFontFamilies(all);
      return;
    }
    if(fontObserver) fontObserver.disconnect();
    fontObserver = new IntersectionObserver(function(entries){
      var batch = [];
      entries.forEach(function(en){
        if(!en.isIntersecting) return;
        batch.push(en.target.getAttribute('data-google'));
        fontObserver.unobserve(en.target);
      });
      if(batch.length) loadFontFamilies(batch);
    }, { root: $('sb-font-grid'), rootMargin: '200px' });
    Array.prototype.forEach.call(tiles, function(t){ fontObserver.observe(t); });
  }

  function renderSwatches(id, includeNone){
    var grid = $(id);
    if(!grid) return;
    // "No outline" is the one tile in either grid that is not a colour, so
    // it does not read as one: a red prohibition sign rather than the
    // faint chequerboard it used to be, which looked like a pale swatch
    // and got picked by shoppers wanting a light grey outline.
    var html = includeNone
      ? '<button type="button" class="sb-sw sb-sw-none" data-sb="swatch" data-hex="" ' +
        'title="No outline" aria-label="No outline">' +
        '<svg viewBox="0 0 16 16" aria-hidden="true">' +
        '<circle cx="8" cy="8" r="5.7"/><path d="M4 12L12 4"/></svg>' +
        '</button>'
      : '';
    // Stock inks, then anything mixed, in the order it was mixed. Appended
    // rather than sorted in: a colour keeps the position the shopper first
    // saw it at, so reaching for it twice means reaching to the same place.
    html += COLORS.map(function(c){ return swatchHTML(c[1], c[0]); }).join('');
    // Titled "Custom" rather than by hex, for the same reason the label
    // beside the chip is: the tooltip is read by shoppers too.
    html += customColors.map(function(h){ return swatchHTML(h, 'Custom'); }).join('');
    // Always last, so adding a colour never moves it.
    html += '<button type="button" class="sb-sw sb-sw-custom" data-sb="swatch-custom" ' +
            'title="Mix your own color" aria-label="Mix your own color">' +
            '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M8 3.5v9M3.5 8h9"/></svg>' +
            '</button>';
    grid.innerHTML = html;
  }

  function swatchHTML(hex, title){
    return '<button type="button" class="sb-sw" data-sb="swatch" data-hex="' + hex + '" ' +
           'title="' + esc(title) + '" style="background:' + hex + '"></button>';
  }

  // Both grids are built from the same list, so a colour added while one is
  // open has to appear in the other too.
  function renderAllSwatches(){
    renderSwatches('sb-t-fills', false);
    renderSwatches('sb-t-strokes', true);
  }

  // ── Mix your own ink ──────────────────────────────────────────────
  // Which grid the mixer was opened from, so the result goes back to the
  // right property. Held separately from swatchTarget because opening the
  // dialog closes the grid, and with it that state.
  var mixTarget = null;

  function openColorMixer(kind){
    mixTarget = kind;
    var o = active();
    // Seeded from the colour that property already has, so the mixer opens
    // on the shopper's starting point rather than on black — most custom
    // colours are an adjustment of something, not a fresh choice.
    var seed = kind === 'stroke'
      ? (o && o.strokeWidth ? o.stroke : null)
      : (o && o.fill);
    setMixFromHex(normHex(seed) || '#000000');
    var title = $('sb-mix-title');
    if(title) title.textContent = kind === 'stroke' ? 'Custom Outline Color' : 'Custom Text Color';
    closeSwatches();
    $('sb-mix-ov').classList.add('open');
    syncSubViewport();
  }

  function closeColorMixer(){
    $('sb-mix-ov').classList.remove('open');
    mixTarget = null;
    syncSubViewport();
  }

  // The picker's state is HSV, because that is what the two surfaces are:
  // a hue, and a square of every saturation and brightness of it. Kept as
  // HSV rather than derived from a hex each time so that dragging along
  // the top edge of the square does not drift — converting to 8-bit RGB
  // and back rounds, and the marker creeps.
  var mixHsv = { h: 0, s: 0, v: 0 };

  function hsvToRgb(h, sat, val){
    var c = ((h % 360) + 360) % 360 / 60;
    var f = val * sat;
    var x = f * (1 - Math.abs(c % 2 - 1));
    var m = val - f;
    var t = [[f, x, 0], [x, f, 0], [0, f, x], [0, x, f], [x, 0, f], [f, 0, x]][Math.floor(c) % 6];
    return [(t[0] + m) * 255, (t[1] + m) * 255, (t[2] + m) * 255];
  }

  function rgbToHsv(r, g, b){
    r /= 255; g /= 255; b /= 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), d = mx - mn;
    var h = 0;
    if(d){
      if(mx === r)      h = 60 * (((g - b) / d) % 6);
      else if(mx === g) h = 60 * ((b - r) / d + 2);
      else              h = 60 * ((r - g) / d + 4);
    }
    return { h: (h + 360) % 360, s: mx ? d / mx : 0, v: mx };
  }

  function mixHex(){
    var rgb = hsvToRgb(mixHsv.h, mixHsv.s, mixHsv.v);
    return rgbToHex(rgb[0], rgb[1], rgb[2]);
  }

  // Roughly what a shopper would call the hue, for the screen reader — the
  // number the slider reports is degrees, which says nothing on its own.
  var HUE_NAMES = [
    [15, 'red'], [45, 'orange'], [70, 'yellow'], [160, 'green'], [200, 'cyan'],
    [255, 'blue'], [320, 'purple'], [345, 'pink'], [360, 'red']
  ];
  function hueName(h){
    for(var i = 0; i < HUE_NAMES.length; i++){
      if(h < HUE_NAMES[i][0]) return HUE_NAMES[i][1];
    }
    return 'red';
  }

  // One place that paints the whole picker from mixHsv, so the square, the
  // strip, the two markers and the preview can never disagree.
  function paintMix(){
    var hex = mixHex();
    var sv = $('sb-mix-sv');
    if(sv){
      // The square's underlying layer is the FULL-strength hue; the white
      // and black gradients over it produce every other shade.
      var pure = hsvToRgb(mixHsv.h, 1, 1);
      sv.style.setProperty('--sb-hue', rgbToHex(pure[0], pure[1], pure[2]));
      sv.setAttribute('aria-valuenow', Math.round(mixHsv.v * 100));
      sv.setAttribute('aria-valuetext',
        Math.round(mixHsv.s * 100) + '% saturation, ' +
        Math.round(mixHsv.v * 100) + '% brightness');
    }
    var dot = $('sb-mix-dot');
    if(dot){
      dot.style.left = (mixHsv.s * 100) + '%';
      dot.style.top = ((1 - mixHsv.v) * 100) + '%';
    }
    var hue = $('sb-mix-hue');
    if(hue){
      hue.setAttribute('aria-valuenow', Math.round(mixHsv.h));
      hue.setAttribute('aria-valuetext', hueName(mixHsv.h));
    }
    var hueDot = $('sb-mix-hue-dot');
    if(hueDot) hueDot.style.top = (mixHsv.h / 360 * 100) + '%';
    var prev = $('sb-mix-prev');
    if(prev) prev.style.setProperty('--sb-mix', hex);
  }

  function setMixFromHex(hex){
    var rgb = hexToRgb(hex);
    mixHsv = rgbToHsv(rgb[0], rgb[1], rgb[2]);
    paintMix();
  }

  // Dragging on a surface, mouse and touch alike. Pointer capture is what
  // keeps a drag alive once the finger leaves the square — without it the
  // marker stops at the edge and the gesture is lost, which is exactly
  // when someone is reaching for pure white or pure black.
  function bindMixSurface(el, move){
    if(!el) return;
    var down = false;
    function apply(e){
      var r = el.getBoundingClientRect();
      if(!r.width || !r.height) return;
      move(clamp((e.clientX - r.left) / r.width, 0, 1),
           clamp((e.clientY - r.top) / r.height, 0, 1));
      paintMix();
    }
    on(el, 'pointerdown', function(e){
      down = true;
      try { el.setPointerCapture(e.pointerId); } catch(err){}
      el.focus();
      apply(e);
      // Stops the press becoming a text selection or a page scroll.
      e.preventDefault();
    });
    on(el, 'pointermove', function(e){ if(down) apply(e); });
    on(el, 'pointerup', function(){ down = false; });
    on(el, 'pointercancel', function(){ down = false; });
  }

  // Arrow keys, because removing the number boxes removed the only way to
  // set a colour without a pointer. Shift takes bigger steps, matching the
  // nudge keys on the stage.
  var MIX_ARROWS = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] };
  function bindMixKeys(){
    on($('sb-mix-sv'), 'keydown', function(e){
      var d = MIX_ARROWS[e.key];
      if(!d) return;
      var step = (e.shiftKey ? 0.1 : 0.02);
      mixHsv.s = clamp(mixHsv.s + d[0] * step, 0, 1);
      mixHsv.v = clamp(mixHsv.v - d[1] * step, 0, 1);
      paintMix();
      e.preventDefault();
    });
    on($('sb-mix-hue'), 'keydown', function(e){
      var d = MIX_ARROWS[e.key];
      if(!d) return;
      var step = (e.shiftKey ? 30 : 4) * (d[0] + d[1]);
      mixHsv.h = (mixHsv.h + step + 360) % 360;
      paintMix();
      e.preventDefault();
    });
  }

  function applyMixedColor(){
    var hex = addCustomColor(mixHex());
    var kind = mixTarget;
    closeColorMixer();
    // Rebuilt before applying, so the new swatch exists to be marked
    // current by the panel sync that follows.
    renderAllSwatches();
    applySwatch(kind, hex);
  }

  // The swatch grids and the mixer both end here, so a mixed colour and a
  // stock one are applied by exactly the same code.
  function applySwatch(kind, hex){
    if(kind === 'stroke'){
      var o = active();
      // Outline width tracks font size so it stays proportional as the
      // text is resized; a fixed width vanishes on large type.
      if(o && typeof o.sbStrokePct !== 'number') o.sbStrokePct = DEFAULT_STROKE_PCT;
      // Apply the colour first so the width is derived from the state
      // the object is about to be in, not the one it is leaving.
      if(o) o.stroke = hex;
      setText({ stroke: hex, strokeWidth: o ? strokeWidthFor(o) : 0 });
    } else {
      setText({ fill: hex || '#000000' });
    }
  }

  function openSwatches(kind){
    closeSwatches();
    if(kind === 'font'){ $('sb-t-fonts').classList.add('open'); swatchTarget = 'font'; return; }
    swatchTarget = kind;
    $('sb-t-' + (kind === 'fill' ? 'fills' : 'strokes')).classList.add('open');
  }
  function closeSwatches(){
    $('sb-t-fonts').classList.remove('open');
    $('sb-t-fills').classList.remove('open');
    $('sb-t-strokes').classList.remove('open');
    swatchTarget = null;
  }

  // ── Design Elements ───────────────────────────────────────────────
  // A live selector for what is on the stage right now, not a library to
  // reuse from. One entry per object on the CURRENT view, in stacking
  // order — so duplicating artwork gives you two entries, which is the
  // point: it is how you reach the copy sitting underneath another one.
  // Clicking an entry selects that object on the canvas and opens its
  // editor, and the canvas selection highlights the entry back.
  // Every element on the whole garment, front then back, each tagged with
  // the side it lives on. Deliberately global: the design is one thing
  // across two sides, and a list that silently showed only the side you
  // happened to be looking at made the other side's work feel lost.
  //
  // Entries are { viewIdx, view, obj } rather than bare objects, because
  // acting on one may mean switching sides first.
  function elements(){
    var out = [];
    views.forEach(function(v, viewIdx){
      if(!v.canvas) return;
      v.canvas.getObjects().forEach(function(obj){
        out.push({ viewIdx: viewIdx, view: v, obj: obj });
      });
    });
    return out;
  }

  // Position of the current selection in that global list, or -1.
  function activeIndex(){
    var o = active();
    if(!o) return -1;
    var list = elements();
    for(var i = 0; i < list.length; i++){
      if(list[i].obj === o && list[i].viewIdx === activeIdx) return i;
    }
    return -1;
  }

  // Text has no source image, so its tile is the object rendered on its
  // own — the shopper picks their text out of the list by reading it,
  // which is the only thing that works once there are two of them.
  function elementThumb(o){
    if(o.type !== 'sb-text') return effectiveSrc(o);
    try {
      var w = o.getScaledWidth() || 1, h = o.getScaledHeight() || 1;
      return o.toDataURL({
        format: 'png',
        multiplier: clamp(160 / Math.max(w, h), 0.04, 3),
        enableRetinaScaling: false
      });
    } catch(e){
      return '';
    }
  }

  function elementLabel(o){
    if(o.type !== 'sb-text') return o.sbLabel || 'Image';
    return (o.text || '').replace(/\s+/g, ' ').trim().slice(0, 24) || 'Text';
  }

  // Thumbnails are regenerated from live objects, so this is coalesced to
  // one pass per frame — every slider tick calls capture(), and rendering
  // a text object to a PNG on each of those would be wasted work.
  var elsQueued = false;
  function scheduleElements(){
    if(elsQueued) return;
    elsQueued = true;
    window.requestAnimationFrame(function(){
      elsQueued = false;
      renderElements();
    });
  }

  function renderElements(){
    var host = $('sb-els');
    if(!host) return;
    var list = elements();
    var act = active();
    if(!list.length){
      host.innerHTML = '<div class="sb-empty sb-empty-lg">' +
                         '<b>No design elements yet</b>' +
                         'Add artwork or text to start your design.' +
                       '</div>';
      syncCycle();
      return;
    }
    // More than one side in play means a tile's thumbnail alone no longer
    // says where the element is — the same artwork can sit on both. Label
    // them by side in that case, and keep the kind badge otherwise.
    var sidesInUse = {};
    list.forEach(function(e){ sidesInUse[e.viewIdx] = true; });
    var showSide = Object.keys(sidesInUse).length > 1;

    host.innerHTML = list.map(function(e, i){
      var o = e.obj;
      var src = elementThumb(o);
      var kind = o.type === 'sb-text' ? 'Text' : 'Art';
      var isActive = o === act && e.viewIdx === activeIdx;
      var badge = showSide ? e.view.label : kind;
      return '<button type="button" class="sb-card' + (isActive ? ' is-active' : '') + '" ' +
               'data-sb="pick-el" data-i="' + i + '" ' +
               'title="' + esc(e.view.label + ' \u2014 ' + elementLabel(o)) + '">' +
               (src ? '<img src="' + esc(src) + '" alt="">' : '') +
               '<span class="sb-card-label">' + esc(elementLabel(o)) + '</span>' +
               '<span class="sb-card-kind">' + esc(badge) + '</span>' +
             '</button>';
    }).join('');
    syncCycle();
  }

  function pickElement(i){
    var list = elements();
    var e = list[i];
    if(!e) return;
    // showView() paints the side and resets the rail to the add panel, so
    // the selection has to be applied after it, not before.
    if(e.viewIdx !== activeIdx) showView(e.viewIdx);
    var c = e.view.canvas;
    if(!c) return;
    c.setActiveObject(e.obj);
    c.renderAll();
    showPanel(e.obj.type === 'sb-text' ? 'text' : 'image');
  }

  // Step through every element on the whole garment, wrapping at both
  // ends — so stepping past the last front element lands on the first back
  // one and switches the view with it. The panel follows the selection, so
  // cycling can move between a text object and an image without the
  // shopper going back to the list.
  function cycleElement(dir){
    var list = elements();
    if(list.length < 2) return;
    var cur = activeIndex();
    var next = cur < 0 ? 0 : (cur + dir + list.length) % list.length;
    pickElement(next);
  }

  // With a single element there is nowhere to step to, so the control
  // goes away rather than sitting there greyed out — a disabled pair of
  // arrows just poses a question the shopper cannot act on.
  function syncCycle(){
    var many = elements().length > 1;
    Array.prototype.forEach.call(document.querySelectorAll('.sb-cycle'), function(g){
      g.hidden = !many;
    });
  }

  // The full upload history, shared with the quick flow — every upload
  // and every AI pick is registered there, from either surface.
  function recent(){
    var a = api();
    try { return (a && a.getRecentDesigns && a.getRecentDesigns()) || []; }
    catch(e){ return []; }
  }

  // Plain <img> on purpose. These are presentational only and never go
  // near the canvas, so they must not carry crossorigin — see loadArtwork
  // for why tagging them breaks them.
  function cardHtml(d){
    return '<button type="button" class="sb-card" data-sb="use" data-url="' + esc(d.img) + '" ' +
           'data-label="' + esc(d.label || '') + '">' +
           '<img src="' + esc(d.img) + '" alt="">' +
           '<span class="sb-card-x" role="button" tabindex="0" data-sb="forget" ' +
             'data-url="' + esc(d.img) + '" title="Remove from recent images" ' +
             'aria-label="Remove from recent images">\u2715</span>' +
           '</button>';
  }

  // ── Saved designs gallery ─────────────────────────────────────────
  function openSavedDesigns(){
    var host = $('sb-saved-grid');
    var a = api();
    $('sb-saved-ov').classList.add('open');
    if(!a){ return; }
    if(a.isSignedIn && !a.isSignedIn()){
      host.innerHTML =
        '<div class="sb-signin-state">' +
          '<div class="sb-signin-title">Sign in to see your saved designs</div>' +
          '<button type="button" class="sb-btn primary sb-btn-lg" data-sb="saved-signin" ' +
            'style="margin-top:16px">Sign In</button>' +
        '</div>';
      return;
    }
    host.innerHTML = '<div class="sb-empty">Loading your saved designs&hellip;</div>';
    savesCall('list', { limit: 60 }).then(function(res){
      if(!res || !res.success || !Array.isArray(res.designs)){
        host.innerHTML = '<div class="sb-empty">Saved designs could not be loaded. Please close this panel and try again.</div>';
        return;
      }
      if(!res.designs.length){
        host.innerHTML = '<div class="sb-empty">You have not saved any designs yet. ' +
          'Build one and press Save.</div>';
        return;
      }
      host.innerHTML = res.designs.map(function(d){
        return '<button type="button" class="sb-saved-card" data-sb="load-saved" ' +
                 'data-guid="' + esc(d.guid) + '">' +
                 '<img class="sb-saved-thumb" src="' + esc(d.thumbnailUrl || '') + '" alt="">' +
                 '<span class="sb-saved-meta">' +
                   '<span class="sb-saved-name">' + esc(d.name) + '</span>' +
                 '</span>' +
                 '<span class="sb-saved-rm" data-sb="delete-saved" data-guid="' + esc(d.guid) +
                   '" data-name="' + esc(d.name || '') + '" role="button" ' +
                   'aria-label="Delete ' + esc(d.name || 'design') + '">&#x2715;</span>' +
               '</button>';
      }).join('');
    });
  }
  function closeSavedDesigns(){ $('sb-saved-ov').classList.remove('open'); }

  // Replaying a saved design replaces whatever is on the stage. The garment
  // stays whichever product the builder was opened on — the design travels,
  // the shirt does not.
  function loadSavedDesign(guid){
    if(builderBusy) return;
    setBusy(true, 'Opening your design…');
    savesCall('get', { guid: guid }).then(function(res){
      setBusy(false);
      if(!res || !res.success || !res.design){
        showMessageSafe('Saved Designs', 'That design could not be opened.');
        return;
      }
      var doc = null;
      try { doc = JSON.parse(res.design.designJson); } catch(e){}
      if(!doc || !Array.isArray(doc.views) || doc.views.some(function(v){
        return !v || !v.canvas || !Array.isArray(v.canvas.objects) || !views.some(function(current){ return current.id === v.id; });
      })){
        showMessageSafe('Saved Designs', 'That design could not be read.');
        return;
      }
      closeSavedDesigns();
      doc.savedGuid = res.design.guid;
      doc.savedName = res.design.name;
      pendingRestore = doc;
      return applyRestore().then(function(){ showPanel('add'); });
    }).catch(function(){
      setBusy(false);
      showMessageSafe('Saved Designs', 'That design could not be opened.');
    });
  }

  // The design pending deletion, held between the prompt and the answer.
  var deleteTarget = null;

  function askDeleteSaved(guid, name){
    if(!guid) return;
    deleteTarget = guid;
    $('sb-delsaved-copy').textContent = name
      ? '\u201C' + name + '\u201D will be removed from your saved designs.'
      : 'This design will be removed from your saved designs.';
    $('sb-delsaved-ov').classList.add('open');
  }

  function closeDeleteSaved(){
    $('sb-delsaved-ov').classList.remove('open');
    deleteTarget = null;
  }

  function deleteSavedDesign(){
    if(builderBusy) return;
    var guid = deleteTarget;
    closeDeleteSaved();
    if(!guid) return;
    setBusy(true, 'Deleting design...');
    savesCall('delete', { guid: guid }).then(function(res){
      setBusy(false);
      if(!res || !res.success){ showMessageSafe('Saved Designs', 'The design could not be deleted. Please try again.'); return; }
      // The open design was the one deleted: drop its identity so the next
      // Save creates a new row rather than resurrecting the deleted one.
      if(savedGuid === guid){ savedGuid = null; savedName = ''; dirtySinceSave = true; }
      openSavedDesigns();
    });
  }

  function openAll(){
    var list = recent();
    $('sb-all-grid').innerHTML = list.length
      ? list.map(cardHtml).join('')
      : '<div class="sb-empty">Nothing saved yet. Anything you upload or generate is kept here for reuse.</div>';
    $('sb-all-ov').classList.add('open');
  }

  // ── Errors + busy ─────────────────────────────────────────────────
  function showError(id, msg){
    var el = $(id);
    if(!el) return;
    el.textContent = msg;
    el.classList.add('show');
  }
  function clearError(id){ var el = $(id); if(el) el.classList.remove('show'); }
  var builderBusy = false;
  var restoreFailed = false;

  // Initial attempt plus three retries. Validation and authorization errors
  // cannot recover by waiting; transient failures often can.
  function builderRetry(operation){
    var delays = [500, 1500, 3000];
    function attempt(n){
      return Promise.resolve().then(operation).catch(function(err){
        if(n >= delays.length || (err.status && err.status !== 408 && err.status !== 429 && err.status < 500)) throw err;
        return new Promise(function(resolve){ setTimeout(resolve, delays[n]); }).then(function(){ return attempt(n + 1); });
      });
    }
    return attempt(0);
  }

  // Include response-body parsing in the deadline, and abort the request.
  function builderFetch(url, options, asBlob){
    options = Object.assign({}, options || {});
    var controller = window.AbortController ? new window.AbortController() : null;
    if(controller) options.signal = controller.signal;
    return new Promise(function(resolve, reject){
      var timer = setTimeout(function(){
        if(controller) controller.abort();
        reject(new Error('The request timed out. Please try again.'));
      }, 30000);
      Promise.resolve().then(function(){ return fetch(url, options); }).then(function(response){
        return (asBlob ? response.blob() : response.text()).then(function(body){
          return { ok: response.ok, status: response.status, blob: function(){ return Promise.resolve(body); }, json: function(){
            return Promise.resolve().then(function(){ return JSON.parse(body); });
          } };
        });
      }).then(function(response){ clearTimeout(timer); resolve(response); }, function(err){ clearTimeout(timer); reject(err); });
    });
  }

  function setBusy(on, text){
    builderBusy = !!on;
    $('sb-busy').classList.toggle('on', !!on);
    if(text) $('sb-busy-txt').textContent = text;
  }

  // Undo/redo/reset enablement, the empty-stage hint, per-view dots and
  // whether there is anything worth taking to the sizes step.
  function setStageTool(id, enabled){
    var b = $(id);
    if(!b) return;
    b.disabled = !enabled;
    b.hidden = !enabled;
  }

  function refreshChrome(){
    ccsChanged();
    var v = view();
    var any = false;
    views.forEach(function(vw){
      if(vw.canvas && vw.canvas.getObjects().length) any = true;
    });
    // Hidden rather than greyed: these three are only ever relevant once
    // there is something to undo, redo or clear, and a column of dead
    // buttons over the garment is just noise. Still disabled as well as
    // hidden, so nothing can act on one that is off screen.
    var swap = $('sb-swap');
    if(swap){
      // Nothing to exchange if both sides are bare, and with only one side
      // the link has no meaning at all.
      swap.hidden = !(views.length === 2 && any);
    }
    setStageTool('sb-undo',  v && v.history.length > 1);
    setStageTool('sb-redo',  v && v.redo.length > 0);
    // `any`, not the visible side: Start Over clears both, so it stays
    // available while looking at a bare front with art on the back.
    setStageTool('sb-reset', any);
    $('sb-next').disabled  = !any;
    // Say what is missing rather than naming a step they cannot reach yet.
    // A cart edit has no sizes step at all — the quantities are already set
    // and are edited from the cart card's own size pills — so the primary
    // action is simply committing the new artwork.
    // No sizes step and no cart edit to distinguish between, so the only
    // thing this label varies on is whether there is anything to render.
    $('sb-next').textContent = any ? 'Continue' : 'Add a Design to Continue';
    var headNext = $('sb-head-next');
    if(headNext){
      headNext.disabled = !any;
      headNext.textContent = 'Continue';
    }
    syncSaveButton(any);
    syncEmptyState();
    renderViews();
    scheduleElements();
  }

  // ── Garment card + colour switching ───────────────────────────────
  function shirtColors(){
    return (shirt && Array.isArray(shirt.colors)) ? shirt.colors : [];
  }

  function renderShirtBox(){
    if(!shirt) return;
    $('sb-shirt-thumb').src = shirt.img || '';
    $('sb-shirt-name').textContent = shirt.name || '';
    $('sb-shirt-colorname').textContent = shirt.color || '';
    $('sb-shirt-dot').style.background = shirt.hex ? ('#' + String(shirt.hex).replace(/^#/, '')) : '#ccc';
    // Nothing to switch between: show the garment, drop the invitation.
    var cta = $('sb-shirt-box').querySelector('.sb-shirt-cta');
    var many = shirtColors().length > 1;
    if(cta) cta.style.display = many ? '' : 'none';
    $('sb-shirt-box').style.cursor = many ? 'pointer' : 'default';
  }

  function openColorPicker(){
    var list = shirtColors();
    if(list.length < 2) return;
    $('sb-color-grid').innerHTML = list.map(function(c){
      var hex = '#' + String(c.hex || '').replace(/^#/, '');
      var hex2 = c.hex2 ? ('#' + String(c.hex2).replace(/^#/, '')) : '';
      var swatch = (hex2 && hex2 !== '#000000' && hex2 !== hex)
        ? 'background:linear-gradient(135deg,' + hex + ' 50%,' + hex2 + ' 50%)'
        : 'background:' + hex;
      var current = shirt && c.key === shirt.key;
      return '<button type="button" class="sb-color' + (current ? ' is-current' : '') + '" ' +
               'data-sb="pick-color" data-key="' + esc(c.key) + '">' +
               '<span class="sb-color-sw" style="' + swatch + '"></span>' +
               '<span class="sb-color-name">' + esc(c.name || '') + '</span>' +
             '</button>';
    }).join('');
    $('sb-color-ov').classList.add('open');
  }
  function closeColorPicker(){ $('sb-color-ov').classList.remove('open'); }

  // Swap the garment art under the design. Object coordinates live in
  // design units, so they survive the change untouched — except when the
  // new shot has a different aspect ratio, where the vertical scale is
  // rebased so artwork stays where it looked rather than sliding up or
  // down the shirt.
  function pickColor(key){
    var next = null;
    shirtColors().forEach(function(c){ if(c.key === key) next = c; });
    if(!next || !shirt || next.key === shirt.key) { closeColorPicker(); return; }

    track('builder-color-change', {
      from: shirt && shirt.key, from_color: shirt && shirt.color,
      to: next.key, to_color: next.name,
      scene: logScene()
    });
    setBusy(true, 'Switching color…');
    var art = {
      front: { garment: next.designFront },
      back:  { garment: next.designBack }
    };

    Promise.all(views.map(function(v){
      var a = art[v.id];
      if(!a || !a.garment) return Promise.resolve();
      return measure(a.garment).then(function(nat){
        if(!nat) return;
        var oldH = v.design && v.design.h;
        v.garment = a.garment;
        v.natural = nat;
        v.design = { w: DESIGN_W, h: Math.round(DESIGN_W * nat.h / nat.w) };
        if(v.canvas && oldH && v.design.h !== oldH){
          var k = v.design.h / oldH;
          v.canvas.getObjects().forEach(function(o){ o.top = o.top * k; o.setCoords(); });
        }
      });
    })).then(function(){
      shirt = Object.assign({}, shirt, {
        key: next.key, color: next.name, hex: next.hex, img: next.img,
        designFront: next.designFront, designBack: next.designBack,
      });
      var v = view();
      if(v) $('sb-garment').src = v.garment;
      fitStage();
      renderShirtBox();
      refreshChrome();
      dirtySinceSave = true;
      setBusy(false);
      closeColorPicker();
    }).catch(function(err){
      setBusy(false);
      warn('[ShirtBuilder] color switch failed', err);
      showMessageSafe('Change Color', 'That color could not be loaded. Please try another.');
    });
  }

  // The side's artwork on transparency, at thumbnail resolution. Separate
  // from exportSide(): that one crops to the artwork and renders at print
  // resolution, while this has to stay aligned with the garment photo, so
  // it keeps the full canvas frame.
  //
  // A selected object draws its handles on the upper canvas, not this one,
  // so nothing has to be deselected first.
  var VIEW_ART_PX = 320;
  // targetPx is the width the result is about to be DRAWN at. It matters:
  // the rail thumbnails and the sizes-modal previews are ~100px on screen
  // and 320 is generous for them, but the composites are 700px (the copy
  // stored with the cart line) and 900px (the saved-designs thumb). Left
  // at 320 the artwork was upscaled 2.2x-2.8x into those, so the design
  // came out visibly pixellated over a garment photo that stayed sharp --
  // which is exactly how it looked wrong in the cart but fine in the
  // builder.
  function viewArtPng(v, targetPx){
    if(!v || !v.canvas || !v.canvas.getObjects().length) return '';
    // A side that has never been on screen has an unfitted canvas, and
    // rendering it would give a blank PNG. Size it here rather than only
    // when it becomes visible.
    fitCanvas(v);
    try {
      var w = v.canvas.getWidth() || 1;
      // Ceiling of 4 rather than 2: a 900px slot rendered from a narrow
      // canvas on a phone needs more than 2x, and 2 was quietly capping it.
      return v.canvas.toDataURL({
        format: 'png',
        multiplier: clamp((targetPx || VIEW_ART_PX) / w, 0.05, 4),
        enableRetinaScaling: false
      });
    } catch(e){
      // Tainted canvas (artwork that refused CORS). The garment still shows.
      warn('[ShirtBuilder] could not preview side', v.id, e);
      return '';
    }
  }

  // Everything the sizes modal needs to show both sides, designed or not.
  function viewPreviews(){
    return views.map(function(v){
      return { id: v.id, label: v.label, garment: v.garment, art: viewArtPng(v) };
    });
  }

  // Swap what is on the front with what is on the back. Works on the
  // serialised scenes rather than moving fabric objects between canvases:
  // an object carries a reference to the canvas that owns it, and handing
  // a live one to another canvas leaves the two disagreeing about which
  // owns it. Round-tripping through JSON gives each side its own objects.
  //
  // Only ever two sides in the builder, so this is a straight exchange
  // rather than a general permutation.
  function swapViews(){
    if(views.length !== 2) return;
    var a = views[0], b = views[1];
    if(!a.canvas || !b.canvas) return;
    if(!a.canvas.getObjects().length && !b.canvas.getObjects().length) return;

    var aJson = JSON.stringify(a.canvas.toJSON(SCENE_PROPS));
    var bJson = JSON.stringify(b.canvas.toJSON(SCENE_PROPS));
    var aNotes = a.notes || '', bNotes = b.notes || '';

    setBusy(true, 'Swapping sides…');
    // restoring suppresses capture() while loadFromJSON fires object:added
    // for every object, which would otherwise push a history entry each.
    restoring = true;
    loadSide(a, bJson).then(function(){
      return loadSide(b, aJson);
    }).then(function(){
      a.notes = bNotes;
      b.notes = aNotes;
      restoring = false;
      setBusy(false);
      syncNotes();
      refreshChrome();
      capture();
    }).catch(function(err){
      restoring = false;
      setBusy(false);
      warn('[ShirtBuilder] swap failed', err);
      refreshChrome();
    });
  }

  // Replace one side's contents from a serialised scene, re-resolving the
  // artwork through the blob loader so the swapped side stays as
  // export-safe as a freshly built one.
  // A text object's width is measured against whatever font the browser
  // has RIGHT NOW. loadFromJSON re-creates the object immediately, so if
  // its webfont has not arrived yet fabric measures the fallback — and the
  // object keeps that width once the real font paints. The result is a
  // bounding box that no longer matches the glyphs: too wide, text sitting
  // off-centre inside it, and snap-to-centre aligning the box rather than
  // the visible text. The same stale width also feeds exportSide's crop.
  //
  // So after any restore, wait for each text object's font and re-measure.
  // ══════════════════════════════════════════════════════════════════
  // TEMPORARY DIAGNOSTICS — remove once the text bounding-box report is
  // closed out. Everything here is read-only and wrapped in try/catch;
  // nothing in it can change what the builder does.
  //
  // The question it answers: is a text object's stored width the same as
  // the width the browser actually paints, and if not, when did they
  // diverge? Run window.sbDiag() in the console with the text selected.
  // ══════════════════════════════════════════════════════════════════
  var SB_DIAG = (function(){
    try { return /[?&]sb_debug=1/.test(location.search) || window.__sbDebug === true; }
    catch(e){ return false; }
  })();

  function sbDiagText(o, canvasEl){
    var out = { text: o.text, font: o.fontFamily, fontSize: o.fontSize,
                scaleX: round2(o.scaleX), scaleY: round2(o.scaleY),
                charSpacing: o.charSpacing || 0, arc: o.arc || 0,
                textAlign: o.textAlign, strokeWidth: o.strokeWidth || 0 };
    try {
      out.storedWidth = round2(o.width);
      out.lineWidths = (o.__lineWidths || []).map(round2);
      out.lineLeftOffset0 = o._getLineLeftOffset ? round2(o._getLineLeftOffset(0)) : null;
      // Where fabric itself thinks each line's glyphs stop. If this is
      // well short of storedWidth, the slack is in the box, not the font.
      out.charBoundsRight = (o.__charBounds || []).map(function(line){
        var last = line && line[line.length - 1];
        return last ? round2(last.left + (last.kernedWidth != null ? last.kernedWidth : last.width)) : null;
      });
    } catch(e){ out.storedWidthErr = String(e); }

    // Is the face the object claims actually available right now?
    try {
      out.fontLoaded = document.fonts && document.fonts.check
        ? document.fonts.check(Math.round(o.fontSize) + 'px ' + o.fontFamily)
        : 'unknown';
    } catch(e){ out.fontLoaded = 'check-threw'; }

    // What the browser says about this exact string in this exact font,
    // using the same declaration fabric renders with.
    try {
      var mctx = document.createElement('canvas').getContext('2d');
      mctx.font = o._getFontDeclaration ? o._getFontDeclaration()
                                        : (o.fontSize + 'px ' + o.fontFamily);
      out.fontDeclaration = mctx.font;
      var lines = (o.text || '').split('\n');
      out.perLine = lines.map(function(ln){
        var m = mctx.measureText(ln);
        return { line: ln, advance: round2(m.width),
                 ink: round2((m.actualBoundingBoxLeft || 0) + (m.actualBoundingBoxRight || 0)),
                 leftBearing: round2(m.actualBoundingBoxLeft || 0) };
      });
      out.widestAdvance = round2(Math.max.apply(null, out.perLine.map(function(l){ return l.advance; })));
      out.storedMinusAdvance = round2(o.width - out.widestAdvance);
    } catch(e){ out.measureErr = String(e); }

    // The heart of the report: how much of the box is empty, and on which
    // side. Painting the object on its own keeps the numbers clean when
    // other artwork shares the shirt -- a canvas-wide scan would just
    // measure whatever sits furthest out.
    try {
      var br = o.getBoundingRect();
      out.box = { width: round2(br.width), height: round2(br.height) };
      var solo = o.toCanvasElement ? o.toCanvasElement({ multiplier: 1 }) : null;
      if(solo && solo.width){
        var d = solo.getContext('2d').getImageData(0, 0, solo.width, solo.height).data;
        var minX = -1, maxX = -1;
        for(var y = 0; y < solo.height; y++){
          for(var x = 0; x < solo.width; x++){
            if(d[(y * solo.width + x) * 4 + 3] > 12){
              if(minX < 0 || x < minX) minX = x;
              if(x > maxX) maxX = x;
            }
          }
        }
        out.soloBox = solo.width + 'x' + solo.height;
        out.ink = { left: minX, right: maxX, width: maxX - minX };
        // Slack inside the box, in the box's own pixels. Even numbers mean
        // the glyphs are centred in their box; a big gapRight is the bug.
        out.gapLeft = minX;
        out.gapRight = solo.width - 1 - maxX;
        out.gapSkew = round2(out.gapRight - out.gapLeft);
      }
    } catch(e){ out.boxErr = String(e); }
    return out;
  }

  function round2(n){ return (typeof n === 'number' && isFinite(n)) ? Math.round(n * 100) / 100 : n; }

  // Console entry point. Reports every text object on every side.
  window.sbDiag = function(){
    var report = { when: new Date().toISOString(), zoom: null, sides: [] };
    try {
      var cur = canvas();
      report.zoom = cur ? round2(cur.getZoom()) : null;
      report.fontsStatus = (document.fonts && document.fonts.status) || 'unknown';
      views.forEach(function(v){
        if(!v.canvas) return;
        var el = (v === view()) ? v.canvas.lowerCanvasEl : null;
        var texts = v.canvas.getObjects().filter(function(o){ return o.type === 'sb-text'; });
        report.sides.push({
          side: v.id, visible: v === view(), objects: v.canvas.getObjects().length,
          canvasSize: v.canvas.getWidth() + 'x' + v.canvas.getHeight(),
          designSpace: v.design ? (v.design.w + 'x' + v.design.h) : null,
          texts: texts.map(function(o){ return sbDiagText(o, el); })
        });
      });
    } catch(e){ report.error = String(e && e.stack || e); }
    try {
      report.sides.forEach(function(sd){
        sd.texts.forEach(function(t, i){
          // Slack is the whole story: how much wider the box is than the
          // glyphs, and whether that space splits evenly or piles up on
          // one side (lineLeftOffset0 == 0 with slack means all on the right).
          console.log('[sb-diag] VERDICT ' + sd.side + '#' + i +
            ' | SLACK=' + round2(t.storedMinusAdvance) +
            ' of width ' + t.storedWidth +
            ' | leftOffset=' + t.lineLeftOffset0 +
            ' | align=' + t.textAlign +
            ' | gapL=' + t.gapLeft + ' gapR=' + t.gapRight +
            ' | fontLoaded=' + t.fontLoaded +
            ' | ' + t.font);
        });
      });
    } catch(e){}
    // Printed as JSON so it can be copied out of the console in one go.
    console.log('[sb-diag] ' + JSON.stringify(report, null, 2));
    return report;
  };

  // One line per transition, so the sequence that produced a bad box is
  // visible without having to catch it live.
  function sbDiagLog(stage, o){
    if(!SB_DIAG || !o || o.type !== 'sb-text') return;
    try {
      var loaded = (document.fonts && document.fonts.check)
        ? document.fonts.check(Math.round(o.fontSize) + 'px ' + o.fontFamily) : '?';
      var slack = '?';
      try {
        var mc = document.createElement('canvas').getContext('2d');
        mc.font = o._getFontDeclaration();
        slack = round2(o.width - Math.max.apply(null,
          (o._textLines || []).map(function(cells){
            return mc.measureText(cells.join('')).width; })));
      } catch(e){}
      console.log('[sb-diag] ' + stage +
        ' | SLACK=' + slack +
        ' | width=' + round2(o.width) +
        ' | lineW=' + JSON.stringify((o.__lineWidths || []).map(round2)) +
        ' | fontLoaded=' + loaded +
        ' | font=' + o.fontFamily +
        ' | size=' + round2(o.fontSize) +
        ' | text=' + JSON.stringify((o.text || '').slice(0, 40)));
    } catch(e){}
  }

  function remeasureText(v){
    if(!v || !v.canvas) return Promise.resolve();
    var texts = v.canvas.getObjects().filter(function(o){ return o.type === 'sb-text'; });
    if(!texts.length) return Promise.resolve();
    return Promise.all(texts.map(function(o){
      sbDiagLog('remeasureText:before', o);
      return whenFamilyUsable(o.fontFamily).then(function(){
        o.initDimensions();
        o.setCoords();
        sbDiagLog('remeasureText:after', o);
      });
    })).then(function(){
      v.canvas.renderAll();
      scheduleElements();
    }).catch(function(err){
      warn('[ShirtBuilder] could not re-measure text', err);
    });
  }

  function loadSide(v, json){
    var scene = JSON.parse(json);
    var objs = scene.objects || [];
    return Promise.all([prepareSceneFonts(scene)].concat(objs.map(function(o){
      if(!o.sbSrc) return null;
      return loadArtwork(effectiveSrc(o)).then(function(src){ o.src = src; });
    }))).then(function(){
      return new Promise(function(resolve){
        v.canvas.loadFromJSON(scene, function(){
          v.canvas.getObjects().forEach(adoptObject);
          v.canvas.renderAll();
          v.history = [JSON.stringify(v.canvas.toJSON(SCENE_PROPS))];
          v.redo.length = 0;
          // The font preflight above makes construction accurate. Keep the
          // post-load pass for old scenes and browsers without FontFaceSet.
          remeasureText(v).then(function(){
            v.history = [JSON.stringify(v.canvas.toJSON(SCENE_PROPS))];
            resolve();
          });
        });
      });
    });
  }

  function renderViews(){
    $('sb-views').innerHTML = views.map(function(v, i){
      var used = v.canvas && v.canvas.getObjects().length;
      var art = used ? viewArtPng(v) : '';
      return '<button type="button" class="sb-view' + (i === activeIdx ? ' active' : '') + '" ' +
               'data-sb="view" data-i="' + i + '">' +
               '<span class="sb-view-img"><img src="' + esc(v.garment) + '" alt="">' +
                 (art ? '<img class="sb-view-art" src="' + esc(art) + '" alt="">' : '') +
               '</span>' +
               '<span class="sb-view-name">' + esc(v.label) + '</span>' +
               (used ? '<span class="sb-view-dot" title="Has a design"></span>' : '') +
             '</button>';
    }).join('');
  }

  // ============================================================
  // EXPORT + SAVE
  // ============================================================
  // Artwork only, on transparency, cropped to what the shopper actually
  // placed. The garment photo is a DOM image behind the canvas, so it is
  // simply not part of this — which is what the print file needs.
  function exportSide(v){
    var c = v.canvas;
    var objs = c.getObjects();
    if(!objs.length) return null;

    c.discardActiveObject();
    c.renderAll();

    // Union of every object's bounding rect, in design units.
    var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    objs.forEach(function(o){
      var r = o.getBoundingRect(true, true);   // absolute, ignore viewport
      minX = Math.min(minX, r.left);
      minY = Math.min(minY, r.top);
      maxX = Math.max(maxX, r.left + r.width);
      maxY = Math.max(maxY, r.top + r.height);
    });
    var pad = 8;
    minX = Math.max(0, minX - pad); minY = Math.max(0, minY - pad);
    maxX = Math.min(v.design.w, maxX + pad); maxY = Math.min(v.design.h, maxY + pad);
    var w = Math.max(1, maxX - minX), h = Math.max(1, maxY - minY);

    // toDataURL's crop rect is in *screen* pixels and the output is
    // (crop x multiplier), so both have to go through the zoom the canvas
    // happens to be displayed at. Clamping the multiplier here would be a
    // trap: on a small window zoom is small, the multiplier needed is
    // large, and a ceiling would quietly hand the printer a low-res file
    // whose resolution depended on the shopper's browser size. So the
    // guard rails go on the OUTPUT dimension instead, which is the thing
    // that actually has to be right.
    var zoom = c.getZoom() || 1;
    var longSide = Math.max(w, h);
    var targetPx = clamp(EXPORT_LONG_EDGE, longSide, 4096);
    var mult = targetPx / (longSide * zoom);
    try {
      return {
        dataUrl: c.toDataURL({
          format: 'png',
          left: minX * zoom, top: minY * zoom,
          width: w * zoom,  height: h * zoom,
          multiplier: mult
        }),
        width: w, height: h
      };
    } catch(err){
      // A tainted canvas is the only realistic failure here, and it means
      // some artwork host stopped sending CORS headers. Say so plainly
      // rather than uploading a blank PNG.
      warn('[ShirtBuilder] export blocked', err);
      return { error: err };
    }
  }

  function dataUrlToBlob(dataUrl){
    var parts = dataUrl.split(',');
    var mime = (parts[0].match(/:(.*?);/) || [])[1] || 'image/png';
    var bin = atob(parts[1]);
    var buf = new Uint8Array(bin.length);
    for(var i = 0; i < bin.length; i++) buf[i] = bin.charCodeAt(i);
    return new Blob([buf], { type: mime });
  }

  function blobFile(blob, name){
    // Some Safari versions still lack the File constructor; the presign
    // path only reads .name and .type, so a tagged Blob is enough.
    try { return new File([blob], name, { type: blob.type }); }
    catch(e){ blob.name = name; return blob; }
  }

  // The scene is uploaded next to the artwork instead of travelling with
  // the design. The whole cartCustom tree is stringified into a single
  // `_design_data` line-item property, and a fabric scene per placement
  // would cost kilobytes of that shared budget for something only the
  // builder ever reads back.
  // Losing the preview costs a nicer cart thumbnail, not the order, so a
  // failure here resolves null and the cart falls back to its old
  // artwork-and-placement-icon pair.
  function uploadSidePreview(v){
    var a = api();
    if(!a || !a.uploadArtwork) return Promise.resolve(null);
    return renderSidePreview(v).then(function(dataUrl){
      if(!dataUrl) return null;
      try {
        var file = blobFile(dataUrlToBlob(dataUrl),
                            'preview-' + v.id + '-' + Date.now() + '.png');
        return a.uploadArtwork(file, { addToHistory: false, source: 'builder-side-preview' })
          .then(function(d){ return (d && d.img) || null; })
          .catch(function(){ return null; });
      } catch(e){ return null; }
    }).catch(function(){ return null; });
  }

  function uploadScene(v){
    var a = api();
    if(!a || !a.uploadArtwork) return Promise.reject(new Error('Scene uploads are unavailable.'));
    var json = v.canvas.toJSON(SCENE_PROPS);
    // Object URLs die with the page, so swap each image's src back to the
    // address the artwork actually lives at before the scene is stored.
    (json.objects || []).forEach(function(o){
      if(o.sbSrc) o.src = effectiveSrc(o);
    });
    var scene = {
      version: 1,
      view: v.id,
      design: v.design,
      garment: v.garment,
      canvas: json
    };
    var blob = new Blob([JSON.stringify(scene)], { type: 'application/json' });
    return a.uploadArtwork(blobFile(blob, 'scene-' + v.id + '-' + Date.now() + '.json'),
                           { addToHistory: false, source: 'builder-scene' })
      .then(function(d){
        if(!d || !/^https:\/\//i.test(d.img || '')) throw new Error('The editable design could not be uploaded. Please try again.');
        return d.img;
      });
  }

  // Opening the sizes step costs nothing: it just hands the modal the
  // placements, the previews, and a way to finish the job later.
  //
  // The expensive part — flattening each side to a print-resolution PNG
  // and parking both that and the editable scene on S3 — is deferred to
  // Add to Cart. Doing it here meant a progress overlay on the way to a
  // screen the shopper might well back out of, and it read like the
  // account-save behind the Save button. Now nothing is uploaded until
  // they actually commit.
  // The admin primary action. Everything the storefront does from here —
  // the sizes step, the approval modal, the cart write — has no meaning
  // against a proof, so this hands the finished renders to the page and
  // lets it duplicate the website proof.
  // Coalesced to a frame: refreshChrome runs several times during a single
  // drag, and the rail only needs the settled answer.
  var ccsChangeQueued = false;
  function ccsChanged(){
    if(ccsChangeQueued) return;
    ccsChangeQueued = true;
    requestAnimationFrame(function(){
      ccsChangeQueued = false;
      try { document.dispatchEvent(new CustomEvent('ccs:builder-changed')); }
      catch(e){}
    });
  }

  function publishListing(){
    var a = api();
    if(!a || !a.publishListing) return;
    if(!hasArtwork()){
      showMessageSafe('Publish', 'There is nothing on the shirt yet.');
      return;
    }
    // The host takes it from here: it collects the colors, re-opens this
    // builder on each one, and calls prepare() below to export and upload.
    a.publishListing();
  }

  function openSizes(){
    if(builderBusy || restoreFailed) return;
    if(views.some(function(v){ return v.canvas && v.canvas.getObjects().some(function(o){ return o.sbBgBusy; }); })){
      showMessageSafe('Prepare Design', 'Please wait for background removal to finish before continuing.'); return;
    }
    var a = api();
    if(!a || !a.applyBuilderResult) return;

    var pending = views.filter(function(v){ return v.canvas && v.canvas.getObjects().length; });
    if(!pending.length) return;
    pending.sort(function(x, y){ return viewOrder(x.id) - viewOrder(y.id); });

    // Provisional: no img yet, because nothing has been uploaded. The qty
    // screen renders from `previews`, not from these, and the modal will
    // not write cart state until prepareSides() has filled them in.
    var provisional = pending.map(function(v){
      return { placement: v.id, img: '', label: v.label + ' design', notes: v.notes || '' };
    });

    // The builder stays open underneath: sizes is a step on top of the
    // design, not a departure from it, so closing that modal has to put
    // the shopper back exactly where they were.
    flushSettled();
    track('builder-continue', {
      scene: logScene(),
      elements: elements().map(function(e){ return logElement(e.obj); })
    });
    sizesOpen = true;
    a.applyBuilderResult(provisional, {
      keepBuilder: true,
      previews: viewPreviews(),
      prepare: prepareSides,
      // The colour can have been changed in here since the modal opened,
      // and the modal's copy of the shirt is what picks the cart variant
      // and names the product from here on.
      shirtKey: shirt && shirt.key
    });
  }

  // Editing an existing cart design: export and upload the sides, swap
  // them into that design, and let the cart take it from there. The cart
  // page listens for the state change, syncs the line item and reloads —
  // so this does not navigate itself.
  function updateCartDesign(){
    if(builderBusy || restoreFailed) return;
    var a = api();
    if(!a || !a.applyBuilderUpdate || cartDesignIdx === null || !shirt) return;
    if(!hasArtwork()) return;
    // A design in the cart is filed under the shirt it was added as, and
    // its sizes and quantities are allocated against that variant. Moving
    // it to another colour is a different cart line, not an edit of this
    // one, so this says so rather than either failing to find the design
    // or quietly updating the artwork and leaving the colour behind.
    if(cartShirtKey && shirt.key !== cartShirtKey){
      showMessageSafe('Change Color',
        'This design is already in your cart in a different color. Changing the ' +
        'color here would need a new cart item — remove the one in your cart ' +
        'and build it again in this color.');
      return;
    }

    setBusy(true, 'Updating design…');
    prepareSides().then(function(sides){
      if(cartDesignSnapshot !== cartDesignState()) throw new Error('This cart design changed while you were editing. Please reopen it from the cart before updating.');
      var ok = a.applyBuilderUpdate(cartShirtKey || shirt.key, cartDesignIdx, sides);
      if(!ok) throw new Error('That design could not be found in your cart.');
      // Close on the way out: the cart's own spinner is already up from the
      // state change, and it reloads the page when the sync lands.
      setBusy(false);
      closeBuilder(false);
    }).catch(function(err){
      setBusy(false);
      warn('[ShirtBuilder] cart update failed', err);
      showMessageSafe('Update Design',
        (err && err.message) || 'Your design could not be updated. Please try again.');
    });
  }

  // Export + upload every designed side. Resolves with the finished sides
  // in placement order; rejects with a message worth showing. Called by the
  // modal from Add to Cart, which owns the progress overlay — so this
  // deliberately shows none of its own.
  function prepareSides(){
    if(restoreFailed) return Promise.reject(new Error('The design did not finish loading. Please close and reopen it before continuing.'));
    if(views.some(function(v){ return v.canvas && v.canvas.getObjects().some(function(o){ return o.sbBgBusy; }); })){
      return Promise.reject(new Error('Please wait for background removal to finish before continuing.'));
    }
    var a = api();
    if(!a || !a.uploadArtwork) return Promise.reject(new Error('Uploads are unavailable right now.'));

    var pending = views.filter(function(v){ return v.canvas && v.canvas.getObjects().length; });
    if(!pending.length) return Promise.reject(new Error('There is nothing on the shirt to add.'));

    var sides = [];
    var chain = Promise.resolve();

    pending.forEach(function(v){
      chain = chain.then(function(){
        var out = exportSide(v);
        if(!out) throw new Error('The ' + v.label + ' design could not be exported. Please check that its artwork is inside the print area.');
        if(out.error) throw new Error('This design could not be exported. Please remove the most recently added artwork and try again.');
        var file = blobFile(dataUrlToBlob(out.dataUrl), 'builder-' + v.id + '-' + Date.now() + '.png');
        return a.uploadArtwork(file, {
          addToHistory: false,
          source: 'builder',
          label: v.label + ' design'
        }).then(function(design){
          if(!design || !/^https:\/\//i.test(design.img || '')) throw new Error('Artwork upload returned an invalid address. Please try again.');
          return uploadScene(v).then(function(sceneUrl){
            // A flat picture of this side as it will be worn. Stored with
            // the line so the cart shows an image rather than compositing
            // a garment shot and a transparent PNG on every render.
            return uploadSidePreview(v).then(function(previewUrl){
              sides.push({
                placement: v.id,
                img: design.img,
                label: v.label + ' design',
                notes: v.notes || '',
                sceneUrl: sceneUrl,
                preview: previewUrl
              });
            });
          });
        });
      });
    });

    return chain.then(function(){
      if(sides.length !== pending.length) throw new Error('This design could not be prepared completely. Please try again.');
      // Keep the placement order stable (front before back) regardless of
      // which side the shopper happened to finish first.
      sides.sort(function(x, y){ return viewOrder(x.placement) - viewOrder(y.placement); });
      return sides;
    });
  }


  // ============================================================
  // SAVING A DESIGN
  // ============================================================
  var SAVES_URL = 'https://dix7ak1o8b.execute-api.us-east-1.amazonaws.com/dev/public/customDesignSaves';
  // Survives the login redirect. sessionStorage, not local: an unsaved
  // design is worth carrying across one navigation, not across days.
  var PENDING_KEY = 'sib.builder.pending';
  // Marker the login return_to carries, so the page knows to reopen the
  // builder and resume the save it was interrupted mid-way through.
  var RESTORE_FLAG = 'sb_restore';

  // Identity of the design currently open, once it has been saved once.
  var savedGuid = null;
  var savedName = '';
  var pendingSaveAttempt = null;
  // Whether anything has changed since the last successful save. A design
  // that has never been saved counts as dirty the moment it has artwork.
  var dirtySinceSave = false;
  // Where to go once the leaving prompt is answered: 'cancel' or 'back'.
  var exitIntent = null;
  // True while the sizes modal is stacked over the builder. The builder is
  // still mounted and still listening, so its keyboard shortcuts would
  // otherwise fire underneath the modal that has focus.
  var sizesOpen = false;
  // Set when the builder was opened to edit a design that is already IN
  // the cart (the cart card's orange Edit). That changes three things:
  //
  //   * "Use Quick & Easy Instead" makes no sense — the design exists and
  //     was laid out on a canvas, which the quick flow cannot represent.
  //   * Leaving means going back to the cart, not abandoning a new design.
  //   * There is nothing unsaved to warn about: the design is already in
  //     the cart, and leaving without touching Sizes simply leaves it as
  //     it was. The prompt exists for work that would be lost.
  var cartEdit = false;
  // Which cart design is being edited, so the update lands on the right one.
  var cartDesignIdx = null;
  // And the shirt it is filed under. Held separately from `shirt`, which
  // follows the colour picker: a design in the cart belongs to the variant
  // it was added as, so the update has to be looked up by the key it came
  // in with rather than whatever colour the builder is showing now.
  var cartShirtKey = null;
  var cartDesignSnapshot = null;
  function cartDesignState(){
    var a = api();
    var state = a && a.getState ? a.getState() : null;
    var item = state && state.cartCustom && state.cartCustom[cartShirtKey];
    return JSON.stringify(item && item.customDesigns && item.customDesigns[cartDesignIdx] || null);
  }
  // When the builder opened, for the time-in-tool figure on close.
  var openedAt = null;

  function savesCall(action, payload){
    var a = api();
    if(!window.fetch || !a || !a.customerId) return Promise.resolve(null);
    var body = Object.assign({ action: action, customer_id: String(a.customerId() || '') }, payload || {});
    return builderRetry(function(){ return builderFetch(SAVES_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(r){
      if(!r.ok){ var err = new Error('Saved designs request failed: ' + r.status); err.status = r.status; throw err; }
      return r.json();
    }); })
      .catch(function(err){
        warn('[ShirtBuilder] save ' + action + ' failed', err);
        return null;
      });
  }

  // The whole builder state, in the shape the endpoint stores and
  // restoreDocument() reads back. Object src is normalised to the
  // canonical https address, since a blob: URL dies with the page.
  function designDocument(){
    return {
      version: 1,
      shirt: shirt,
      savedGuid: savedGuid,
      savedName: savedName,
      views: views.map(function(v){
        var json = v.canvas ? v.canvas.toJSON(SCENE_PROPS) : { objects: [] };
        (json.objects || []).forEach(function(o){ if(o.sbSrc) o.src = effectiveSrc(o); });
        return { id: v.id, notes: v.notes || '', canvas: json };
      })
    };
  }

  function hasArtwork(){
    return views.some(function(v){ return v.canvas && v.canvas.getObjects().length; });
  }

  // ── The login round trip ───────────────────────────────────────────
  function stashPending(){
    try { sessionStorage.setItem(PENDING_KEY, JSON.stringify(designDocument())); return true; }
    catch(e){ warn('[ShirtBuilder] could not stash design', e); return false; }
  }
  function readPending(){
    try {
      var raw = sessionStorage.getItem(PENDING_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch(e){ return null; }
  }
  function clearPending(){
    try { sessionStorage.removeItem(PENDING_KEY); } catch(e){}
  }

  // mode 'save' resumes the interrupted save on return; 'browse' reopens
  // the saved-designs list instead. Either way the design in progress rides
  // along in sessionStorage so the round trip never costs their work.
  function goSignIn(mode){
    var a = api();
    if(!a || !a.loginUrl) return;
    if(!stashPending()){
      showMessageSafe('Sign In', 'Your browser could not preserve this design for sign-in. Please allow browser storage before continuing.');
      return;
    }
    closeSignInToSave();
    var back = location.pathname + location.search;
    back += (back.indexOf('?') > -1 ? '&' : '?') + RESTORE_FLAG + '=' +
            (mode === 'browse' ? 'browse' : 'save');
    location.href = a.loginUrl(back);
  }

  // ── Save ───────────────────────────────────────────────────────────
  // Leaving with work that is not in the account yet is the one moment
  // worth interrupting for. An empty stage, or a design already saved and
  // untouched since, closes straight through.
  function requestExit(intent){
    // Admin: nothing to save to, so nothing to warn about. The prompt the
    // storefront shows below is unreachable here.
    runExit(intent);
    return;
    // A cart edit has nothing to lose by leaving: the design is already in
    // the cart and stays exactly as it was unless they go through Sizes.
    // The prompt is for work that would otherwise vanish.
    if(cartEdit){ runExit(intent); return; }
    if(!hasArtwork() || (savedGuid && !dirtySinceSave)){ runExit(intent); return; }
    exitIntent = intent;
    $('sb-exit-copy').textContent = savedGuid
      ? 'You have changes that haven\u2019t been saved yet.'
      : 'This design hasn\u2019t been saved to your account yet.';
    $('sb-exit-ov').classList.add('open');
  }

  function closeExitDialog(){
    $('sb-exit-ov').classList.remove('open');
    exitIntent = null;
  }

  function runExit(intent){
    $('sb-exit-ov').classList.remove('open');
    exitIntent = null;
    // Only ever 'back' or 'cancel' now: the sizes step opens over the
    // builder instead of leaving it, so it never routes through here.
    // 'back' returns to the custom-design modal so the quick path is one
    // click away; 'cancel' (the X, and Cancel Design) leaves custom design
    // altogether. Both come through the same unsaved-work prompt.
    //
    // A cart edit has no modal behind it worth returning to — the shopper
    // came from the cart, so every way out lands them back there.
    closeBuilder(intent === 'back' && !cartEdit);
  }

  // Save, then carry on to wherever they were heading. If they are signed
  // out, saveDesign() navigates to login instead and the design is stashed
  // — so there is nothing to continue to, by design.
  function saveThenExit(){
    var intent = exitIntent;
    $('sb-exit-ov').classList.remove('open');
    exitIntent = null;
    exitAfterSave = intent;
    saveDesign();
  }
  var exitAfterSave = null;

  function saveDesign(){
    if(!hasArtwork()) return;
    var a = api();
    if(!a) return;
    // No account means no owner to attach the design to. Explain that
    // before moving them off the page — a Save button that silently
    // navigates to a login screen reads as having lost the design.
    if(a.isSignedIn && !a.isSignedIn()){ openSignInToSave(); return; }
    if(savedGuid){ commitSave(savedName); return; }
    openNameDialog();
  }

  function openSignInToSave(){ $('sb-signin-ov').classList.add('open'); }
  function closeSignInToSave(){ $('sb-signin-ov').classList.remove('open'); }

  function openNameDialog(){
    clearError('sb-name-err');
    var inp = $('sb-name-inp');
    inp.value = savedName || defaultDesignName();
    $('sb-name-ov').classList.add('open');
    inp.focus();
    inp.select();
  }
  function closeNameDialog(){ $('sb-name-ov').classList.remove('open'); }

  // Something better than an empty box to start from.
  function defaultDesignName(){
    var found = null;
    views.forEach(function(v){
      if(found || !v.canvas) return;
      v.canvas.getObjects().forEach(function(o){
        if(!found && o.type === 'sb-text' && o.text) found = o.text;
      });
    });
    if(found) return found.replace(/\s+/g, ' ').trim().slice(0, 60);
    return String((shirt && shirt.name) || 'My design').slice(0, 60);
  }

  function submitName(){
    var name = $('sb-name-inp').value.trim();
    if(!name){ showError('sb-name-err', 'Please enter a name for this design.'); return; }
    closeNameDialog();
    commitSave(name);
  }

  // Flatten a preview, then write the row. The thumbnail is best-effort:
  // a failed render must not cost the shopper their design.
  // The gallery thumbnail: the design ON the shirt it was made for, not
  // loose artwork on a transparency checkerboard. A saved design is
  // recognised by what it looks like worn, and "which shirt was this?" was
  // unanswerable from the old thumbs.
  //
  // A double-sided design draws both sides side by side in the same square,
  // each smaller than a single-side thumb would be — which is itself the
  // signal that there are two.
  var SAVED_THUMB_PX = 900;

  // Fit src dimensions into a box the way object-fit:contain does, centred.
  function containRect(sw, sh, bx, by, bw, bh){
    var scale = Math.min(bw / (sw || 1), bh / (sh || 1));
    var w = (sw || 1) * scale, h = (sh || 1) * scale;
    return { x: bx + (bw - w) / 2, y: by + (bh - h) / 2, w: w, h: h };
  }

  function loadImageEl(url){
    return new Promise(function(resolve){
      if(!url) return resolve(null);
      var img = new Image();
      img.onload = function(){ resolve(img); };
      img.onerror = function(){ resolve(null); };
      img.src = url;
    });
  }

  // Composites the sides that carry artwork. Resolves null when it cannot
  // be done cleanly, so the caller can fall back to the old artwork-only
  // thumbnail rather than saving something broken.
  // Composite the given sides into one square PNG: the garment with its
  // artwork layered on top, laid out left to right. Resolves null when it
  // cannot be done cleanly, so callers can fall back rather than storing
  // something broken.
  //
  // The garment photos go through loadArtwork so they arrive as
  // same-origin blobs. Drawing them straight from the CDN would taint the
  // canvas and toDataURL would throw — the same reason canvas artwork
  // takes this route.
  function compositeSides(sides, px){
    if(!sides || !sides.length) return Promise.resolve(null);
    var size = px || SAVED_THUMB_PX;
    // Each side is drawn into a slot this wide, so that is the resolution
    // to ask the canvas for.
    var slotPx = Math.round(size / sides.length);

    return Promise.all(sides.map(function(v){
      return Promise.all([
        loadArtwork(v.garment).then(loadImageEl),
        loadImageEl(viewArtPng(v, slotPx))
      ]).then(function(pair){
        return { garment: pair[0], art: pair[1] };
      });
    })).then(function(layers){
      var cv = document.createElement('canvas');
      cv.width = size;
      cv.height = size;
      var ctx = cv.getContext('2d');
      // White, not transparent: this is a photo of a garment now, and a
      // transparent ground would put a checkerboard behind the shirt.
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, cv.width, cv.height);

      var slotW = size / layers.length;
      var drew = false;
      layers.forEach(function(l, i){
        // Both layers share the garment's frame, so fitting them into the
        // same slot rect lines the artwork up on the shirt exactly.
        var ref = l.garment || l.art;
        if(!ref) return;
        var r = containRect(ref.naturalWidth || ref.width, ref.naturalHeight || ref.height,
                            i * slotW, 0, slotW, size);
        if(l.garment){ ctx.drawImage(l.garment, r.x, r.y, r.w, r.h); drew = true; }
        if(l.art){ ctx.drawImage(l.art, r.x, r.y, r.w, r.h); drew = true; }
      });
      if(!drew) return null;
      try { return cv.toDataURL('image/png'); }
      catch(e){
        // A garment shot that refused CORS tainted the canvas.
        warn('[ShirtBuilder] composite tainted, falling back', e);
        return null;
      }
    }).catch(function(err){
      warn('[ShirtBuilder] composite failed', err);
      return null;
    });
  }

  // Every designed side, side by side — the saved-designs gallery thumb.
  function renderSavedThumb(){
    return compositeSides(views.filter(function(v){
      return v.canvas && v.canvas.getObjects().length;
    }));
  }

  // One side on its own, for the copy stored with the cart line. Rendering
  // it once at add-to-cart time means the cart — and anything else showing
  // an order — displays a plain <img> instead of re-deriving the design.
  var SIDE_PREVIEW_PX = 1000;
  function renderSidePreview(v){
    return compositeSides([v], SIDE_PREVIEW_PX);
  }

  function uploadPreview(){
    var a = api();
    var front = views[0];
    if(!a || !a.uploadArtwork || !hasArtwork()) return Promise.resolve(null);

    function put(dataUrl){
      try {
        var file = blobFile(dataUrlToBlob(dataUrl), 'saved-' + Date.now() + '.png');
        return a.uploadArtwork(file, { addToHistory: false, source: 'builder-preview' })
          .then(function(d){ return d && d.img; })
          .catch(function(){ return null; });
      } catch(e){ return Promise.resolve(null); }
    }

    return renderSavedThumb().then(function(dataUrl){
      if(dataUrl) return put(dataUrl);
      // Fall back to the flattened artwork, which is what saves made
      // before this looked like — better a thumbnail than none.
      if(!front || !front.canvas || !front.canvas.getObjects().length) return null;
      var shot = exportSide(front);
      if(!shot || shot.error || !shot.dataUrl) return null;
      return put(shot.dataUrl);
    });
  }

  function commitSave(name){
    if(builderBusy || restoreFailed) return;
    if(views.some(function(v){ return v.canvas && v.canvas.getObjects().some(function(o){ return o.sbBgBusy; }); })){
      showMessageSafe('Save Design', 'Please wait for background removal to finish before saving.'); return;
    }
    setBusy(true, 'Saving your design…');
    var doc;
    try { doc = designDocument();
    doc.savedName = name;
    var serialized = JSON.stringify(doc);
    if(!savedGuid && (!pendingSaveAttempt || pendingSaveAttempt.document !== serialized)){
      var bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      bytes[6] = (bytes[6] & 15) | 64;
      bytes[8] = (bytes[8] & 63) | 128;
      var hex = Array.prototype.map.call(bytes, function(b){ return ('0' + b.toString(16)).slice(-2); }).join('');
      pendingSaveAttempt = { document: serialized, id: hex.slice(0,8) + '-' + hex.slice(8,12) + '-' + hex.slice(12,16) + '-' + hex.slice(16,20) + '-' + hex.slice(20) };
    }
    } catch(err){ setBusy(false); exitAfterSave = null; showMessageSafe('Save Design', 'Your design could not be prepared for saving.'); return; }
    Promise.resolve().then(uploadPreview).then(function(thumbUrl){
      return savesCall('save', {
        guid: savedGuid || undefined,
        request_id: !savedGuid && pendingSaveAttempt ? pendingSaveAttempt.id : undefined,
        name: name,
        design_json: serialized,
        thumbnail_url: thumbUrl || undefined,
        shirt_key: shirt && shirt.key,
        shirt_name: shirt && shirt.name,
        shirt_color: shirt && shirt.color
      });
    }).then(function(res){
      setBusy(false);
      if(!res || !res.success || !/^[0-9a-f-]{36}$/i.test(res.guid || '')){
        exitAfterSave = null;
        showMessageSafe('Save Design',
          (res && res.error) || 'Your design could not be saved. Please try again.');
        return;
      }
      var currentDoc = designDocument();
      currentDoc.savedName = name;
      var unchanged = JSON.stringify(currentDoc) === serialized;
      savedGuid = res.guid || savedGuid;
      pendingSaveAttempt = null;
      savedName = name;
      dirtySinceSave = !unchanged;
      clearPending();
      syncSaveButton();
      if(exitAfterSave && unchanged){
        var intent = exitAfterSave;
        exitAfterSave = null;
        runExit(intent);
      }
      exitAfterSave = null;
    }).catch(function(err){
      setBusy(false);
      exitAfterSave = null;
      warn('[ShirtBuilder] save failed', err);
      showMessageSafe('Save Design', 'Your design could not be saved. Please try again.');
    });
  }

  function showMessageSafe(title, message){
    var a = api();
    if(a && a.showMessage) a.showMessage({ title: title, message: message });
    else alert(message);
  }

  // The button is the save state, not just a trigger: once a design is
  // stored and untouched there is nothing to save, so it greys out and
  // says so. Any edit runs through capture(), which marks the design dirty
  // and refreshes this — so it re-enables on its own.
  function syncSaveButton(any){
    var btn = $('sb-save');
    if(!btn) return;
    if(typeof any !== 'boolean') any = hasArtwork();
    var saved = !!savedGuid && !dirtySinceSave && any;
    btn.disabled = !any || saved;
    btn.classList.toggle('is-saved', saved);
    var label = btn.querySelector('span');
    if(label) label.textContent = saved ? 'Saved' : 'Save';
    btn.title = saved ? 'This design is saved' : 'Save this design to your account';
    var dock = $('sb-dock-save');
    if(dock){
      dock.disabled = btn.disabled;
      var dockLabel = dock.querySelector('span');
      if(dockLabel) dockLabel.textContent = saved ? 'Saved' : 'Save';
    }
    syncNameBar();
  }

  // The name row mirrors savedGuid/savedName: no row until the design has
  // an identity to name.
  function syncNameBar(){
    var bar = $('sb-namebar'), btn = $('sb-namebar-btn'), inp = $('sb-namebar-inp');
    if(!bar) return;
    bar.hidden = !savedGuid;
    if(!savedGuid){ closeRename(); return; }
    if(inp.hidden) btn.textContent = savedName || 'Untitled design';
  }

  function openRename(){
    if(!savedGuid) return;
    var btn = $('sb-namebar-btn'), inp = $('sb-namebar-inp');
    inp.value = savedName || '';
    btn.hidden = true;
    inp.hidden = false;
    inp.focus();
    inp.select();
  }

  function closeRename(){
    var btn = $('sb-namebar-btn'), inp = $('sb-namebar-inp');
    if(!inp || inp.hidden) return;
    inp.hidden = true;
    btn.hidden = false;
  }

  // Writes the name and nothing else. commitSave() would also push the
  // current scene, which would quietly save edits the shopper has not
  // chosen to save yet — the whole point of a separate endpoint action.
  function commitRename(){
    if(builderBusy) return;
    var inp = $('sb-namebar-inp');
    if(!inp || inp.hidden) return;
    var name = (inp.value || '').trim().slice(0, 120);
    closeRename();
    if(!savedGuid || !name || name === savedName){ syncNameBar(); return; }
    var previous = savedName;
    // Show it straight away; the request is a background confirmation.
    savedName = name;
    syncNameBar();
    setBusy(true, 'Renaming design...');
    savesCall('rename', { guid: savedGuid, name: name }).then(function(res){
      setBusy(false);
      if(res && res.success) return;
      savedName = previous;
      syncNameBar();
      showMessageSafe('Rename Design',
        (res && res.error) || 'That name could not be saved. Please try again.');
    });
  }

  function viewOrder(id){
    for(var i = 0; i < views.length; i++) if(views[i].id === id) return i;
    return 99;
  }

  // ============================================================
  // OPEN / CLOSE
  // ============================================================
  // Which sides the builder can offer: a placement the product allows,
  // that we hold a blank garment shot for. Pocket is intentionally absent
  // — it is a small fixed print the quick path already handles better
  // than a free canvas would.
  function buildViews(s){
    var allowed = Array.isArray(s.allowedPlacements)
      ? s.allowedPlacements.map(function(x){ return String(x).toLowerCase().trim(); })
      : null;
    function ok(label){ return !allowed || allowed.indexOf(label.toLowerCase()) > -1; }

    var defs = [
      { id:'front', label:'Front', garment: s.designFront },
      { id:'back',  label:'Back',  garment: s.designBack }
    ];
    return defs.filter(function(d){ return d.garment && ok(d.label); })
               .map(function(d){
                 return { id:d.id, label:d.label, garment:d.garment,
                          canvas:null, el:null, natural:null, design:null,
                          history:[], redo:[], notes:'' };
               });
  }

  function measure(url){
    return new Promise(function(resolve){
      var img = new Image();
      img.onload  = function(){ resolve({ w: img.naturalWidth || 1000, h: img.naturalHeight || 1200 }); };
      img.onerror = function(){ resolve(null); };   // a broken shot drops its view
      img.src = url;
    });
  }

  function openBuilder(detail){
    var a = api();
    if(!a) return;
    shirt = detail && detail.shirt;
    if(!shirt) return;
    // The cart passes the index of the design being edited; the PDP promo
    // card and the login restore do not.
    cartEdit = !!(detail && typeof detail.designIdx === 'number');
    cartDesignIdx = cartEdit ? detail.designIdx : null;
    cartShirtKey = cartEdit ? (shirt && shirt.key) || null : null;
    cartDesignSnapshot = cartEdit ? cartDesignState() : null;
    syncCartEditChrome();
    openedAt = Date.now();
    track('builder-open', {
      shirt: shirt && shirt.key,
      color: shirt && shirt.color,
      // Which door they came through: the method selector on the first
      // modal screen, the cart's Edit on an existing design, or the
      // restore that runs after a sign-in round trip.
      entry: cartEdit ? 'cart-edit' : (detail && detail.restored ? 'login-restore' : 'modal'),
      design_index: cartDesignIdx,
      sides: (detail && detail.placements ? detail.placements.length : null),
      incoming_placements: (detail && detail.assignments ? detail.assignments.length : 0)
    });

    var candidates = buildViews(shirt);
    if(!candidates.length){
      a.showMessage && a.showMessage({
        title: 'Shirt Builder',
        message: 'This product does not have builder artwork set up yet. Choose a location instead and we’ll email you a proof.'
      });
      a.returnFromBuilder && a.returnFromBuilder();
      return;
    }

    $('sb-ov').classList.add('open');
    $('sb-ov').setAttribute('aria-hidden', 'false');
    // Captured BEFORE the lock: overflow:hidden leaves the page where it
    // is, and this is the position to put it back to if the iOS keyboard
    // scrolls it out from under us.
    lockedScrollY = pageScrollY();
    document.documentElement.classList.add('sb-locked');
    // Suppress the floating third-party widgets. Opening from the modal
    // already has this applied; opening from a login restore does not.
    // Claimed as 'builder': the modal closes behind us on the ordinary
    // way in here, and its own release must not take our mask with it.
    if(a.setOverlayMask) a.setOverlayMask(true, 'builder');
    isOpen = true;
    setBusy(true, 'Loading the design studio…');


    requestFonts();

    return Promise.all([loadFabric()].concat(candidates.map(function(v){ return measure(v.garment); })))
      .then(function(res){
        fabric = res[0];
        defineSbText(fabric);
        // Whatever the previous session left behind, this one starts clean.
        views.forEach(function(v){
          if(v.canvas){ try { v.canvas.dispose(); } catch(e){} }
        });
        resetStage();
        views = [];
        candidates.forEach(function(v, i){
          var nat = res[i + 1];
          if(!nat) return;                        // garment shot failed to load
          v.natural = nat;
          v.design = { w: DESIGN_W, h: Math.round(DESIGN_W * nat.h / nat.w) };
          views.push(v);
        });
        if(!views.length) throw new Error('The garment images for this product could not be loaded.');

        activeIdx = 0;
        views.forEach(function(v){ ensureCanvas(v); v.el.style.display = 'none'; });
        showView(0);
        renderShirtBox();
        views.forEach(function(v){ v.history = [JSON.stringify(v.canvas.toJSON())]; });

        scheduleElements();
        watchStage();
        restoreFailed = false;
        // A proof being re-opened for editing hands its stored scene in
        // here. applyRestore() is the login-round-trip path, which does
        // exactly the right thing with it: rebuild each side, re-resolve
        // the artwork through the blob loader so it stays export-safe, and
        // reset the history.
        if(detail && detail.document) pendingRestore = detail.document;
        return applyRestore().then(function(restored){
          return seedFromAssignments(detail && detail.assignments).then(function(){
            setBusy(false);
            refreshChrome();
            if(restored && restored.resumeSave && hasArtwork()) saveDesign();
            else if(restored && restored.resumeBrowse) openSavedDesigns();
          });
        });
      })
      .catch(function(err){
        setBusy(false);
        warn('[ShirtBuilder] open failed', err);
        closeBuilder(true);
        a.showMessage && a.showMessage({
          title: 'Shirt Builder',
          message: (err && err.message) || 'The design studio could not be opened. Please try again.'
        });
      });
  }

  // Re-entering the builder on a design that already has placements: a
  // scene is replayed exactly, and a plain uploaded image is dropped onto
  // its side at the default size so nothing the shopper picked is lost.
  function seedFromAssignments(assignments){
    if(!Array.isArray(assignments) || !assignments.length) return Promise.resolve();
    return Promise.all(assignments.map(function(as){
      var idx = -1;
      views.forEach(function(v, i){ if(v.id === as.placement) idx = i; });
      if(idx < 0 || !as.design) throw new Error('A design placement could not be loaded for this shirt.');
      var v = views[idx];
      v.notes = as.notes || v.notes;
      if(as.design.sceneUrl) return loadScene(v, as.design.sceneUrl);
      if(as.design.img) return seedImage(v, as.design.img, as.design.label);
      throw new Error('A design is missing its artwork.');
    })).then(syncNotes).then(function(){
      // The cart-edit path: a design coming back from the cart never goes
      // through applyRestore, so its colours have to be harvested here or
      // a colour already on the shirt has no swatch to reapply it from.
      harvestCustomColors();
    });
  }

  function loadScene(v, url){
    return builderRetry(function(){ return builderFetch(url, { cache: 'no-store' })
      .then(function(r){ if(!r.ok){ var err = new Error('scene ' + r.status); err.status = r.status; throw err; } return r.json(); }); })
      .then(function(scene){
        if(!scene || !scene.canvas || (scene.view && scene.view !== v.id)) throw new Error('Invalid design scene.');
        return stageScene(scene.canvas);
      }).then(function(objects){
        objects.forEach(function(o){ adoptObject(o); v.canvas.add(o); });
        adoptFontsInUse();
        return remeasureText(v).then(function(){
          v.history = [JSON.stringify(v.canvas.toJSON(SCENE_PROPS))];
          v.canvas.renderAll();
          refreshChrome();
        });
      }).catch(function(err){ restoreFailed = true; throw err; });
  }

  function seedImage(v, url, label){
    return stageScene({ objects: [{ type: 'image', src: url, sbSrc: url }] }).then(function(objects){
        var img = objects[0];
        if(!img || !img.width) throw new Error('Artwork could not be loaded.');
        var box = dropBox(v);
        var scale = Math.min(box.w / img.width, box.h / img.height);
        img.set({ scaleX: scale, scaleY: scale, originX:'center', originY:'center',
                  left: box.cx, top: box.cy });
        img.sbSrc = url;
        img.sbLabel = label || '';
        img.sbBaseW = img.getScaledWidth();
        applyControls(fabric, img, controlHandlers);
        v.canvas.add(img);
        v.canvas.renderAll();
        v.history = [JSON.stringify(v.canvas.toJSON(SCENE_PROPS))];
        refreshChrome();
    });
  }

  // A design handed in from sessionStorage after a login round trip.
  // Consumed once, by the open it was stashed for.
  var pendingRestore = null;

  // Load a replacement off-stage so a failed request cannot clear the
  // customer's current work. Only complete scenes reach the live canvas.
  function stageScene(json){
    if(!json || !Array.isArray(json.objects)) return Promise.reject(new Error('Invalid design scene.'));
    var canvas = new fabric.StaticCanvas(null);
    return new Promise(function(resolve, reject){
      var finished = false;
      var timer = setTimeout(function(){
        finished = true;
        reject(new Error('Design loading timed out. Please try again.'));
      }, 150000);
      Promise.all([prepareSceneFonts(json)].concat(json.objects.map(function(o){
        if(!o.sbSrc) return null;
        if(o.sbBgSrc) bgCache[o.sbSrc] = o.sbBgSrc;
        return loadArtwork(effectiveSrc(o)).then(function(src){ o.src = src; });
      }))).then(function(){
        if(finished){ canvas.dispose(); return; }
        canvas.loadFromJSON(json, function(){
          if(finished){ canvas.dispose(); return; }
          var objects = canvas.getObjects().slice();
          var invalid = objects.length !== json.objects.length || objects.some(function(o){
            return o.type === 'image' && (!o.width || !o.height);
          });
          finished = true;
          clearTimeout(timer);
          canvas.remove.apply(canvas, objects);
          canvas.dispose();
          if(invalid) reject(new Error('Some artwork could not be loaded.'));
          else resolve(objects);
        });
      }).catch(function(err){
        if(finished) return;
        finished = true;
        clearTimeout(timer);
        canvas.dispose();
        reject(err);
      });
    });
  }

  function applyRestore(){
    var doc = pendingRestore;
    pendingRestore = null;
    if(!doc) return Promise.resolve();
    setBusy(true, 'Restoring design...');
    var loads = (doc.views || []).map(function(saved){
      var v = views.find(function(candidate){ return candidate.id === saved.id; });
      if(!v || !saved.canvas) return Promise.reject(new Error('A saved placement is unavailable for this shirt.'));
      return stageScene(saved.canvas).then(function(objects){
        return { view: v, saved: saved, objects: objects };
      });
    });
    return Promise.all(loads).then(function(staged){
      views.forEach(function(v){
        v.canvas.discardActiveObject();
        v.canvas.remove.apply(v.canvas, v.canvas.getObjects().slice());
        v.notes = '';
      });
      staged.forEach(function(entry){
        entry.objects.forEach(function(o){ adoptObject(o); entry.view.canvas.add(o); });
        entry.view.notes = entry.saved.notes || '';
        entry.view.canvas.renderAll();
        entry.view.history = [JSON.stringify(entry.view.canvas.toJSON(SCENE_PROPS))];
      });
      // Colours mixed in an earlier session arrive with the design, and
      // have to come back as swatches — otherwise a colour already on the
      // shirt is one the shopper cannot apply to anything else.
      harvestCustomColors();
      savedGuid = doc.savedGuid || null;
      savedName = doc.savedName || '';
      dirtySinceSave = !doc.savedGuid;
      adoptFontsInUse();
      return Promise.all(views.map(remeasureText));
    }).then(function(){
      syncNotes();
      refreshChrome();
      restoreFailed = false;
      setBusy(false);
      return doc;
    }).catch(function(err){
      setBusy(false);
      throw err;
    });
  }

  // The sizes modal closing hands control back. It is a plain event rather
  // than a bridge callback so neither side has to hold a reference to the
  // other's internals.
  document.addEventListener('sib:builder-sizes-closed', function(){
    sizesOpen = false;
    if(isOpen) refreshChrome();
  });

  // The design went into the cart, so the builder's work is finished. No
  // returnToModal: the modal has already closed itself.
  document.addEventListener('sib:builder-done', function(){
    sizesOpen = false;
    if(isOpen) closeBuilder(false);
  });

  // Reopen the builder after a login redirect. The flag rides in the
  // return_to; the design itself never leaves this browser.
  function resumeAfterLogin(){
    var flag = location.search.match(new RegExp('[?&]' + RESTORE_FLAG + '=([^&]*)'));
    if(!flag) return;
    var doc = readPending();
    if(!doc || !doc.shirt) { clearPending(); return; }
    doc.resumeSave = flag[1] !== 'browse';
    doc.resumeBrowse = flag[1] === 'browse';
    pendingRestore = doc;
    // Keep the draft and restore flag until saving succeeds. A failed
    // restore must remain recoverable by refreshing after connectivity returns.
    openBuilder({ shirt: doc.shirt, assignments: [] });
  }

  function closeBuilder(returnToModal){
    if(!isOpen) return;
    flushSettled();
    track('builder-close', {
      returned_to_modal: !!returnToModal,
      seconds_open: openedAt ? Math.round((Date.now() - openedAt) / 1000) : null,
      saved: !!savedGuid,
      unsaved_changes: !!dirtySinceSave,
      scene: logScene()
    });
    openedAt = null;
    isOpen = false;
    sizesOpen = false;
    cartEdit = false;
    cartDesignIdx = null;
    cartShirtKey = null;
    unwatchStage();
    $('sb-ov').classList.remove('open');
    $('sb-ov').setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('sb-locked');
    // Any dialog height left over from the keyboard, and any scroll iOS
    // performed while it was up.
    syncSubViewport();
    restorePageScroll();
    // Lift it here; returnFromBuilder re-applies it for the modal, which
    // is still covering the page.
    var bridge = api();
    if(bridge && bridge.setOverlayMask) bridge.setOverlayMask(false, 'builder');
    setBusy(false);
    $('sb-all-ov').classList.remove('open');
    $('sb-exit-ov').classList.remove('open');
    closeColorPicker();
    closeFontPicker();
    closeSignInToSave();
    closeStartOver();
    hideCenterGuide();
    closeNotes();
    closeDeleteSaved();
    closeSavedDesigns();
    closeNameDialog();
    closeTool();
    // Dispose the canvases: fabric attaches document-level listeners per
    // instance, and leaving several sets live across repeated opens is
    // how a builder ends up handling the same drag twice.
    views.forEach(function(v){
      if(v.canvas){ try { v.canvas.dispose(); } catch(e){} }
      if(v.el && v.el.parentNode) v.el.parentNode.removeChild(v.el);
      v.canvas = null; v.el = null;
    });
    views = [];
    activeIdx = 0;
    savedGuid = null;
    savedName = '';
    dirtySinceSave = false;
    exitAfterSave = null;
    resetStage();
    releaseArtwork();
    if(returnToModal){
      var a = api();
      a && a.returnFromBuilder && a.returnFromBuilder();
    }
  }

  // Instructions are kept per side — front and back can need different
  // things — so this reflects whichever view is on screen.
  function syncNotes(){
    var v = view(), btn = $('sb-notes-btn'), card = $('sb-notes-card');
    if(!btn || !card) return;
    var text = (v && v.notes) || '';
    btn.hidden = !!text;
    card.hidden = !text;
    if(text) $('sb-notes-text').textContent = text;
  }

  function openNotes(){
    $('sb-notes-ta').value = (view() || {}).notes || '';
    $('sb-notes-ov').classList.add('open');
    $('sb-notes-ta').focus();
  }
  function closeNotes(){ $('sb-notes-ov').classList.remove('open'); }

  function setNotes(text){
    var v = view();
    if(!v) return;
    v.notes = text;
    // Instructions travel with the design, so changing them is an edit.
    dirtySinceSave = true;
    syncNotes();
    syncSaveButton();
  }

  // ============================================================
  // FILE INTAKE
  // ============================================================
  function takeFiles(files){
    var a = api();
    if(!a || !a.uploadArtwork) return;
    clearError('sb-up-err');
    Array.prototype.slice.call(files).forEach(function(f){
      if(ALLOWED_TYPES.indexOf(f.type) === -1){
        showError('sb-up-err', '"' + f.name + '" is not a PNG, JPG or SVG.');
        return;
      }
      if(f.size > MAX_BYTES){
        showError('sb-up-err', '"' + f.name + '" is larger than 25MB.');
        return;
      }
      $('sb-prog').classList.add('on');
      $('sb-prog-bar').style.width = '5%';
      a.uploadArtwork(f, { onProgress: function(p){ $('sb-prog-bar').style.width = p + '%'; } })
        .then(function(d){
          $('sb-prog').classList.remove('on');
          $('sb-prog-bar').style.width = '0%';
          scheduleElements();
          renderRecent();
          addImage(d.img, d.label);
          closeTool();
        })
        .catch(function(err){
          $('sb-prog').classList.remove('on');
          warn('[ShirtBuilder] upload failed', err);
          showError('sb-up-err', 'That upload did not go through. Please try again.');
        });
    });
  }

  function runAI(){
    var a = api();
    if(!a || !a.fetchAIImages) return;
    var prompt = $('sb-ai-prompt').value.trim();
    if(!prompt){ showError('sb-ai-err', 'Please describe what you want first.'); return; }
    clearError('sb-ai-err');
    var btn = $('sb-ai-go');
    btn.disabled = true;
    btn.innerHTML = '<span class="sb-spinner"></span> Generating…';
    a.fetchAIImages(prompt).then(function(images){
      btn.disabled = false;
      btn.textContent = 'Generate';
      var list = images || [];
      // Held for the viewer, which pages through the same set. Stored as
      // plain {url,label} so nothing downstream depends on the shape the
      // endpoint happened to return.
      aiResults = list.map(function(im){
        return { url: im.url || im, thumb: im.thumbnailUrl || im.url || im, label: prompt };
      });
      $('sb-ai-grid').innerHTML = list.length
        ? aiResults.map(function(im, i){
            return '<button type="button" class="sb-card" data-sb="use-ai" data-url="' + esc(im.url) + '" ' +
                   'data-idx="' + i + '" ' +
                   'data-label="' + esc(im.label) + '"><img src="' + esc(im.thumb) + '" ' +
                   'alt=""></button>';
          }).join('')
        : '<div class="sb-empty">No images came back. Try describing it a different way.</div>';
    }).catch(function(err){
      btn.disabled = false;
      btn.textContent = 'Generate';
      warn('[ShirtBuilder] AI failed', err);
      showError('sb-ai-err', (err && err.message) || 'Generation failed. Please try again.');
    });
  }

  // ── One AI result, large (phones) ──────────────────────────────────
  // Three results across a phone screen are three thumbnails nobody can
  // judge, and a tap used to drop one straight onto the shirt. On a phone
  // a tap opens it here instead, big enough to look at, with the other
  // results a swipe of the arrows away. Desktop keeps the direct tap: the
  // grid there is already large enough to choose from, and a confirm step
  // would be friction for nothing.
  var aiResults = [];
  var aiViewIdx = 0;

  function openAiView(idx){
    if(!aiResults.length) return;
    aiViewIdx = clamp(idx | 0, 0, aiResults.length - 1);
    paintAiView();
    $('sb-aiview-ov').classList.add('open');
    syncSubViewport();
  }

  function closeAiView(){
    $('sb-aiview-ov').classList.remove('open');
    syncSubViewport();
  }

  function paintAiView(){
    var im = aiResults[aiViewIdx];
    if(!im) return;
    // The full-size address, not the thumbnail the grid shows — the whole
    // point of this dialog is to see the picture properly.
    $('sb-aiview-img').src = im.url;
    var title = $('sb-aiview-title');
    if(title){
      title.textContent = aiResults.length > 1
        ? 'Image ' + (aiViewIdx + 1) + ' of ' + aiResults.length
        : 'Generated image';
    }
    // Nowhere to go with one result, so the arrows go away rather than
    // sitting there dead.
    var solo = aiResults.length < 2;
    $('sb-aiview-prev').hidden = solo;
    $('sb-aiview-next').hidden = solo;
  }

  function stepAiView(delta){
    if(aiResults.length < 2) return;
    // Wraps: with three images, "next" from the last one going nowhere is
    // a dead end for no reason.
    aiViewIdx = (aiViewIdx + delta + aiResults.length) % aiResults.length;
    paintAiView();
  }

  // Both routes to placing an AI image end here, so the history write and
  // the placement cannot diverge between them.
  function useAiImage(url, label){
    if(!url) return;
    // An AI pick has never been through an upload, so this is where it
    // joins the shopper's history — same as the quick flow does on
    // confirm. Placing it does not wait on that round trip.
    var bridge = api();
    if(bridge && bridge.registerArtwork){
      bridge.registerArtwork({ url: url, label: label, source: 'ai' });
    }
    addImage(url, label);
    closeAiView();
    closeTool();
  }

  // ============================================================
  // WIRING
  // ============================================================
  // One delegated handler for every button, matching the pattern the
  // custom-design modal already uses: no inline handlers, and markup
  // rendered at runtime needs no re-binding.
  document.addEventListener('click', function(e){
    if(sizesOpen || builderBusy) return;
    if(!isOpen && !(e.target.closest && e.target.closest('#sb-ov'))) return;
    if(!e.target.closest) return;
    // A floating menu has to close on any click that is not the trigger
    // or the menu itself — including clicks on the canvas. The one
    // exception is the click that opened the canvas menu in the first
    // place, which arrives here immediately after fabric's mouseup.
    var opening = canvasMenuJustOpened;
    canvasMenuJustOpened = false;
    if(!opening && !e.target.closest('[data-sb="obj-menu"], .sb-submenu')) closeSubmenus();
    // A click on the canvas that is not the layer control dismisses it.
    if(!opening && e.target.closest('.canvas-container') && !e.target.closest('.sb-submenu')) closeCanvasMenu();
    var el = e.target.closest('[data-sb]');
    if(!el) return;
    var act = el.getAttribute('data-sb');

    switch(act){
      case 'close':
      case 'cancel':        requestExit('cancel'); break;
      // NOT an exit any more: the sizes step opens over the builder and
      // hands control straight back, so there is nothing to warn about.
      case 'next':          publishListing(); break;
      case 'exit-save':     saveThenExit(); break;
      case 'exit-discard':  runExit(exitIntent); break;
      case 'close-exit':
        if(el === e.target || el.classList.contains('sb-sub-x')) closeExitDialog();
        break;
      case 'tool':          openTool(el.getAttribute('data-tool')); break;
      case 'sheet-toggle':
        if(gripSwallowClick) gripSwallowClick = false;   // the drag already moved it
        else toggleSheet();
        break;
      case 'sheet-open':    openSheet(el.getAttribute('data-panel'), 'peek'); break;
      case 'close-add':
        // Backdrop, the corner x, or the dialog's own Cancel.
        if(el === e.target || el.classList.contains('sb-sub-x') || el.classList.contains('sb-btn')) closeTool();
        break;
      case 'pick-file':     $('sb-file').click(); break;
      case 'ai-go':         runAI(); break;
      case 'add-text':
        var s = $('sb-new-text').value.trim();
        if(s){ addText(s); $('sb-new-text').value = ''; closeTool(); }
        break;
      case 'forget':
        // Taking an image out of the list. The file is untouched -- a
        // published product still prints from it, so what the seller is
        // removing is the shortcut rather than the artwork.
        var forgetUrl = el.getAttribute('data-url');
        var forgetBridge = api();
        if(forgetBridge && forgetBridge.forgetRecentDesign) forgetBridge.forgetRecentDesign(forgetUrl);
        break;
      case 'use':
        var useUrl = el.getAttribute('data-url');
        // Using a piece of artwork moves it to the front of the shared
        // history, so the next visit to Recent Artwork — here or in the
        // quick flow — offers it first. The modal owns that list; the
        // builder only renders a copy of it.
        var useBridge = api();
        if(useBridge && useBridge.touchArtwork) useBridge.touchArtwork(useUrl);
        addImage(useUrl, el.getAttribute('data-label'));
        $('sb-all-ov').classList.remove('open'); closeTool(); break;
      case 'use-ai':
        // Phone: look at it first. Desktop: place it, as before.
        if(isMobile()){
          openAiView(parseInt(el.getAttribute('data-idx'), 10) || 0);
        } else {
          useAiImage(el.getAttribute('data-url'), el.getAttribute('data-label'));
        }
        break;
      case 'aiview-step':   stepAiView(parseInt(el.getAttribute('data-step'), 10) || 0); break;
      case 'aiview-use':
        var chosen = aiResults[aiViewIdx];
        if(chosen) useAiImage(chosen.url, chosen.label);
        break;
      case 'close-aiview':
        if(el === e.target || el.classList.contains('sb-sub-x') ||
           el.classList.contains('sb-btn')) closeAiView();
        break;
      case 'see-all':       openAll(); break;
      case 'see-saved':     openSavedDesigns(); break;
      case 'change-color':  openColorPicker(); break;
      case 'pick-color':    pickColor(el.getAttribute('data-key')); break;
      case 'close-color':
        if(el === e.target || el.classList.contains('sb-sub-x') || el.classList.contains('sb-btn')) closeColorPicker();
        break;
      case 'close-saved':
        if(el === e.target || el.classList.contains('sb-sub-x') || el.classList.contains('sb-btn')) closeSavedDesigns();
        break;
      case 'notes':         openNotes(); break;
      case 'notes-remove':  setNotes(''); break;
      case 'close-notes':
        if(el === e.target || el.classList.contains('sb-sub-x') || el.classList.contains('sb-btn')) closeNotes();
        break;
      case 'save-notes':
        setNotes($('sb-notes-ta').value.trim());
        closeNotes();
        break;
      case 'back-quick':    requestExit('back'); break;
      case 'bg-toggle':     toggleBackgroundRemoval(); break;
      case 'rename-open':   openRename(); break;
      case 'saved-signin':  goSignIn('browse'); break;
      case 'signin-save':   goSignIn('save'); break;
      case 'close-signin':
        if(el === e.target || el.classList.contains('sb-sub-x') || el.classList.contains('sb-btn')) closeSignInToSave();
        break;
      case 'load-saved':    loadSavedDesign(el.getAttribute('data-guid')); break;
      case 'delete-saved':
        // Nested inside the card, and closest() resolves to the innermost
        // [data-sb] — so this wins over load-saved without any stopping.
        askDeleteSaved(el.getAttribute('data-guid'), el.getAttribute('data-name'));
        break;
      case 'confirm-delsaved': deleteSavedDesign(); break;
      case 'close-delsaved':
        if(el === e.target || el.classList.contains('sb-sub-x') || el.classList.contains('sb-btn')) closeDeleteSaved();
        break;
      case 'save-design':   saveDesign(); break;
      case 'save-name':     submitName(); break;
      case 'close-name':
        if(el === e.target || el.classList.contains('sb-sub-x') || el.classList.contains('sb-btn')) closeNameDialog();
        break;
      case 'pick-el':       pickElement(parseInt(el.getAttribute('data-i'), 10) || 0); break;
      case 'obj-prev':      cycleElement(-1); break;
      case 'obj-next':      cycleElement(1); break;
      case 'close-all':     if(el === e.target) $('sb-all-ov').classList.remove('open'); break;
      case 'view':          showView(parseInt(el.getAttribute('data-i'), 10) || 0); break;
      case 'swap-views':    swapViews(); break;
      case 'undo':          undo(); break;
      case 'redo':          redo(); break;
      case 'reset':         askStartOver(); break;
      case 'confirm-reset': closeStartOver(); startOver(); break;
      case 'close-reset':
        if(el === e.target || el.classList.contains('sb-sub-x') || el.classList.contains('sb-btn')) closeStartOver();
        break;
      case 'deselect':      showPanel('add'); break;

      case 'obj-center':    objCenter(); break;
      case 'obj-menu':
        var panel = el.closest('.sb-panel');
        var wanted = el.getAttribute('data-menu');
        var already = el.classList.contains('open');
        openSubmenu(panel, already ? null : wanted);
        break;
      // Layering stays open so repeated steps do not need a re-open;
      // syncSubmenus() disables whichever direction has run out.
      case 'obj-forward':   objLayer('forward'); break;
      case 'obj-backward':  objLayer('backward'); break;
      case 'obj-flip-h':    objFlip('h'); closeSubmenus(); break;
      case 'obj-flip-v':    objFlip('v'); closeSubmenus(); break;
      case 'obj-dupe':      objDupe(); break;
      case 'obj-replace':   pickReplacement(); break;
      case 'obj-delete':    objDelete(); break;

      case 't-align':
        setText({ textAlign: el.getAttribute('data-v') });
        break;
      case 't-font-open':   swatchTarget === 'font'   ? closeSwatches() : openSwatches('font'); break;
      case 't-fill-open':   swatchTarget === 'fill'   ? closeSwatches() : openSwatches('fill'); break;
      case 't-stroke-open': swatchTarget === 'stroke' ? closeSwatches() : openSwatches('stroke'); break;
      case 't-font':
        var fi = parseInt(el.getAttribute('data-i'), 10) || 0;
        var f = FONTS[fi];
        // A face picked from the full list may not have been fetched yet.
        loadFontFamilies([f.google]);
        // Promote before the await: the grid should show the choice even if
        // the face itself is slow to arrive.
        if(promoteFont(fi)) renderFonts();
        whenFamilyUsable(f.css).then(function(){
          setText({ fontFamily: f.css });
          closeSwatches();
          closeFontPicker();
        });
        break;
      case 'open-fonts':    openFontPicker(); break;
      case 'close-fonts':
        if(el === e.target || el.classList.contains('sb-sub-x') || el.classList.contains('sb-btn')) closeFontPicker();
        break;
      case 'swatch':
        var swKind = swatchTarget;
        var hex = el.getAttribute('data-hex') || null;
        closeSwatches();
        applySwatch(swKind, hex);
        break;
      case 'swatch-custom':
        openColorMixer(swatchTarget === 'stroke' ? 'stroke' : 'fill');
        break;
      case 'close-mix':
        if(el === e.target || el.classList.contains('sb-sub-x') ||
           el.classList.contains('sb-btn')) closeColorMixer();
        break;
      case 'use-mix':        applyMixedColor(); break;

    }
  });

  function setText(props){
    var o = active();
    if(!o || o.type !== 'sb-text') return;
    o.set(props);
    // Anything that changes glyph layout has to invalidate the cached
    // measurements, or the box keeps the old width and the arc is drawn
    // against a stale line length.
    // Thickness is proportional, so a font-size change has to recompute it.
    if('fontSize' in props && !('strokeWidth' in props) && o.stroke){
      o.set('strokeWidth', strokeWidthFor(o));
    }
    if('fontFamily' in props || 'fontSize' in props || 'charSpacing' in props ||
       'text' in props || 'arc' in props){
      o.initDimensions();
      o.setCoords();
      sbDiagLog('setText:' + Object.keys(props).join(','), o);
    }
    o.dirty = true;
    // Collapsed: a slider drag calls this on every tick. One row per
    // settled state says how the text ended up, which is the thing worth
    // knowing; a row per tick says only that a slider exists.
    trackSettled('builder-text-settled', function(){
      var cur = active();
      return (cur && cur.type === 'sb-text')
        ? Object.assign({ changed: Object.keys(props) }, logElement(cur) || {})
        : null;
    });
    canvas().renderAll();
    syncPanel();
    scheduleElements();
    capture();
  }

  // Sliders and their number twins stay in lockstep; both write straight
  // through to the object so the canvas updates as the handle moves.
  // How much extra finger travel the zero detent absorbs, in screen
  // pixels. Converted to each control's own units per event, so arc and
  // spacing feel the same under the finger despite spanning 720 and 900.
  var DETENT_PX = 4;

  // A detent at zero, for the sliders that cross it. Arc spans 720 units
  // across a few hundred pixels, so "no arc" is a sub-pixel target.
  //
  // NOT a window that maps everything nearby to zero — that was the first
  // attempt, and it made the values either side of zero unreachable: the
  // slider jumped to zero and then came out the far side a dozen numbers
  // later. This holds AT zero for a few pixels of extra travel and then
  // carries on from 1, because the travel the detent absorbed becomes an
  // offset applied to the rest of the drag. Every value stays settable in
  // both directions; zero just costs a little more travel to leave.
  function zeroDetent(){
    // lastOut starts as null, not 0: the first event of a drag has nothing
    // to have crossed, and treating an unknown previous value as zero made
    // every drag engage the detent on its first move — grabbing the slider
    // at 30 sent it straight to zero, which is the very thing this is
    // supposed to stop doing.
    var offset = 0, stuck = false, anchor = 0, lastOut = null;
    return {
      // raw: where the slider says it is. width: the detent, in units.
      read: function(raw, width){
        var out = raw - offset;
        if(stuck){
          if(Math.abs(raw - anchor) <= width) return 0;
          // Out the far side. The offset is what gives the absorbed travel
          // back, so the next number reported is 1 and not width + 1.
          offset = anchor + (raw > anchor ? width : -width);
          stuck = false;
          lastOut = raw - offset;
          return lastOut;
        }
        // Landing on zero, or stepping across it in one event.
        if(out === 0 || (lastOut !== null && (lastOut > 0) !== (out > 0))){
          stuck = true; anchor = raw; offset = raw; lastOut = 0;
          return 0;
        }
        lastOut = out;
        return out;
      },
      // A finished drag, or a typed value: the thumb and the number agree
      // again, so whatever offset the last drag accumulated is dropped.
      reset: function(){ offset = 0; stuck = false; lastOut = null; }
    };
  }

  // detent: true for a control whose scale crosses zero. Typing in the
  // number box never detents — 3 has to mean 3.
  function bindPair(rangeId, numId, apply, detent){
    var d = detent ? zeroDetent() : null;
    function run(e){
      var raw = parseFloat(e.target.value);
      if(!isFinite(raw)) return;
      var fromRange = e.target.id === rangeId;
      var val = raw;
      if(d && fromRange){
        var el = $(rangeId);
        var step = parseFloat(el.step) || 1;
        var span = Math.abs(parseFloat(el.max) - parseFloat(el.min)) || 1;
        var track = el.offsetWidth || 1;
        // Rounded to the control's own step, and never below one step: an
        // offset of 8.6 would put the whole scale between the numbers,
        // and a detent narrower than a step could never engage at all.
        var width = Math.max(step, Math.round(DETENT_PX * span / track / step) * step);
        val = d.read(raw, width);
        // The thumb follows the number it reported. That is what makes the
        // hold visible: the finger keeps going and the slider does not.
        el.value = val;
      } else if(d){
        d.reset();
      }
      var other = fromRange ? $(numId) : $(rangeId);
      other.value = val;
      paintRange($(rangeId));
      apply(val);
    }
    on($(rangeId), 'input', run);
    on($(numId), 'input', run);
    // Fires when a drag ends, so the next one starts from a clean mapping.
    if(d) on($(rangeId), 'change', function(){ d.reset(); });
  }

  // Grows the AI prompt box to fit what is in it, to a limit. Three rows
  // is enough to start typing in but not enough to edit a finished prompt,
  // which is the part that was awkward. Capped so a long one scrolls
  // instead of pushing the Generate button out of the rail.
  var PROMPT_MAX_H = 190;
  function growPrompt(el){
    if(!el) return;
    el.style.height = 'auto';
    el.style.height = Math.min(el.scrollHeight, PROMPT_MAX_H) + 'px';
  }

  function bindAll(){
    // The picker's two surfaces. Not bindPair: that pair drives a property
    // on the selected object as it moves, and these drive nothing until
    // "Use This Color" is pressed — the design must not change colour
    // behind an open dialog.
    bindMixSurface($('sb-mix-sv'), function(x, y){
      mixHsv.s = x;
      mixHsv.v = 1 - y;
    });
    bindMixSurface($('sb-mix-hue'), function(x, y){
      mixHsv.h = y * 360;
    });
    bindMixKeys();
    on($('sb-ai-prompt'), 'input', function(e){ growPrompt(e.target); });
    bindPair('sb-t-size', 'sb-t-size-n', function(v){ setText({ fontSize: clamp(v, 8, 400) }); });
    // The two controls whose scale crosses zero, so zero is a value worth
    // being able to land on. Size, outline and rotation never cross it and
    // stay linear. The detent width comes from the control itself.
    bindPair('sb-t-arc',  'sb-t-arc-n',  function(v){ setText({ arc: clamp(v, -360, 360) }); }, true);
    bindPair('sb-t-spc',  'sb-t-spc-n',  function(v){ setText({ charSpacing: v }); }, true);
    bindPair('sb-t-ow',   'sb-t-ow-n',   function(v){
      var o = active();
      if(!o || o.type !== 'sb-text') return;
      o.sbStrokePct = clamp(v, 0.5, 20);
      setText({ strokeWidth: strokeWidthFor(o) });
    });
    bindPair('sb-t-rot',  'sb-t-rot-n',  function(v){
      var o = active(); if(!o) return;
      o.rotate(v % 360); o.setCoords(); canvas().renderAll(); capture();
    });
    bindPair('sb-i-rot',  'sb-i-rot-n',  function(v){
      var o = active(); if(!o) return;
      o.rotate((((v % 360) + 360) % 360));
      o.setCoords(); canvas().renderAll(); capture();
    });
    // Size is not a 1:1 pair — the slider carries a log position and the
    // box carries a plain percentage — so the two are bound separately
    // rather than through bindPair.
    on($('sb-i-size'), 'input', function(e){
      var pos = parseFloat(e.target.value);
      if(!isFinite(pos)) return;
      paintRange(e.target);
      applySizeFactor(sizePosToFactor(pos));
    });
    on($('sb-i-size-n'), 'input', function(e){
      var pct = parseFloat(e.target.value);
      if(!isFinite(pct) || pct <= 0) return;
      applySizeFactor(pct / 100);
      paintRange($('sb-i-size'));
    });

    on($('sb-t-text'), 'input', function(e){ setText({ text: e.target.value }); });
    on($('sb-font-search'), 'input', function(e){ renderFontGrid(e.target.value); });
    // Enter commits, Escape abandons, and clicking away commits too — the
    // same shape as every other rename field people have used.
    on($('sb-namebar-inp'), 'keydown', function(e){
      if(e.key === 'Enter'){ e.preventDefault(); commitRename(); }
      else if(e.key === 'Escape'){ e.preventDefault(); e.stopPropagation(); closeRename(); }
    });
    on($('sb-namebar-inp'), 'blur', function(){ commitRename(); });
    on($('sb-file'), 'change', function(e){
      takeFiles(e.target.files);
      e.target.value = '';   // re-selecting the same file must still fire
    });

    var dz = $('sb-drop');
    on(dz, 'dragover', function(e){ e.preventDefault(); dz.classList.add('over'); });
    on(dz, 'dragleave', function(){ dz.classList.remove('over'); });
    on(dz, 'drop', function(e){
      e.preventDefault();
      dz.classList.remove('over');
      takeFiles(e.dataTransfer.files);
    });
    on(dz, 'keydown', function(e){
      if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); $('sb-file').click(); }
    });

    bindSheetDrag();
    // Crossing the breakpoint — a rotation, or a desktop window being
    // dragged narrow — leaves the sheet mid-animation with an inline
    // transform that means nothing in the other layout. Reset it.
    if(mobileQuery){
      var onBreakpoint = function(){ setSheet('closed'); };
      if(mobileQuery.addEventListener) mobileQuery.addEventListener('change', onBreakpoint);
      else if(mobileQuery.addListener) mobileQuery.addListener(onBreakpoint);
    }

    renderFonts();
    renderAllSwatches();
    Array.prototype.forEach.call(document.querySelectorAll('.sb-range'), paintRange);
  }

  // Debounced so a drag-resize of the window does not re-fit on every
  // one of the dozens of events it fires.
  var resizeTimer = null;
  window.addEventListener('resize', function(){
    if(!isOpen) return;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fitStage, 120);
  });

  // Measuring the stage once, on open, is not enough: the header wraps to
  // two lines for a long product name, the footer's proof notice reflows,
  // a webfont lands, the rail gains a scrollbar — each changes the stage's
  // height after the first measurement, leaving the garment fitted to a
  // size the stage no longer is. Watching the element keeps it filling
  // whatever space it actually has.
  var stageRO = null;
  var refitQueued = false;
  function watchStage(){
    var main = $('sb-stage-main');
    if(stageRO || !window.ResizeObserver || !main) return;
    stageRO = new ResizeObserver(function(){
      if(!isOpen || refitQueued) return;
      // Coalesce to one fit per frame. Resizing .sb-wrap cannot feed back
      // into the observed element's size — it is a flex:1 child of a
      // fixed-height column — but a frame gate keeps that guarantee cheap.
      refitQueued = true;
      window.requestAnimationFrame(function(){
        refitQueued = false;
        if(isOpen) fitStage();
      });
    });
    stageRO.observe(main);
  }
  function unwatchStage(){
    if(!stageRO) return;
    try { stageRO.disconnect(); } catch(e){}
    stageRO = null;
  }

  document.addEventListener('keydown', function(e){
    if(!isOpen || sizesOpen) return;
    if(builderBusy) return;
    var typing = /^(INPUT|TEXTAREA)$/.test((e.target && e.target.tagName) || '');
    if(e.key === 'Enter' && $('sb-name-ov').classList.contains('open') &&
       e.target && e.target.id === 'sb-name-inp'){
      e.preventDefault();
      submitName();
      return;
    }
    if(e.key === 'Escape'){
      if($('sb-reset-ov').classList.contains('open')){ closeStartOver(); return; }
      if($('sb-notes-ov').classList.contains('open')){ closeNotes(); return; }
      if($('sb-delsaved-ov').classList.contains('open')){ closeDeleteSaved(); return; }
      if($('sb-signin-ov').classList.contains('open')){ closeSignInToSave(); return; }
      if($('sb-font-ov').classList.contains('open')){ closeFontPicker(); return; }
      if($('sb-exit-ov').classList.contains('open')){ closeExitDialog(); return; }
      if($('sb-name-ov').classList.contains('open')){ closeNameDialog(); return; }
      if(document.querySelector('#sb-rail .sb-submenu.open')){ closeSubmenus(); return; }
      if($('sb-add-ov').classList.contains('open')){ closeTool(); return; }
      if($('sb-all-ov').classList.contains('open')){ $('sb-all-ov').classList.remove('open'); return; }
      if(active()){ showPanel('add'); return; }
      requestExit('cancel');
      return;
    }
    if(typing) return;
    var arrow = ARROWS[e.key];
    if(arrow && active()){
      // Claimed before the page can scroll with it.
      e.preventDefault();
      nudge(arrow[0], arrow[1], e.shiftKey);
      return;
    }
    if((e.key === 'Delete' || e.key === 'Backspace') && active()){ e.preventDefault(); objDelete(); }
    if((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'z'){
      e.preventDefault();
      e.shiftKey ? redo() : undo();
    }
  });

  // Claim the modal's cancelable invitation. preventDefault() is what
  // tells it the builder exists; without this snippet on the page the
  // modal falls back to its own "not ready yet" message.
  // ═════════════════════════════════════════════════════════
  // THE CCS EXTENSION POINT
  // ═════════════════════════════════════════════════════════
  // A CCS listing is one design across several colors; this builder is one
  // design on one garment. The host bridges the two by driving this builder
  // once per color -- see assets/ccs-builder-host.js -- and these are the
  // handles it needs to do that. Nothing here is new behaviour: every one of
  // them is an existing internal, exposed.
  //
  //   open(detail)  resolves when the garment and scene are on screen, so the
  //                 host can swap colors and know when the swap landed
  //   document()    the scene the builder is holding right now, which the host
  //                 stores against the color before moving off it
  //   prepare()     export + upload every designed side. This is the storefront
  //                 add-to-cart pipeline untouched: artwork cropped to the
  //                 print area, the scene, and a composited preview, all three
  //                 through the host's own uploadArtwork
  //   hasArtwork()  whether this color has anything on it
  //   busy()        the builder's own progress overlay, so publishing looks
  //                 like part of the builder rather than a second spinner
  //   close()       teardown, once the listing is published
  window.CCSBuilder = {
    open: openBuilder,
    close: closeBuilder,
    document: designDocument,
    hasArtwork: hasArtwork,
    prepare: prepareSides,
    busy: setBusy,
    // Which side is on screen, and a way to put a side on screen. Stepping
    // from color to color has to stay on the side the seller is looking at --
    // dropping back to the front every time is the opposite of a review tool.
    side: function(){ var v = view(); return v && v.id; },
    showSide: function(id){
      for(var i = 0; i < views.length; i++){
        if(views[i].id === id){ showView(i); return true; }
      }
      return false;
    },
    // Whether an element is selected. The arrow keys nudge a selection when
    // there is one, so the host may only claim them when there is not.
    hasSelection: function(){ return !!active(); },
    /*
     * Borrow Add Images to choose an image for something other than the
     * canvas -- the feature photo. claim(url, label) is called with whatever
     * the seller picks, uploads or generates, and the panel closes itself.
     */
    pickImage: function(claim){
      ccsPick = claim;
      openTool('images');
    },
    // Redraw the recent-images grids from whatever the host now holds.
    refreshRecent: function(){
      renderRecent();
      if($('sb-all-ov').classList.contains('open')) openAll();
    }
  };

  document.addEventListener('sib:open-shirt-builder', function(e){
    if(!$('sb-ov')) return;
    e.preventDefault();
    openBuilder(e.detail || {});
  });

  bindAll();

  // The bridge is defined by the sibling snippet; wait a tick so a restore
  // triggered on load does not race its definition.
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(resumeAfterLogin, 0); });
  } else {
    setTimeout(resumeAfterLogin, 0);
  }
})();
